function generateRandom(e = 0, t = 100) {
  var t = t - e,
    n = Math.random(),
    n = Math.floor(n * t);
  return (n += e);
}

function convertKilogramsToPounds(e) {
  return 2.2 * e;
}

function convertPoundsToKilograms(e) {
  return 0.453592 * e;
}

function convertFtToCm(e, t) {
  return 30.48 * e + 2.54 * t;
}

function convertCmToMeter(e) {
  return parseFloat((e / 100).toFixed(5));
}

function getMonthName(e) {
  return [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ][e];
}

function convertOzToLiters(e) {
  return 0.029574 * e;
}

function quizInputFocus(e) {
  e = $('[data-step="' + e + '"]');
  $('input[type="number"]', e).each(function (e, t) {
    var t = $(t),
      n = t.closest('.quiz-size-fields');
    if ((console.log(t), 'none' !== n.css('display'))) return t.focus(), !1;
  });
}

function numberInRange(e, t, n) {
  return t <= e && e <= n;
}
!(function (e, t) {
  'use strict';
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (e.document) return t(e);
            throw new Error('jQuery requires a window with a document');
          })
    : t(e);
})('undefined' != typeof window ? window : this, function (x, L) {
  'use strict';

  function y(e) {
    return (
      'function' == typeof e &&
      'number' != typeof e.nodeType &&
      'function' != typeof e.item
    );
  }

  function R(e) {
    return null != e && e === e.window;
  }
  var t = [],
    z = Object.getPrototypeOf,
    a = t.slice,
    M = t.flat
      ? function (e) {
          return t.flat.call(e);
        }
      : function (e) {
          return t.concat.apply([], e);
        },
    q = t.push,
    _ = t.indexOf,
    H = {},
    F = H.toString,
    W = H.hasOwnProperty,
    B = W.toString,
    Q = B.call(Object),
    g = {},
    C = x.document,
    U = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0,
    };

  function V(e, t, n) {
    var i,
      o,
      r = (n = n || C).createElement('script');
    if (((r.text = e), t))
      for (i in U)
        (o = t[i] || (t.getAttribute && t.getAttribute(i))) &&
          r.setAttribute(i, o);
    n.head.appendChild(r).parentNode.removeChild(r);
  }

  function X(e) {
    return null == e
      ? e + ''
      : 'object' == typeof e || 'function' == typeof e
      ? H[F.call(e)] || 'object'
      : typeof e;
  }
  var e = '3.7.0',
    Y = /HTML$/i,
    T = function (e, t) {
      return new T.fn.init(e, t);
    };

  function K(e) {
    var t = !!e && 'length' in e && e.length,
      n = X(e);
    return (
      !y(e) &&
      !R(e) &&
      ('array' === n ||
        0 === t ||
        ('number' == typeof t && 0 < t && t - 1 in e))
    );
  }

  function b(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  (T.fn = T.prototype =
    {
      jquery: e,
      constructor: T,
      length: 0,
      toArray: function () {
        return a.call(this);
      },
      get: function (e) {
        return null == e
          ? a.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        e = T.merge(this.constructor(), e);
        return (e.prevObject = this), e;
      },
      each: function (e) {
        return T.each(this, e);
      },
      map: function (n) {
        return this.pushStack(
          T.map(this, function (e, t) {
            return n.call(e, t, e);
          })
        );
      },
      slice: function () {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          T.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          T.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          e = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= e && e < t ? [this[e]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: q,
      sort: t.sort,
      splice: t.splice,
    }),
    (T.extend = T.fn.extend =
      function () {
        var e,
          t,
          n,
          i,
          o,
          r = arguments[0] || {},
          s = 1,
          a = arguments.length,
          l = !1;
        for (
          'boolean' == typeof r && ((l = r), (r = arguments[s] || {}), s++),
            'object' == typeof r || y(r) || (r = {}),
            s === a && ((r = this), s--);
          s < a;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (n = e[t]),
                '__proto__' !== t &&
                  r !== n &&
                  (l && n && (T.isPlainObject(n) || (i = Array.isArray(n)))
                    ? ((o = r[t]),
                      (o =
                        i && !Array.isArray(o)
                          ? []
                          : i || T.isPlainObject(o)
                          ? o
                          : {}),
                      (i = !1),
                      (r[t] = T.extend(l, o, n)))
                    : void 0 !== n && (r[t] = n));
        return r;
      }),
    T.extend({
      expando: 'jQuery' + (e + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        return !(
          !e ||
          '[object Object]' !== F.call(e) ||
          ((e = z(e)) &&
            ('function' !=
              typeof (e = W.call(e, 'constructor') && e.constructor) ||
              B.call(e) !== Q))
        );
      },
      isEmptyObject: function (e) {
        for (var t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, n) {
        V(
          e,
          {
            nonce: t && t.nonce,
          },
          n
        );
      },
      each: function (e, t) {
        var n,
          i = 0;
        if (K(e))
          for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
        else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
        return e;
      },
      text: function (e) {
        var t,
          n = '',
          i = 0,
          o = e.nodeType;
        if (o) {
          if (1 === o || 9 === o || 11 === o) return e.textContent;
          if (3 === o || 4 === o) return e.nodeValue;
        } else for (; (t = e[i++]); ) n += T.text(t);
        return n;
      },
      makeArray: function (e, t) {
        t = t || [];
        return (
          null != e &&
            (K(Object(e))
              ? T.merge(t, 'string' == typeof e ? [e] : e)
              : q.call(t, e)),
          t
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : _.call(t, e, n);
      },
      isXMLDoc: function (e) {
        var t = e && e.namespaceURI,
          e = e && (e.ownerDocument || e).documentElement;
        return !Y.test(t || (e && e.nodeName) || 'HTML');
      },
      merge: function (e, t) {
        for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
        return (e.length = o), e;
      },
      grep: function (e, t, n) {
        for (var i = [], o = 0, r = e.length, s = !n; o < r; o++)
          !t(e[o], o) != s && i.push(e[o]);
        return i;
      },
      map: function (e, t, n) {
        var i,
          o,
          r = 0,
          s = [];
        if (K(e))
          for (i = e.length; r < i; r++)
            null != (o = t(e[r], r, n)) && s.push(o);
        else for (r in e) null != (o = t(e[r], r, n)) && s.push(o);
        return M(s);
      },
      guid: 1,
      support: g,
    }),
    'function' == typeof Symbol && (T.fn[Symbol.iterator] = t[Symbol.iterator]),
    T.each(
      'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(
        ' '
      ),
      function (e, t) {
        H['[object ' + t + ']'] = t.toLowerCase();
      }
    );
  var J = t.pop,
    G = t.sort,
    Z = t.splice,
    n = '[\\x20\\t\\r\\n\\f]',
    ee = new RegExp('^' + n + '+|((?:^|[^\\\\])(?:\\\\.)*)' + n + '+$', 'g'),
    te =
      ((T.contains = function (e, t) {
        t = t && t.parentNode;
        return (
          e === t ||
          !(
            !t ||
            1 !== t.nodeType ||
            !(e.contains
              ? e.contains(t)
              : e.compareDocumentPosition && 16 & e.compareDocumentPosition(t))
          )
        );
      }),
      /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g);

  function ne(e, t) {
    return t
      ? '\0' === e
        ? '�'
        : e.slice(0, -1) + '\\' + e.charCodeAt(e.length - 1).toString(16) + ' '
      : '\\' + e;
  }
  T.escapeSelector = function (e) {
    return (e + '').replace(te, ne);
  };
  var ie,
    w,
    oe,
    re,
    se,
    E,
    ae,
    S,
    d,
    le,
    i = C,
    ue = q,
    k = ue,
    D = T.expando,
    A = 0,
    ce = 0,
    he = Ne(),
    de = Ne(),
    fe = Ne(),
    pe = Ne(),
    ge = function (e, t) {
      return e === t && (se = !0), 0;
    },
    me =
      'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
    e =
      '(?:\\\\[\\da-fA-F]{1,6}' + n + '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
    o =
      '\\[' +
      n +
      '*(' +
      e +
      ')(?:' +
      n +
      '*([*^$|!~]?=)' +
      n +
      '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
      e +
      '))|)' +
      n +
      '*\\]',
    r =
      ':(' +
      e +
      ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
      o +
      ')*)|.*)\\)|)',
    ve = new RegExp(n + '+', 'g'),
    ye = new RegExp('^' + n + '*,' + n + '*'),
    _e = new RegExp('^' + n + '*([>+~]|' + n + ')' + n + '*'),
    be = new RegExp(n + '|>'),
    we = new RegExp(r),
    xe = new RegExp('^' + e + '$'),
    Ce = {
      ID: new RegExp('^#(' + e + ')'),
      CLASS: new RegExp('^\\.(' + e + ')'),
      TAG: new RegExp('^(' + e + '|[*])'),
      ATTR: new RegExp('^' + o),
      PSEUDO: new RegExp('^' + r),
      CHILD: new RegExp(
        '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
          n +
          '*(even|odd|(([+-]|)(\\d*)n|)' +
          n +
          '*(?:([+-]|)' +
          n +
          '*(\\d+)|))' +
          n +
          '*\\)|)',
        'i'
      ),
      bool: new RegExp('^(?:' + me + ')$', 'i'),
      needsContext: new RegExp(
        '^' +
          n +
          '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
          n +
          '*((?:-\\d)?\\d*)' +
          n +
          '*\\)|)(?=[^-]|$)',
        'i'
      ),
    },
    Te = /^(?:input|select|textarea|button)$/i,
    Ee = /^h\d$/i,
    Se = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
    ke = /[+~]/,
    h = new RegExp('\\\\[\\da-fA-F]{1,6}' + n + '?|\\\\([^\\r\\n\\f])', 'g'),
    f = function (e, t) {
      e = '0x' + e.slice(1) - 65536;
      return (
        t ||
        (e < 0
          ? String.fromCharCode(65536 + e)
          : String.fromCharCode((e >> 10) | 55296, (1023 & e) | 56320))
      );
    },
    De = function () {
      Pe();
    },
    Ae = Me(
      function (e) {
        return !0 === e.disabled && b(e, 'fieldset');
      },
      {
        dir: 'parentNode',
        next: 'legend',
      }
    );
  try {
    k.apply((t = a.call(i.childNodes)), i.childNodes),
      t[i.childNodes.length].nodeType;
  } catch (ie) {
    k = {
      apply: function (e, t) {
        ue.apply(e, a.call(t));
      },
      call: function (e) {
        ue.apply(e, a.call(arguments, 1));
      },
    };
  }

  function N(e, t, n, i) {
    var o,
      r,
      s,
      a,
      l,
      u,
      c = t && t.ownerDocument,
      h = t ? t.nodeType : 9;
    if (
      ((n = n || []),
      'string' != typeof e || !e || (1 !== h && 9 !== h && 11 !== h))
    )
      return n;
    if (!i && (Pe(t), (t = t || E), S)) {
      if (11 !== h && (a = Se.exec(e)))
        if ((o = a[1])) {
          if (9 === h) {
            if (!(u = t.getElementById(o))) return n;
            if (u.id === o) return k.call(n, u), n;
          } else if (
            c &&
            (u = c.getElementById(o)) &&
            N.contains(t, u) &&
            u.id === o
          )
            return k.call(n, u), n;
        } else {
          if (a[2]) return k.apply(n, t.getElementsByTagName(e)), n;
          if ((o = a[3]) && t.getElementsByClassName)
            return k.apply(n, t.getElementsByClassName(o)), n;
        }
      if (!(pe[e + ' '] || (d && d.test(e)))) {
        if (((u = e), (c = t), 1 === h && (be.test(e) || _e.test(e)))) {
          for (
            ((c = (ke.test(e) && Oe(t.parentNode)) || t) == t && g.scope) ||
              ((s = t.getAttribute('id'))
                ? (s = T.escapeSelector(s))
                : t.setAttribute('id', (s = D))),
              r = (l = Re(e)).length;
            r--;

          )
            l[r] = (s ? '#' + s : ':scope') + ' ' + ze(l[r]);
          u = l.join(',');
        }
        try {
          return k.apply(n, c.querySelectorAll(u)), n;
        } catch (t) {
          pe(e, !0);
        } finally {
          s === D && t.removeAttribute('id');
        }
      }
    }
    return Be(e.replace(ee, '$1'), t, n, i);
  }

  function Ne() {
    var i = [];
    return function e(t, n) {
      return (
        i.push(t + ' ') > w.cacheLength && delete e[i.shift()], (e[t + ' '] = n)
      );
    };
  }

  function I(e) {
    return (e[D] = !0), e;
  }

  function Ie(e) {
    var t = E.createElement('fieldset');
    try {
      return !!e(t);
    } catch (e) {
      return !1;
    } finally {
      t.parentNode && t.parentNode.removeChild(t);
    }
  }

  function $e(t) {
    return function (e) {
      return 'form' in e
        ? e.parentNode && !1 === e.disabled
          ? 'label' in e
            ? 'label' in e.parentNode
              ? e.parentNode.disabled === t
              : e.disabled === t
            : e.isDisabled === t || (e.isDisabled !== !t && Ae(e) === t)
          : e.disabled === t
        : 'label' in e && e.disabled === t;
    };
  }

  function je(s) {
    return I(function (r) {
      return (
        (r = +r),
        I(function (e, t) {
          for (var n, i = s([], e.length, r), o = i.length; o--; )
            e[(n = i[o])] && (e[n] = !(t[n] = e[n]));
        })
      );
    });
  }

  function Oe(e) {
    return e && void 0 !== e.getElementsByTagName && e;
  }

  function Pe(e) {
    var e = e ? e.ownerDocument || e : i;
    return (
      e != E &&
        9 === e.nodeType &&
        e.documentElement &&
        ((ae = (E = e).documentElement),
        (S = !T.isXMLDoc(E)),
        (le = ae.matches || ae.webkitMatchesSelector || ae.msMatchesSelector),
        i != E &&
          (e = E.defaultView) &&
          e.top !== e &&
          e.addEventListener('unload', De),
        (g.getById = Ie(function (e) {
          return (
            (ae.appendChild(e).id = T.expando),
            !E.getElementsByName || !E.getElementsByName(T.expando).length
          );
        })),
        (g.disconnectedMatch = Ie(function (e) {
          return le.call(e, '*');
        })),
        (g.scope = Ie(function () {
          return E.querySelectorAll(':scope');
        })),
        (g.cssHas = Ie(function () {
          try {
            return E.querySelector(':has(*,:jqfake)'), 0;
          } catch (e) {
            return 1;
          }
        })),
        g.getById
          ? ((w.filter.ID = function (e) {
              var t = e.replace(h, f);
              return function (e) {
                return e.getAttribute('id') === t;
              };
            }),
            (w.find.ID = function (e, t) {
              if (void 0 !== t.getElementById && S)
                return (t = t.getElementById(e)) ? [t] : [];
            }))
          : ((w.filter.ID = function (e) {
              var t = e.replace(h, f);
              return function (e) {
                e = void 0 !== e.getAttributeNode && e.getAttributeNode('id');
                return e && e.value === t;
              };
            }),
            (w.find.ID = function (e, t) {
              if (void 0 !== t.getElementById && S) {
                var n,
                  i,
                  o,
                  r = t.getElementById(e);
                if (r) {
                  if ((n = r.getAttributeNode('id')) && n.value === e)
                    return [r];
                  for (o = t.getElementsByName(e), i = 0; (r = o[i++]); )
                    if ((n = r.getAttributeNode('id')) && n.value === e)
                      return [r];
                }
                return [];
              }
            })),
        (w.find.TAG = function (e, t) {
          return void 0 !== t.getElementsByTagName
            ? t.getElementsByTagName(e)
            : t.querySelectorAll(e);
        }),
        (w.find.CLASS = function (e, t) {
          if (void 0 !== t.getElementsByClassName && S)
            return t.getElementsByClassName(e);
        }),
        (d = []),
        Ie(function (e) {
          var t;
          (ae.appendChild(e).innerHTML =
            "<a id='" +
            D +
            "' href='' disabled='disabled'></a><select id='" +
            D +
            "-\r\\' disabled='disabled'><option selected=''></option></select>"),
            e.querySelectorAll('[selected]').length ||
              d.push('\\[' + n + '*(?:value|' + me + ')'),
            e.querySelectorAll('[id~=' + D + '-]').length || d.push('~='),
            e.querySelectorAll('a#' + D + '+*').length || d.push('.#.+[+~]'),
            e.querySelectorAll(':checked').length || d.push(':checked'),
            (t = E.createElement('input')).setAttribute('type', 'hidden'),
            e.appendChild(t).setAttribute('name', 'D'),
            (ae.appendChild(e).disabled = !0),
            2 !== e.querySelectorAll(':disabled').length &&
              d.push(':enabled', ':disabled'),
            (t = E.createElement('input')).setAttribute('name', ''),
            e.appendChild(t),
            e.querySelectorAll("[name='']").length ||
              d.push('\\[' + n + '*name' + n + '*=' + n + '*(?:\'\'|"")');
        }),
        g.cssHas || d.push(':has'),
        (d = d.length && new RegExp(d.join('|'))),
        (ge = function (e, t) {
          var n;
          return e === t
            ? ((se = !0), 0)
            : !e.compareDocumentPosition - !t.compareDocumentPosition ||
                (1 &
                  (n =
                    (e.ownerDocument || e) == (t.ownerDocument || t)
                      ? e.compareDocumentPosition(t)
                      : 1) ||
                (!g.sortDetached && t.compareDocumentPosition(e) === n)
                  ? e === E || (e.ownerDocument == i && N.contains(i, e))
                    ? -1
                    : t === E || (t.ownerDocument == i && N.contains(i, t))
                    ? 1
                    : re
                    ? _.call(re, e) - _.call(re, t)
                    : 0
                  : 4 & n
                  ? -1
                  : 1);
        })),
      E
    );
  }
  for (ie in ((N.matches = function (e, t) {
    return N(e, null, null, t);
  }),
  (N.matchesSelector = function (e, t) {
    if ((Pe(e), S && !pe[t + ' '] && (!d || !d.test(t))))
      try {
        var n = le.call(e, t);
        if (
          n ||
          g.disconnectedMatch ||
          (e.document && 11 !== e.document.nodeType)
        )
          return n;
      } catch (e) {
        pe(t, !0);
      }
    return 0 < N(t, E, null, [e]).length;
  }),
  (N.contains = function (e, t) {
    return (e.ownerDocument || e) != E && Pe(e), T.contains(e, t);
  }),
  (N.attr = function (e, t) {
    (e.ownerDocument || e) != E && Pe(e);
    var n = w.attrHandle[t.toLowerCase()],
      n = n && W.call(w.attrHandle, t.toLowerCase()) ? n(e, t, !S) : void 0;
    return void 0 !== n ? n : e.getAttribute(t);
  }),
  (N.error = function (e) {
    throw new Error('Syntax error, unrecognized expression: ' + e);
  }),
  (T.uniqueSort = function (e) {
    var t,
      n = [],
      i = 0,
      o = 0;
    if (
      ((se = !g.sortStable),
      (re = !g.sortStable && a.call(e, 0)),
      G.call(e, ge),
      se)
    ) {
      for (; (t = e[o++]); ) t === e[o] && (i = n.push(o));
      for (; i--; ) Z.call(e, n[i], 1);
    }
    return (re = null), e;
  }),
  (T.fn.uniqueSort = function () {
    return this.pushStack(T.uniqueSort(a.apply(this)));
  }),
  ((w = T.expr =
    {
      cacheLength: 50,
      createPseudo: I,
      match: Ce,
      attrHandle: {},
      find: {},
      relative: {
        '>': {
          dir: 'parentNode',
          first: !0,
        },
        ' ': {
          dir: 'parentNode',
        },
        '+': {
          dir: 'previousSibling',
          first: !0,
        },
        '~': {
          dir: 'previousSibling',
        },
      },
      preFilter: {
        ATTR: function (e) {
          return (
            (e[1] = e[1].replace(h, f)),
            (e[3] = (e[3] || e[4] || e[5] || '').replace(h, f)),
            '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
            e.slice(0, 4)
          );
        },
        CHILD: function (e) {
          return (
            (e[1] = e[1].toLowerCase()),
            'nth' === e[1].slice(0, 3)
              ? (e[3] || N.error(e[0]),
                (e[4] = +(e[4]
                  ? e[5] + (e[6] || 1)
                  : 2 * ('even' === e[3] || 'odd' === e[3]))),
                (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
              : e[3] && N.error(e[0]),
            e
          );
        },
        PSEUDO: function (e) {
          var t,
            n = !e[6] && e[2];
          return Ce.CHILD.test(e[0])
            ? null
            : (e[3]
                ? (e[2] = e[4] || e[5] || '')
                : n &&
                  we.test(n) &&
                  (t =
                    (t = Re(n, !0)) &&
                    n.indexOf(')', n.length - t) - n.length) &&
                  ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
              e.slice(0, 3));
        },
      },
      filter: {
        TAG: function (e) {
          var t = e.replace(h, f).toLowerCase();
          return '*' === e
            ? function () {
                return !0;
              }
            : function (e) {
                return b(e, t);
              };
        },
        CLASS: function (e) {
          var t = he[e + ' '];
          return (
            t ||
            ((t = new RegExp('(^|' + n + ')' + e + '(' + n + '|$)')) &&
              he(e, function (e) {
                return t.test(
                  ('string' == typeof e.className && e.className) ||
                    (void 0 !== e.getAttribute && e.getAttribute('class')) ||
                    ''
                );
              }))
          );
        },
        ATTR: function (t, n, i) {
          return function (e) {
            e = N.attr(e, t);
            return null == e
              ? '!=' === n
              : !n ||
                  ((e += ''),
                  '=' === n
                    ? e === i
                    : '!=' === n
                    ? e !== i
                    : '^=' === n
                    ? i && 0 === e.indexOf(i)
                    : '*=' === n
                    ? i && -1 < e.indexOf(i)
                    : '$=' === n
                    ? i && e.slice(-i.length) === i
                    : '~=' === n
                    ? -1 < (' ' + e.replace(ve, ' ') + ' ').indexOf(i)
                    : '|=' === n &&
                      (e === i || e.slice(0, i.length + 1) === i + '-'));
          };
        },
        CHILD: function (f, e, t, p, g) {
          var m = 'nth' !== f.slice(0, 3),
            v = 'last' !== f.slice(-4),
            y = 'of-type' === e;
          return 1 === p && 0 === g
            ? function (e) {
                return !!e.parentNode;
              }
            : function (e, t, n) {
                var i,
                  o,
                  r,
                  s,
                  a,
                  l = m != v ? 'nextSibling' : 'previousSibling',
                  u = e.parentNode,
                  c = y && e.nodeName.toLowerCase(),
                  h = !n && !y,
                  d = !1;
                if (u) {
                  if (m) {
                    for (; l; ) {
                      for (r = e; (r = r[l]); )
                        if (y ? b(r, c) : 1 === r.nodeType) return !1;
                      a = l = 'only' === f && !a && 'nextSibling';
                    }
                    return !0;
                  }
                  if (((a = [v ? u.firstChild : u.lastChild]), v && h)) {
                    for (
                      d =
                        (s =
                          (i = (o = u[D] || (u[D] = {}))[f] || [])[0] === A &&
                          i[1]) && i[2],
                        r = s && u.childNodes[s];
                      (r = (++s && r && r[l]) || ((d = s = 0), a.pop()));

                    )
                      if (1 === r.nodeType && ++d && r === e) {
                        o[f] = [A, s, d];
                        break;
                      }
                  } else if (
                    !1 ===
                    (d = h
                      ? (s =
                          (i = (o = e[D] || (e[D] = {}))[f] || [])[0] === A &&
                          i[1])
                      : d)
                  )
                    for (
                      ;
                      (r = (++s && r && r[l]) || ((d = s = 0), a.pop())) &&
                      ((y ? !b(r, c) : 1 !== r.nodeType) ||
                        !++d ||
                        (h && ((o = r[D] || (r[D] = {}))[f] = [A, d]),
                        r !== e));

                    );
                  return (d -= g) === p || (d % p == 0 && 0 <= d / p);
                }
              };
        },
        PSEUDO: function (e, r) {
          var t,
            s =
              w.pseudos[e] ||
              w.setFilters[e.toLowerCase()] ||
              N.error('unsupported pseudo: ' + e);
          return s[D]
            ? s(r)
            : 1 < s.length
            ? ((t = [e, e, '', r]),
              w.setFilters.hasOwnProperty(e.toLowerCase())
                ? I(function (e, t) {
                    for (var n, i = s(e, r), o = i.length; o--; )
                      e[(n = _.call(e, i[o]))] = !(t[n] = i[o]);
                  })
                : function (e) {
                    return s(e, 0, t);
                  })
            : s;
        },
      },
      pseudos: {
        not: I(function (e) {
          var i = [],
            o = [],
            a = We(e.replace(ee, '$1'));
          return a[D]
            ? I(function (e, t, n, i) {
                for (var o, r = a(e, null, i, []), s = e.length; s--; )
                  (o = r[s]) && (e[s] = !(t[s] = o));
              })
            : function (e, t, n) {
                return (i[0] = e), a(i, null, n, o), (i[0] = null), !o.pop();
              };
        }),
        has: I(function (t) {
          return function (e) {
            return 0 < N(t, e).length;
          };
        }),
        contains: I(function (t) {
          return (
            (t = t.replace(h, f)),
            function (e) {
              return -1 < (e.textContent || T.text(e)).indexOf(t);
            }
          );
        }),
        lang: I(function (n) {
          return (
            xe.test(n || '') || N.error('unsupported lang: ' + n),
            (n = n.replace(h, f).toLowerCase()),
            function (e) {
              var t;
              do {
                if (
                  (t = S
                    ? e.lang
                    : e.getAttribute('xml:lang') || e.getAttribute('lang'))
                )
                  return (
                    (t = t.toLowerCase()) === n || 0 === t.indexOf(n + '-')
                  );
              } while ((e = e.parentNode) && 1 === e.nodeType);
              return !1;
            }
          );
        }),
        target: function (e) {
          var t = x.location && x.location.hash;
          return t && t.slice(1) === e.id;
        },
        root: function (e) {
          return e === ae;
        },
        focus: function (e) {
          return (
            e ===
              (function () {
                try {
                  return E.activeElement;
                } catch (e) {}
              })() &&
            E.hasFocus() &&
            !!(e.type || e.href || ~e.tabIndex)
          );
        },
        enabled: $e(!1),
        disabled: $e(!0),
        checked: function (e) {
          return (
            (b(e, 'input') && !!e.checked) || (b(e, 'option') && !!e.selected)
          );
        },
        selected: function (e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        },
        empty: function (e) {
          for (e = e.firstChild; e; e = e.nextSibling)
            if (e.nodeType < 6) return !1;
          return !0;
        },
        parent: function (e) {
          return !w.pseudos.empty(e);
        },
        header: function (e) {
          return Ee.test(e.nodeName);
        },
        input: function (e) {
          return Te.test(e.nodeName);
        },
        button: function (e) {
          return (b(e, 'input') && 'button' === e.type) || b(e, 'button');
        },
        text: function (e) {
          return (
            b(e, 'input') &&
            'text' === e.type &&
            (null == (e = e.getAttribute('type')) || 'text' === e.toLowerCase())
          );
        },
        first: je(function () {
          return [0];
        }),
        last: je(function (e, t) {
          return [t - 1];
        }),
        eq: je(function (e, t, n) {
          return [n < 0 ? n + t : n];
        }),
        even: je(function (e, t) {
          for (var n = 0; n < t; n += 2) e.push(n);
          return e;
        }),
        odd: je(function (e, t) {
          for (var n = 1; n < t; n += 2) e.push(n);
          return e;
        }),
        lt: je(function (e, t, n) {
          for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i; ) e.push(i);
          return e;
        }),
        gt: je(function (e, t, n) {
          for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
          return e;
        }),
      },
    }).pseudos.nth = w.pseudos.eq),
  {
    radio: !0,
    checkbox: !0,
    file: !0,
    password: !0,
    image: !0,
  }))
    w.pseudos[ie] = (function (t) {
      return function (e) {
        return b(e, 'input') && e.type === t;
      };
    })(ie);
  for (ie in {
    submit: !0,
    reset: !0,
  })
    w.pseudos[ie] = (function (t) {
      return function (e) {
        return (b(e, 'input') || b(e, 'button')) && e.type === t;
      };
    })(ie);

  function Le() {}

  function Re(e, t) {
    var n,
      i,
      o,
      r,
      s,
      a,
      l,
      u = de[e + ' '];
    if (u) return t ? 0 : u.slice(0);
    for (s = e, a = [], l = w.preFilter; s; ) {
      for (r in ((n && !(i = ye.exec(s))) ||
        (i && (s = s.slice(i[0].length) || s), a.push((o = []))),
      (n = !1),
      (i = _e.exec(s)) &&
        ((n = i.shift()),
        o.push({
          value: n,
          type: i[0].replace(ee, ' '),
        }),
        (s = s.slice(n.length))),
      w.filter))
        !(i = Ce[r].exec(s)) ||
          (l[r] && !(i = l[r](i))) ||
          ((n = i.shift()),
          o.push({
            value: n,
            type: r,
            matches: i,
          }),
          (s = s.slice(n.length)));
      if (!n) break;
    }
    return t ? s.length : s ? N.error(e) : de(e, a).slice(0);
  }

  function ze(e) {
    for (var t = 0, n = e.length, i = ''; t < n; t++) i += e[t].value;
    return i;
  }

  function Me(s, e, t) {
    var a = e.dir,
      l = e.next,
      u = l || a,
      c = t && 'parentNode' === u,
      h = ce++;
    return e.first
      ? function (e, t, n) {
          for (; (e = e[a]); ) if (1 === e.nodeType || c) return s(e, t, n);
          return !1;
        }
      : function (e, t, n) {
          var i,
            o,
            r = [A, h];
          if (n) {
            for (; (e = e[a]); )
              if ((1 === e.nodeType || c) && s(e, t, n)) return !0;
          } else
            for (; (e = e[a]); )
              if (1 === e.nodeType || c)
                if (((o = e[D] || (e[D] = {})), l && b(e, l))) e = e[a] || e;
                else {
                  if ((i = o[u]) && i[0] === A && i[1] === h)
                    return (r[2] = i[2]);
                  if (((o[u] = r)[2] = s(e, t, n))) return !0;
                }
          return !1;
        };
  }

  function qe(o) {
    return 1 < o.length
      ? function (e, t, n) {
          for (var i = o.length; i--; ) if (!o[i](e, t, n)) return !1;
          return !0;
        }
      : o[0];
  }

  function He(e, t, n, i, o) {
    for (var r, s = [], a = 0, l = e.length, u = null != t; a < l; a++)
      !(r = e[a]) || (n && !n(r, i, o)) || (s.push(r), u && t.push(a));
    return s;
  }

  function Fe(e) {
    for (
      var i,
        t,
        n,
        o = e.length,
        r = w.relative[e[0].type],
        s = r || w.relative[' '],
        a = r ? 1 : 0,
        l = Me(
          function (e) {
            return e === i;
          },
          s,
          !0
        ),
        u = Me(
          function (e) {
            return -1 < _.call(i, e);
          },
          s,
          !0
        ),
        c = [
          function (e, t, n) {
            e = (!r && (n || t != oe)) || ((i = t).nodeType ? l : u)(e, t, n);
            return (i = null), e;
          },
        ];
      a < o;
      a++
    )
      if ((t = w.relative[e[a].type])) c = [Me(qe(c), t)];
      else {
        if ((t = w.filter[e[a].type].apply(null, e[a].matches))[D]) {
          for (n = ++a; n < o && !w.relative[e[n].type]; n++);
          return (function e(f, p, g, m, v, t) {
            return (
              m && !m[D] && (m = e(m)),
              v && !v[D] && (v = e(v, t)),
              I(function (e, t, n, i) {
                var o,
                  r,
                  s,
                  a,
                  l = [],
                  u = [],
                  c = t.length,
                  h =
                    e ||
                    (function (e, t, n) {
                      for (var i = 0, o = t.length; i < o; i++) N(e, t[i], n);
                      return n;
                    })(p || '*', n.nodeType ? [n] : n, []),
                  d = !f || (!e && p) ? h : He(h, l, f, n, i);
                if (
                  (g
                    ? g(d, (a = v || (e ? f : c || m) ? [] : t), n, i)
                    : (a = d),
                  m)
                )
                  for (o = He(a, u), m(o, [], n, i), r = o.length; r--; )
                    (s = o[r]) && (a[u[r]] = !(d[u[r]] = s));
                if (e) {
                  if (v || f) {
                    if (v) {
                      for (o = [], r = a.length; r--; )
                        (s = a[r]) && o.push((d[r] = s));
                      v(null, (a = []), o, i);
                    }
                    for (r = a.length; r--; )
                      (s = a[r]) &&
                        -1 < (o = v ? _.call(e, s) : l[r]) &&
                        (e[o] = !(t[o] = s));
                  }
                } else (a = He(a === t ? a.splice(c, a.length) : a)), v ? v(null, t, a, i) : k.apply(t, a);
              })
            );
          })(
            1 < a && qe(c),
            1 < a &&
              ze(
                e.slice(0, a - 1).concat({
                  value: ' ' === e[a - 2].type ? '*' : '',
                })
              ).replace(ee, '$1'),
            t,
            a < n && Fe(e.slice(a, n)),
            n < o && Fe((e = e.slice(n))),
            n < o && ze(e)
          );
        }
        c.push(t);
      }
    return qe(c);
  }

  function We(e, t) {
    var n,
      m,
      v,
      y,
      _,
      i,
      o = [],
      r = [],
      s = fe[e + ' '];
    if (!s) {
      for (n = (t = t || Re(e)).length; n--; )
        ((s = Fe(t[n]))[D] ? o : r).push(s);
      (s = fe(
        e,
        ((y = 0 < (v = o).length),
        (_ = 0 < (m = r).length),
        (i = function (e, t, n, i, o) {
          var r,
            s,
            a,
            l = 0,
            u = '0',
            c = e && [],
            h = [],
            d = oe,
            f = e || (_ && w.find.TAG('*', o)),
            p = (A += null == d ? 1 : Math.random() || 0.1),
            g = f.length;
          for (
            o && (oe = t == E || t || o);
            u !== g && null != (r = f[u]);
            u++
          ) {
            if (_ && r) {
              for (
                s = 0, t || r.ownerDocument == E || (Pe(r), (n = !S));
                (a = m[s++]);

              )
                if (a(r, t || E, n)) {
                  k.call(i, r);
                  break;
                }
              o && (A = p);
            }
            y && ((r = !a && r) && l--, e) && c.push(r);
          }
          if (((l += u), y && u !== l)) {
            for (s = 0; (a = v[s++]); ) a(c, h, t, n);
            if (e) {
              if (0 < l) for (; u--; ) c[u] || h[u] || (h[u] = J.call(i));
              h = He(h);
            }
            k.apply(i, h),
              o && !e && 0 < h.length && 1 < l + v.length && T.uniqueSort(i);
          }
          return o && ((A = p), (oe = d)), c;
        }),
        y ? I(i) : i)
      )).selector = e;
    }
    return s;
  }

  function Be(e, t, n, i) {
    var o,
      r,
      s,
      a,
      l,
      u = 'function' == typeof e && e,
      c = !i && Re((e = u.selector || e));
    if (((n = n || []), 1 === c.length)) {
      if (
        2 < (r = c[0] = c[0].slice(0)).length &&
        'ID' === (s = r[0]).type &&
        9 === t.nodeType &&
        S &&
        w.relative[r[1].type]
      ) {
        if (!(t = (w.find.ID(s.matches[0].replace(h, f), t) || [])[0]))
          return n;
        u && (t = t.parentNode), (e = e.slice(r.shift().value.length));
      }
      for (
        o = Ce.needsContext.test(e) ? 0 : r.length;
        o-- && ((s = r[o]), !w.relative[(a = s.type)]);

      )
        if (
          (l = w.find[a]) &&
          (i = l(
            s.matches[0].replace(h, f),
            (ke.test(r[0].type) && Oe(t.parentNode)) || t
          ))
        ) {
          if ((r.splice(o, 1), (e = i.length && ze(r)))) break;
          return k.apply(n, i), n;
        }
    }
    return (
      (u || We(e, c))(i, t, !S, n, !t || (ke.test(e) && Oe(t.parentNode)) || t),
      n
    );
  }
  (Le.prototype = w.filters = w.pseudos),
    (w.setFilters = new Le()),
    (g.sortStable = D.split('').sort(ge).join('') === D),
    Pe(),
    (g.sortDetached = Ie(function (e) {
      return 1 & e.compareDocumentPosition(E.createElement('fieldset'));
    })),
    (T.find = N),
    (T.expr[':'] = T.expr.pseudos),
    (T.unique = T.uniqueSort),
    (N.compile = We),
    (N.select = Be),
    (N.setDocument = Pe),
    (N.escape = T.escapeSelector),
    (N.getText = T.text),
    (N.isXML = T.isXMLDoc),
    (N.selectors = T.expr),
    (N.support = T.support),
    (N.uniqueSort = T.uniqueSort);

  function Qe(e, t, n) {
    for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
      if (1 === e.nodeType) {
        if (o && T(e).is(n)) break;
        i.push(e);
      }
    return i;
  }

  function Ue(e, t) {
    for (var n = []; e; e = e.nextSibling)
      1 === e.nodeType && e !== t && n.push(e);
    return n;
  }
  var Ve = T.expr.match.needsContext,
    Xe = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

  function Ye(e, n, i) {
    return y(n)
      ? T.grep(e, function (e, t) {
          return !!n.call(e, t, e) !== i;
        })
      : n.nodeType
      ? T.grep(e, function (e) {
          return (e === n) !== i;
        })
      : 'string' != typeof n
      ? T.grep(e, function (e) {
          return -1 < _.call(n, e) !== i;
        })
      : T.filter(n, e, i);
  }
  (T.filter = function (e, t, n) {
    var i = t[0];
    return (
      n && (e = ':not(' + e + ')'),
      1 === t.length && 1 === i.nodeType
        ? T.find.matchesSelector(i, e)
          ? [i]
          : []
        : T.find.matches(
            e,
            T.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    T.fn.extend({
      find: function (e) {
        var t,
          n,
          i = this.length,
          o = this;
        if ('string' != typeof e)
          return this.pushStack(
            T(e).filter(function () {
              for (t = 0; t < i; t++) if (T.contains(o[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < i; t++) T.find(e, o[t], n);
        return 1 < i ? T.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(Ye(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(Ye(this, e || [], !0));
      },
      is: function (e) {
        return !!Ye(
          this,
          'string' == typeof e && Ve.test(e) ? T(e) : e || [],
          !1
        ).length;
      },
    });
  var Ke,
    Je = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
    Ge =
      (((T.fn.init = function (e, t, n) {
        if (e) {
          if (((n = n || Ke), 'string' != typeof e))
            return e.nodeType
              ? ((this[0] = e), (this.length = 1), this)
              : y(e)
              ? void 0 !== n.ready
                ? n.ready(e)
                : e(T)
              : T.makeArray(e, this);
          if (
            !(i =
              '<' === e[0] && '>' === e[e.length - 1] && 3 <= e.length
                ? [null, e, null]
                : Je.exec(e)) ||
            (!i[1] && t)
          )
            return (!t || t.jquery ? t || n : this.constructor(t)).find(e);
          if (i[1]) {
            if (
              ((t = t instanceof T ? t[0] : t),
              T.merge(
                this,
                T.parseHTML(
                  i[1],
                  t && t.nodeType ? t.ownerDocument || t : C,
                  !0
                )
              ),
              Xe.test(i[1]) && T.isPlainObject(t))
            )
              for (var i in t) y(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
          } else
            (n = C.getElementById(i[2])) && ((this[0] = n), (this.length = 1));
        }
        return this;
      }).prototype = T.fn),
      (Ke = T(C)),
      /^(?:parents|prev(?:Until|All))/),
    Ze = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0,
    };

  function et(e, t) {
    for (; (e = e[t]) && 1 !== e.nodeType; );
    return e;
  }
  T.fn.extend({
    has: function (e) {
      var t = T(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (T.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        i = 0,
        o = this.length,
        r = [],
        s = 'string' != typeof e && T(e);
      if (!Ve.test(e))
        for (; i < o; i++)
          for (n = this[i]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (s
                ? -1 < s.index(n)
                : 1 === n.nodeType && T.find.matchesSelector(n, e))
            ) {
              r.push(n);
              break;
            }
      return this.pushStack(1 < r.length ? T.uniqueSort(r) : r);
    },
    index: function (e) {
      return e
        ? 'string' == typeof e
          ? _.call(T(e), this[0])
          : _.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(T.uniqueSort(T.merge(this.get(), T(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    T.each(
      {
        parent: function (e) {
          e = e.parentNode;
          return e && 11 !== e.nodeType ? e : null;
        },
        parents: function (e) {
          return Qe(e, 'parentNode');
        },
        parentsUntil: function (e, t, n) {
          return Qe(e, 'parentNode', n);
        },
        next: function (e) {
          return et(e, 'nextSibling');
        },
        prev: function (e) {
          return et(e, 'previousSibling');
        },
        nextAll: function (e) {
          return Qe(e, 'nextSibling');
        },
        prevAll: function (e) {
          return Qe(e, 'previousSibling');
        },
        nextUntil: function (e, t, n) {
          return Qe(e, 'nextSibling', n);
        },
        prevUntil: function (e, t, n) {
          return Qe(e, 'previousSibling', n);
        },
        siblings: function (e) {
          return Ue((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return Ue(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && z(e.contentDocument)
            ? e.contentDocument
            : (b(e, 'template') && (e = e.content || e),
              T.merge([], e.childNodes));
        },
      },
      function (i, o) {
        T.fn[i] = function (e, t) {
          var n = T.map(this, o, e);
          return (
            (t = 'Until' !== i.slice(-5) ? e : t) &&
              'string' == typeof t &&
              (n = T.filter(t, n)),
            1 < this.length &&
              (Ze[i] || T.uniqueSort(n), Ge.test(i)) &&
              n.reverse(),
            this.pushStack(n)
          );
        };
      }
    );
  var $ = /[^\x20\t\r\n\f]+/g;

  function tt(e) {
    return e;
  }

  function nt(e) {
    throw e;
  }

  function it(e, t, n, i) {
    var o;
    try {
      e && y((o = e.promise))
        ? o.call(e).done(t).fail(n)
        : e && y((o = e.then))
        ? o.call(e, t, n)
        : t.apply(void 0, [e].slice(i));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  (T.Callbacks = function (i) {
    var e, n;
    i =
      'string' == typeof i
        ? ((e = i),
          (n = {}),
          T.each(e.match($) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : T.extend({}, i);

    function o() {
      for (a = a || i.once, s = r = !0; u.length; c = -1)
        for (t = u.shift(); ++c < l.length; )
          !1 === l[c].apply(t[0], t[1]) &&
            i.stopOnFalse &&
            ((c = l.length), (t = !1));
      i.memory || (t = !1), (r = !1), a && (l = t ? [] : '');
    }
    var r,
      t,
      s,
      a,
      l = [],
      u = [],
      c = -1,
      h = {
        add: function () {
          return (
            l &&
              (t && !r && ((c = l.length - 1), u.push(t)),
              (function n(e) {
                T.each(e, function (e, t) {
                  y(t)
                    ? (i.unique && h.has(t)) || l.push(t)
                    : t && t.length && 'string' !== X(t) && n(t);
                });
              })(arguments),
              t) &&
              !r &&
              o(),
            this
          );
        },
        remove: function () {
          return (
            T.each(arguments, function (e, t) {
              for (var n; -1 < (n = T.inArray(t, l, n)); )
                l.splice(n, 1), n <= c && c--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < T.inArray(e, l) : 0 < l.length;
        },
        empty: function () {
          return (l = l && []), this;
        },
        disable: function () {
          return (a = u = []), (l = t = ''), this;
        },
        disabled: function () {
          return !l;
        },
        lock: function () {
          return (a = u = []), t || r || (l = t = ''), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return (
            a ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]), u.push(t), r) ||
              o(),
            this
          );
        },
        fire: function () {
          return h.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!s;
        },
      };
    return h;
  }),
    T.extend({
      Deferred: function (e) {
        var r = [
            [
              'notify',
              'progress',
              T.Callbacks('memory'),
              T.Callbacks('memory'),
              2,
            ],
            [
              'resolve',
              'done',
              T.Callbacks('once memory'),
              T.Callbacks('once memory'),
              0,
              'resolved',
            ],
            [
              'reject',
              'fail',
              T.Callbacks('once memory'),
              T.Callbacks('once memory'),
              1,
              'rejected',
            ],
          ],
          o = 'pending',
          s = {
            state: function () {
              return o;
            },
            always: function () {
              return a.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return s.then(null, e);
            },
            pipe: function () {
              var o = arguments;
              return T.Deferred(function (i) {
                T.each(r, function (e, t) {
                  var n = y(o[t[4]]) && o[t[4]];
                  a[t[1]](function () {
                    var e = n && n.apply(this, arguments);
                    e && y(e.promise)
                      ? e
                          .promise()
                          .progress(i.notify)
                          .done(i.resolve)
                          .fail(i.reject)
                      : i[t[0] + 'With'](this, n ? [e] : arguments);
                  });
                }),
                  (o = null);
              }).promise();
            },
            then: function (t, n, i) {
              var l = 0;

              function u(o, r, s, a) {
                return function () {
                  function e() {
                    var e, t;
                    if (!(o < l)) {
                      if ((e = s.apply(n, i)) === r.promise())
                        throw new TypeError('Thenable self-resolution');
                      (t =
                        e &&
                        ('object' == typeof e || 'function' == typeof e) &&
                        e.then),
                        y(t)
                          ? a
                            ? t.call(e, u(l, r, tt, a), u(l, r, nt, a))
                            : (l++,
                              t.call(
                                e,
                                u(l, r, tt, a),
                                u(l, r, nt, a),
                                u(l, r, tt, r.notifyWith)
                              ))
                          : (s !== tt && ((n = void 0), (i = [e])),
                            (a || r.resolveWith)(n, i));
                    }
                  }
                  var n = this,
                    i = arguments,
                    t = a
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            T.Deferred.exceptionHook &&
                              T.Deferred.exceptionHook(e, t.error),
                              l <= o + 1 &&
                                (s !== nt && ((n = void 0), (i = [e])),
                                r.rejectWith(n, i));
                          }
                        };
                  o
                    ? t()
                    : (T.Deferred.getErrorHook
                        ? (t.error = T.Deferred.getErrorHook())
                        : T.Deferred.getStackHook &&
                          (t.error = T.Deferred.getStackHook()),
                      x.setTimeout(t));
                };
              }
              return T.Deferred(function (e) {
                r[0][3].add(u(0, e, y(i) ? i : tt, e.notifyWith)),
                  r[1][3].add(u(0, e, y(t) ? t : tt)),
                  r[2][3].add(u(0, e, y(n) ? n : nt));
              }).promise();
            },
            promise: function (e) {
              return null != e ? T.extend(e, s) : s;
            },
          },
          a = {};
        return (
          T.each(r, function (e, t) {
            var n = t[2],
              i = t[5];
            (s[t[1]] = n.add),
              i &&
                n.add(
                  function () {
                    o = i;
                  },
                  r[3 - e][2].disable,
                  r[3 - e][3].disable,
                  r[0][2].lock,
                  r[0][3].lock
                ),
              n.add(t[3].fire),
              (a[t[0]] = function () {
                return (
                  a[t[0] + 'With'](this === a ? void 0 : this, arguments), this
                );
              }),
              (a[t[0] + 'With'] = n.fireWith);
          }),
          s.promise(a),
          e && e.call(a, a),
          a
        );
      },
      when: function (e) {
        function t(t) {
          return function (e) {
            (o[t] = this),
              (r[t] = 1 < arguments.length ? a.call(arguments) : e),
              --n || s.resolveWith(o, r);
          };
        }
        var n = arguments.length,
          i = n,
          o = Array(i),
          r = a.call(arguments),
          s = T.Deferred();
        if (
          n <= 1 &&
          (it(e, s.done(t(i)).resolve, s.reject, !n),
          'pending' === s.state() || y(r[i] && r[i].then))
        )
          return s.then();
        for (; i--; ) it(r[i], t(i), s.reject);
        return s.promise();
      },
    });
  var ot = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/,
    rt =
      ((T.Deferred.exceptionHook = function (e, t) {
        x.console &&
          x.console.warn &&
          e &&
          ot.test(e.name) &&
          x.console.warn('jQuery.Deferred exception: ' + e.message, e.stack, t);
      }),
      (T.readyException = function (e) {
        x.setTimeout(function () {
          throw e;
        });
      }),
      T.Deferred());

  function st() {
    C.removeEventListener('DOMContentLoaded', st),
      x.removeEventListener('load', st),
      T.ready();
  }
  (T.fn.ready = function (e) {
    return (
      rt.then(e).catch(function (e) {
        T.readyException(e);
      }),
      this
    );
  }),
    T.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --T.readyWait : T.isReady) ||
          ((T.isReady = !0) !== e && 0 < --T.readyWait) ||
          rt.resolveWith(C, [T]);
      },
    }),
    (T.ready.then = rt.then),
    'complete' === C.readyState ||
    ('loading' !== C.readyState && !C.documentElement.doScroll)
      ? x.setTimeout(T.ready)
      : (C.addEventListener('DOMContentLoaded', st),
        x.addEventListener('load', st));

  function c(e, t, n, i, o, r, s) {
    var a = 0,
      l = e.length,
      u = null == n;
    if ('object' === X(n)) for (a in ((o = !0), n)) c(e, t, a, n[a], !0, r, s);
    else if (
      void 0 !== i &&
      ((o = !0),
      y(i) || (s = !0),
      (t = u
        ? s
          ? (t.call(e, i), null)
          : ((u = t),
            function (e, t, n) {
              return u.call(T(e), n);
            })
        : t))
    )
      for (; a < l; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
    return o ? e : u ? t.call(e) : l ? t(e[0], n) : r;
  }
  var at = /^-ms-/,
    lt = /-([a-z])/g;

  function ut(e, t) {
    return t.toUpperCase();
  }

  function j(e) {
    return e.replace(at, 'ms-').replace(lt, ut);
  }

  function ct(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  }

  function ht() {
    this.expando = T.expando + ht.uid++;
  }
  (ht.uid = 1),
    (ht.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            ct(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var i,
          o = this.cache(e);
        if ('string' == typeof t) o[j(t)] = n;
        else for (i in t) o[j(i)] = t[i];
        return o;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][j(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && 'string' == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          i = e[this.expando];
        if (void 0 !== i) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(j)
              : (t = j(t)) in i
              ? [t]
              : t.match($) || []).length;
            for (; n--; ) delete i[t[n]];
          }
          (void 0 !== t && !T.isEmptyObject(i)) ||
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        e = e[this.expando];
        return void 0 !== e && !T.isEmptyObject(e);
      },
    });
  var v = new ht(),
    l = new ht(),
    dt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    ft = /[A-Z]/g;

  function pt(e, t, n) {
    var i, o;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((i = 'data-' + t.replace(ft, '-$&').toLowerCase()),
        'string' == typeof (n = e.getAttribute(i)))
      ) {
        try {
          n =
            'true' === (o = n) ||
            ('false' !== o &&
              ('null' === o
                ? null
                : o === +o + ''
                ? +o
                : dt.test(o)
                ? JSON.parse(o)
                : o));
        } catch (e) {}
        l.set(e, t, n);
      } else n = void 0;
    return n;
  }
  T.extend({
    hasData: function (e) {
      return l.hasData(e) || v.hasData(e);
    },
    data: function (e, t, n) {
      return l.access(e, t, n);
    },
    removeData: function (e, t) {
      l.remove(e, t);
    },
    _data: function (e, t, n) {
      return v.access(e, t, n);
    },
    _removeData: function (e, t) {
      v.remove(e, t);
    },
  }),
    T.fn.extend({
      data: function (n, e) {
        var t,
          i,
          o,
          r = this[0],
          s = r && r.attributes;
        if (void 0 !== n)
          return 'object' == typeof n
            ? this.each(function () {
                l.set(this, n);
              })
            : c(
                this,
                function (e) {
                  var t;
                  if (r && void 0 === e)
                    return void 0 !== (t = l.get(r, n)) ||
                      void 0 !== (t = pt(r, n))
                      ? t
                      : void 0;
                  this.each(function () {
                    l.set(this, n, e);
                  });
                },
                null,
                e,
                1 < arguments.length,
                null,
                !0
              );
        if (
          this.length &&
          ((o = l.get(r)), 1 === r.nodeType) &&
          !v.get(r, 'hasDataAttrs')
        ) {
          for (t = s.length; t--; )
            s[t] &&
              0 === (i = s[t].name).indexOf('data-') &&
              ((i = j(i.slice(5))), pt(r, i, o[i]));
          v.set(r, 'hasDataAttrs', !0);
        }
        return o;
      },
      removeData: function (e) {
        return this.each(function () {
          l.remove(this, e);
        });
      },
    }),
    T.extend({
      queue: function (e, t, n) {
        var i;
        if (e)
          return (
            (i = v.get(e, (t = (t || 'fx') + 'queue'))),
            n &&
              (!i || Array.isArray(n)
                ? (i = v.access(e, t, T.makeArray(n)))
                : i.push(n)),
            i || []
          );
      },
      dequeue: function (e, t) {
        t = t || 'fx';
        var n = T.queue(e, t),
          i = n.length,
          o = n.shift(),
          r = T._queueHooks(e, t);
        'inprogress' === o && ((o = n.shift()), i--),
          o &&
            ('fx' === t && n.unshift('inprogress'),
            delete r.stop,
            o.call(
              e,
              function () {
                T.dequeue(e, t);
              },
              r
            )),
          !i && r && r.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + 'queueHooks';
        return (
          v.get(e, n) ||
          v.access(e, n, {
            empty: T.Callbacks('once memory').add(function () {
              v.remove(e, [t + 'queue', n]);
            }),
          })
        );
      },
    }),
    T.fn.extend({
      queue: function (t, n) {
        var e = 2;
        return (
          'string' != typeof t && ((n = t), (t = 'fx'), e--),
          arguments.length < e
            ? T.queue(this[0], t)
            : void 0 === n
            ? this
            : this.each(function () {
                var e = T.queue(this, t, n);
                T._queueHooks(this, t),
                  'fx' === t && 'inprogress' !== e[0] && T.dequeue(this, t);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          T.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || 'fx', []);
      },
      promise: function (e, t) {
        function n() {
          --o || r.resolveWith(s, [s]);
        }
        var i,
          o = 1,
          r = T.Deferred(),
          s = this,
          a = this.length;
        for (
          'string' != typeof e && ((t = e), (e = void 0)), e = e || 'fx';
          a--;

        )
          (i = v.get(s[a], e + 'queueHooks')) &&
            i.empty &&
            (o++, i.empty.add(n));
        return n(), r.promise(t);
      },
    });

  function gt(e, t) {
    return (
      'none' === (e = t || e).style.display ||
      ('' === e.style.display && yt(e) && 'none' === T.css(e, 'display'))
    );
  }
  var e = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    mt = new RegExp('^(?:([+-])=|)(' + e + ')([a-z%]*)$', 'i'),
    p = ['Top', 'Right', 'Bottom', 'Left'],
    vt = C.documentElement,
    yt = function (e) {
      return T.contains(e.ownerDocument, e);
    },
    _t = {
      composed: !0,
    };
  vt.getRootNode &&
    (yt = function (e) {
      return (
        T.contains(e.ownerDocument, e) || e.getRootNode(_t) === e.ownerDocument
      );
    });

  function bt(e, t, n, i) {
    var o,
      r,
      s = 20,
      a = i
        ? function () {
            return i.cur();
          }
        : function () {
            return T.css(e, t, '');
          },
      l = a(),
      u = (n && n[3]) || (T.cssNumber[t] ? '' : 'px'),
      c =
        e.nodeType &&
        (T.cssNumber[t] || ('px' !== u && +l)) &&
        mt.exec(T.css(e, t));
    if (c && c[3] !== u) {
      for (u = u || c[3], c = +(l /= 2) || 1; s--; )
        T.style(e, t, c + u),
          (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0),
          (c /= r);
      T.style(e, t, (c *= 2) + u), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +l || 0), (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), i) &&
        ((i.unit = u), (i.start = c), (i.end = o)),
      o
    );
  }
  var wt = {};

  function xt(e, t) {
    for (var n, i, o, r, s, a, l = [], u = 0, c = e.length; u < c; u++)
      (i = e[u]).style &&
        ((n = i.style.display),
        t
          ? ('none' === n &&
              ((l[u] = v.get(i, 'display') || null),
              l[u] || (i.style.display = '')),
            '' === i.style.display &&
              gt(i) &&
              (l[u] =
                ((a = r = o = void 0),
                (r = i.ownerDocument),
                (s = i.nodeName),
                (a = wt[s]) ||
                  ((o = r.body.appendChild(r.createElement(s))),
                  (a = T.css(o, 'display')),
                  o.parentNode.removeChild(o),
                  (wt[s] = a = 'none' === a ? 'block' : a)))))
          : 'none' !== n && ((l[u] = 'none'), v.set(i, 'display', n)));
    for (u = 0; u < c; u++) null != l[u] && (e[u].style.display = l[u]);
    return e;
  }
  T.fn.extend({
    show: function () {
      return xt(this, !0);
    },
    hide: function () {
      return xt(this);
    },
    toggle: function (e) {
      return 'boolean' == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            gt(this) ? T(this).show() : T(this).hide();
          });
    },
  });
  var Ct = /^(?:checkbox|radio)$/i,
    Tt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    Et = /^$|^module$|\/(?:java|ecma)script/i,
    o = C.createDocumentFragment().appendChild(C.createElement('div')),
    m =
      ((r = C.createElement('input')).setAttribute('type', 'radio'),
      r.setAttribute('checked', 'checked'),
      r.setAttribute('name', 't'),
      o.appendChild(r),
      (g.checkClone = o.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (o.innerHTML = '<textarea>x</textarea>'),
      (g.noCloneChecked = !!o.cloneNode(!0).lastChild.defaultValue),
      (o.innerHTML = '<option></option>'),
      (g.option = !!o.lastChild),
      {
        thead: [1, '<table>', '</table>'],
        col: [2, '<table><colgroup>', '</colgroup></table>'],
        tr: [2, '<table><tbody>', '</tbody></table>'],
        td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
        _default: [0, '', ''],
      });

  function O(e, t) {
    var n =
      void 0 !== e.getElementsByTagName
        ? e.getElementsByTagName(t || '*')
        : void 0 !== e.querySelectorAll
        ? e.querySelectorAll(t || '*')
        : [];
    return void 0 === t || (t && b(e, t)) ? T.merge([e], n) : n;
  }

  function St(e, t) {
    for (var n = 0, i = e.length; n < i; n++)
      v.set(e[n], 'globalEval', !t || v.get(t[n], 'globalEval'));
  }
  (m.tbody = m.tfoot = m.colgroup = m.caption = m.thead),
    (m.th = m.td),
    g.option ||
      (m.optgroup = m.option =
        [1, "<select multiple='multiple'>", '</select>']);
  var kt = /<|&#?\w+;/;

  function Dt(e, t, n, i, o) {
    for (
      var r,
        s,
        a,
        l,
        u,
        c = t.createDocumentFragment(),
        h = [],
        d = 0,
        f = e.length;
      d < f;
      d++
    )
      if ((r = e[d]) || 0 === r)
        if ('object' === X(r)) T.merge(h, r.nodeType ? [r] : r);
        else if (kt.test(r)) {
          for (
            s = s || c.appendChild(t.createElement('div')),
              a = (Tt.exec(r) || ['', ''])[1].toLowerCase(),
              a = m[a] || m._default,
              s.innerHTML = a[1] + T.htmlPrefilter(r) + a[2],
              u = a[0];
            u--;

          )
            s = s.lastChild;
          T.merge(h, s.childNodes), ((s = c.firstChild).textContent = '');
        } else h.push(t.createTextNode(r));
    for (c.textContent = '', d = 0; (r = h[d++]); )
      if (i && -1 < T.inArray(r, i)) o && o.push(r);
      else if (
        ((l = yt(r)), (s = O(c.appendChild(r), 'script')), l && St(s), n)
      )
        for (u = 0; (r = s[u++]); ) Et.test(r.type || '') && n.push(r);
    return c;
  }
  var At = /^([^.]*)(?:\.(.+)|)/;

  function Nt() {
    return !0;
  }

  function It() {
    return !1;
  }

  function $t(e, t, n, i, o, r) {
    var s, a;
    if ('object' == typeof t) {
      for (a in ('string' != typeof n && ((i = i || n), (n = void 0)), t))
        $t(e, a, n, i, t[a], r);
      return e;
    }
    if (
      (null == i && null == o
        ? ((o = n), (i = n = void 0))
        : null == o &&
          ('string' == typeof n
            ? ((o = i), (i = void 0))
            : ((o = i), (i = n), (n = void 0))),
      !1 === o)
    )
      o = It;
    else if (!o) return e;
    return (
      1 === r &&
        ((s = o),
        ((o = function (e) {
          return T().off(e), s.apply(this, arguments);
        }).guid = s.guid || (s.guid = T.guid++))),
      e.each(function () {
        T.event.add(this, t, o, i, n);
      })
    );
  }

  function jt(e, i, t) {
    t
      ? (v.set(e, i, !1),
        T.event.add(e, i, {
          namespace: !1,
          handler: function (e) {
            var t,
              n = v.get(this, i);
            if (1 & e.isTrigger && this[i]) {
              if (n)
                (T.event.special[i] || {}).delegateType && e.stopPropagation();
              else if (
                ((n = a.call(arguments)),
                v.set(this, i, n),
                this[i](),
                (t = v.get(this, i)),
                v.set(this, i, !1),
                n !== t)
              )
                return e.stopImmediatePropagation(), e.preventDefault(), t;
            } else
              n &&
                (v.set(this, i, T.event.trigger(n[0], n.slice(1), this)),
                e.stopPropagation(),
                (e.isImmediatePropagationStopped = Nt));
          },
        }))
      : void 0 === v.get(e, i) && T.event.add(e, i, Nt);
  }
  (T.event = {
    global: {},
    add: function (t, e, n, i, o) {
      var r,
        s,
        a,
        l,
        u,
        c,
        h,
        d,
        f,
        p = v.get(t);
      if (ct(t))
        for (
          n.handler && ((n = (r = n).handler), (o = r.selector)),
            o && T.find.matchesSelector(vt, o),
            n.guid || (n.guid = T.guid++),
            a = (a = p.events) || (p.events = Object.create(null)),
            s =
              (s = p.handle) ||
              (p.handle = function (e) {
                return void 0 !== T && T.event.triggered !== e.type
                  ? T.event.dispatch.apply(t, arguments)
                  : void 0;
              }),
            l = (e = (e || '').match($) || ['']).length;
          l--;

        )
          (h = f = (d = At.exec(e[l]) || [])[1]),
            (d = (d[2] || '').split('.').sort()),
            h &&
              ((u = T.event.special[h] || {}),
              (h = (o ? u.delegateType : u.bindType) || h),
              (u = T.event.special[h] || {}),
              (f = T.extend(
                {
                  type: h,
                  origType: f,
                  data: i,
                  handler: n,
                  guid: n.guid,
                  selector: o,
                  needsContext: o && T.expr.match.needsContext.test(o),
                  namespace: d.join('.'),
                },
                r
              )),
              (c = a[h]) ||
                (((c = a[h] = []).delegateCount = 0),
                u.setup && !1 !== u.setup.call(t, i, d, s)) ||
                (t.addEventListener && t.addEventListener(h, s)),
              u.add &&
                (u.add.call(t, f), f.handler.guid || (f.handler.guid = n.guid)),
              o ? c.splice(c.delegateCount++, 0, f) : c.push(f),
              (T.event.global[h] = !0));
    },
    remove: function (e, t, n, i, o) {
      var r,
        s,
        a,
        l,
        u,
        c,
        h,
        d,
        f,
        p,
        g,
        m = v.hasData(e) && v.get(e);
      if (m && (l = m.events)) {
        for (u = (t = (t || '').match($) || ['']).length; u--; )
          if (
            ((f = g = (a = At.exec(t[u]) || [])[1]),
            (p = (a[2] || '').split('.').sort()),
            f)
          ) {
            for (
              h = T.event.special[f] || {},
                d = l[(f = (i ? h.delegateType : h.bindType) || f)] || [],
                a =
                  a[2] &&
                  new RegExp('(^|\\.)' + p.join('\\.(?:.*\\.|)') + '(\\.|$)'),
                s = r = d.length;
              r--;

            )
              (c = d[r]),
                (!o && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (a && !a.test(c.namespace)) ||
                  (i && i !== c.selector && ('**' !== i || !c.selector)) ||
                  (d.splice(r, 1),
                  c.selector && d.delegateCount--,
                  h.remove && h.remove.call(e, c));
            s &&
              !d.length &&
              ((h.teardown && !1 !== h.teardown.call(e, p, m.handle)) ||
                T.removeEvent(e, f, m.handle),
              delete l[f]);
          } else for (f in l) T.event.remove(e, f + t[u], n, i, !0);
        T.isEmptyObject(l) && v.remove(e, 'handle events');
      }
    },
    dispatch: function (e) {
      var t,
        n,
        i,
        o,
        r,
        s = new Array(arguments.length),
        a = T.event.fix(e),
        e = (v.get(this, 'events') || Object.create(null))[a.type] || [],
        l = T.event.special[a.type] || {};
      for (s[0] = a, t = 1; t < arguments.length; t++) s[t] = arguments[t];
      if (
        ((a.delegateTarget = this),
        !l.preDispatch || !1 !== l.preDispatch.call(this, a))
      ) {
        for (
          r = T.event.handlers.call(this, a, e), t = 0;
          (i = r[t++]) && !a.isPropagationStopped();

        )
          for (
            a.currentTarget = i.elem, n = 0;
            (o = i.handlers[n++]) && !a.isImmediatePropagationStopped();

          )
            (a.rnamespace &&
              !1 !== o.namespace &&
              !a.rnamespace.test(o.namespace)) ||
              ((a.handleObj = o),
              (a.data = o.data),
              void 0 !==
                (o = (
                  (T.event.special[o.origType] || {}).handle || o.handler
                ).apply(i.elem, s)) &&
                !1 === (a.result = o) &&
                (a.preventDefault(), a.stopPropagation()));
        return l.postDispatch && l.postDispatch.call(this, a), a.result;
      }
    },
    handlers: function (e, t) {
      var n,
        i,
        o,
        r,
        s,
        a = [],
        l = t.delegateCount,
        u = e.target;
      if (l && u.nodeType && !('click' === e.type && 1 <= e.button))
        for (; u !== this; u = u.parentNode || this)
          if (1 === u.nodeType && ('click' !== e.type || !0 !== u.disabled)) {
            for (r = [], s = {}, n = 0; n < l; n++)
              void 0 === s[(o = (i = t[n]).selector + ' ')] &&
                (s[o] = i.needsContext
                  ? -1 < T(o, this).index(u)
                  : T.find(o, this, null, [u]).length),
                s[o] && r.push(i);
            r.length &&
              a.push({
                elem: u,
                handlers: r,
              });
          }
      return (
        (u = this),
        l < t.length &&
          a.push({
            elem: u,
            handlers: t.slice(l),
          }),
        a
      );
    },
    addProp: function (t, e) {
      Object.defineProperty(T.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: y(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e,
          });
        },
      });
    },
    fix: function (e) {
      return e[T.expando] ? e : new T.Event(e);
    },
    special: {
      load: {
        noBubble: !0,
      },
      click: {
        setup: function (e) {
          e = this || e;
          return (
            Ct.test(e.type) && e.click && b(e, 'input') && jt(e, 'click', !0),
            !1
          );
        },
        trigger: function (e) {
          e = this || e;
          return (
            Ct.test(e.type) && e.click && b(e, 'input') && jt(e, 'click'), !0
          );
        },
        _default: function (e) {
          e = e.target;
          return (
            (Ct.test(e.type) &&
              e.click &&
              b(e, 'input') &&
              v.get(e, 'click')) ||
            b(e, 'a')
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (T.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (T.Event = function (e, t) {
      if (!(this instanceof T.Event)) return new T.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Nt
              : It),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && T.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[T.expando] = !0);
    }),
    (T.Event.prototype = {
      constructor: T.Event,
      isDefaultPrevented: It,
      isPropagationStopped: It,
      isImmediatePropagationStopped: It,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Nt),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Nt),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Nt),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    T.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0,
      },
      T.event.addProp
    ),
    T.each(
      {
        focus: 'focusin',
        blur: 'focusout',
      },
      function (i, o) {
        function r(e) {
          var t, n;
          C.documentMode
            ? ((t = v.get(this, 'handle')),
              ((n = T.event.fix(e)).type =
                'focusin' === e.type ? 'focus' : 'blur'),
              (n.isSimulated = !0),
              t(e),
              n.target === n.currentTarget && t(n))
            : T.event.simulate(o, e.target, T.event.fix(e));
        }
        (T.event.special[i] = {
          setup: function () {
            var e;
            if ((jt(this, i, !0), !C.documentMode)) return !1;
            (e = v.get(this, o)) || this.addEventListener(o, r),
              v.set(this, o, (e || 0) + 1);
          },
          trigger: function () {
            return jt(this, i), !0;
          },
          teardown: function () {
            var e;
            if (!C.documentMode) return !1;
            (e = v.get(this, o) - 1)
              ? v.set(this, o, e)
              : (this.removeEventListener(o, r), v.remove(this, o));
          },
          _default: function (e) {
            return v.get(e.target, i);
          },
          delegateType: o,
        }),
          (T.event.special[o] = {
            setup: function () {
              var e = this.ownerDocument || this.document || this,
                t = C.documentMode ? this : e,
                n = v.get(t, o);
              n ||
                (C.documentMode
                  ? this.addEventListener(o, r)
                  : e.addEventListener(i, r, !0)),
                v.set(t, o, (n || 0) + 1);
            },
            teardown: function () {
              var e = this.ownerDocument || this.document || this,
                t = C.documentMode ? this : e,
                n = v.get(t, o) - 1;
              n
                ? v.set(t, o, n)
                : (C.documentMode
                    ? this.removeEventListener(o, r)
                    : e.removeEventListener(i, r, !0),
                  v.remove(t, o));
            },
          });
      }
    ),
    T.each(
      {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        pointerenter: 'pointerover',
        pointerleave: 'pointerout',
      },
      function (e, o) {
        T.event.special[e] = {
          delegateType: o,
          bindType: o,
          handle: function (e) {
            var t,
              n = e.relatedTarget,
              i = e.handleObj;
            return (
              (n && (n === this || T.contains(this, n))) ||
                ((e.type = i.origType),
                (t = i.handler.apply(this, arguments)),
                (e.type = o)),
              t
            );
          },
        };
      }
    ),
    T.fn.extend({
      on: function (e, t, n, i) {
        return $t(this, e, t, n, i);
      },
      one: function (e, t, n, i) {
        return $t(this, e, t, n, i, 1);
      },
      off: function (e, t, n) {
        var i, o;
        if (e && e.preventDefault && e.handleObj)
          (i = e.handleObj),
            T(e.delegateTarget).off(
              i.namespace ? i.origType + '.' + i.namespace : i.origType,
              i.selector,
              i.handler
            );
        else {
          if ('object' != typeof e)
            return (
              (!1 !== t && 'function' != typeof t) || ((n = t), (t = void 0)),
              !1 === n && (n = It),
              this.each(function () {
                T.event.remove(this, e, n, t);
              })
            );
          for (o in e) this.off(o, t, e[o]);
        }
        return this;
      },
    });
  var Ot = /<script|<style|<link/i,
    Pt = /checked\s*(?:[^=]|=\s*.checked.)/i,
    Lt = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

  function Rt(e, t) {
    return (
      (b(e, 'table') &&
        b(11 !== t.nodeType ? t : t.firstChild, 'tr') &&
        T(e).children('tbody')[0]) ||
      e
    );
  }

  function zt(e) {
    return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
  }

  function Mt(e) {
    return (
      'true/' === (e.type || '').slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute('type'),
      e
    );
  }

  function qt(e, t) {
    var n, i, o, r;
    if (1 === t.nodeType) {
      if (v.hasData(e) && (r = v.get(e).events))
        for (o in (v.remove(t, 'handle events'), r))
          for (n = 0, i = r[o].length; n < i; n++) T.event.add(t, o, r[o][n]);
      l.hasData(e) && ((e = l.access(e)), (e = T.extend({}, e)), l.set(t, e));
    }
  }

  function Ht(n, i, o, r) {
    i = M(i);
    var e,
      t,
      s,
      a,
      l,
      u,
      c = 0,
      h = n.length,
      d = h - 1,
      f = i[0],
      p = y(f);
    if (p || (1 < h && 'string' == typeof f && !g.checkClone && Pt.test(f)))
      return n.each(function (e) {
        var t = n.eq(e);
        p && (i[0] = f.call(this, e, t.html())), Ht(t, i, o, r);
      });
    if (
      h &&
      ((t = (e = Dt(i, n[0].ownerDocument, !1, n, r)).firstChild),
      1 === e.childNodes.length && (e = t),
      t || r)
    ) {
      for (a = (s = T.map(O(e, 'script'), zt)).length; c < h; c++)
        (l = e),
          c !== d &&
            ((l = T.clone(l, !0, !0)), a) &&
            T.merge(s, O(l, 'script')),
          o.call(n[c], l, c);
      if (a)
        for (u = s[s.length - 1].ownerDocument, T.map(s, Mt), c = 0; c < a; c++)
          (l = s[c]),
            Et.test(l.type || '') &&
              !v.access(l, 'globalEval') &&
              T.contains(u, l) &&
              (l.src && 'module' !== (l.type || '').toLowerCase()
                ? T._evalUrl &&
                  !l.noModule &&
                  T._evalUrl(
                    l.src,
                    {
                      nonce: l.nonce || l.getAttribute('nonce'),
                    },
                    u
                  )
                : V(l.textContent.replace(Lt, ''), l, u));
    }
    return n;
  }

  function Ft(e, t, n) {
    for (var i, o = t ? T.filter(t, e) : e, r = 0; null != (i = o[r]); r++)
      n || 1 !== i.nodeType || T.cleanData(O(i)),
        i.parentNode &&
          (n && yt(i) && St(O(i, 'script')), i.parentNode.removeChild(i));
    return e;
  }
  T.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, n) {
      var i,
        o,
        r,
        s,
        a,
        l,
        u,
        c = e.cloneNode(!0),
        h = yt(e);
      if (
        !(
          g.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          T.isXMLDoc(e)
        )
      )
        for (s = O(c), i = 0, o = (r = O(e)).length; i < o; i++)
          (a = r[i]),
            'input' === (u = (l = s[i]).nodeName.toLowerCase()) &&
            Ct.test(a.type)
              ? (l.checked = a.checked)
              : ('input' !== u && 'textarea' !== u) ||
                (l.defaultValue = a.defaultValue);
      if (t)
        if (n)
          for (r = r || O(e), s = s || O(c), i = 0, o = r.length; i < o; i++)
            qt(r[i], s[i]);
        else qt(e, c);
      return 0 < (s = O(c, 'script')).length && St(s, !h && O(e, 'script')), c;
    },
    cleanData: function (e) {
      for (var t, n, i, o = T.event.special, r = 0; void 0 !== (n = e[r]); r++)
        if (ct(n)) {
          if ((t = n[v.expando])) {
            if (t.events)
              for (i in t.events)
                o[i] ? T.event.remove(n, i) : T.removeEvent(n, i, t.handle);
            n[v.expando] = void 0;
          }
          n[l.expando] && (n[l.expando] = void 0);
        }
    },
  }),
    T.fn.extend({
      detach: function (e) {
        return Ft(this, e, !0);
      },
      remove: function (e) {
        return Ft(this, e);
      },
      text: function (e) {
        return c(
          this,
          function (e) {
            return void 0 === e
              ? T.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Ht(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            Rt(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Ht(this, arguments, function (e) {
          var t;
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            (t = Rt(this, e)).insertBefore(e, t.firstChild);
        });
      },
      before: function () {
        return Ht(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Ht(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (T.cleanData(O(e, !1)), (e.textContent = ''));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return T.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return c(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              i = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              'string' == typeof e &&
              !Ot.test(e) &&
              !m[(Tt.exec(e) || ['', ''])[1].toLowerCase()]
            ) {
              e = T.htmlPrefilter(e);
              try {
                for (; n < i; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (T.cleanData(O(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var n = [];
        return Ht(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            T.inArray(this, n) < 0 &&
              (T.cleanData(O(this)), t) &&
              t.replaceChild(e, this);
          },
          n
        );
      },
    }),
    T.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith',
      },
      function (e, s) {
        T.fn[e] = function (e) {
          for (var t, n = [], i = T(e), o = i.length - 1, r = 0; r <= o; r++)
            (t = r === o ? this : this.clone(!0)),
              T(i[r])[s](t),
              q.apply(n, t.get());
          return this.pushStack(n);
        };
      }
    );

  function Wt(e) {
    var t = e.ownerDocument.defaultView;
    return (t = t && t.opener ? t : x).getComputedStyle(e);
  }

  function Bt(e, t, n) {
    var i,
      o = {};
    for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
    for (i in ((n = n.call(e)), t)) e.style[i] = o[i];
    return n;
  }
  var Qt,
    Ut,
    Vt,
    Xt,
    Yt,
    Kt,
    Jt,
    s,
    Gt = new RegExp('^(' + e + ')(?!px)[a-z%]+$', 'i'),
    Zt = /^--/,
    en = new RegExp(p.join('|'), 'i');

  function tn(e, t, n) {
    var i,
      o = Zt.test(t),
      r = e.style;
    return (
      (n = n || Wt(e)) &&
        ((i = n.getPropertyValue(t) || n[t]),
        '' !== (i = o ? i && (i.replace(ee, '$1') || void 0) : i) ||
          yt(e) ||
          (i = T.style(e, t)),
        !g.pixelBoxStyles()) &&
        Gt.test(i) &&
        en.test(t) &&
        ((o = r.width),
        (e = r.minWidth),
        (t = r.maxWidth),
        (r.minWidth = r.maxWidth = r.width = i),
        (i = n.width),
        (r.width = o),
        (r.minWidth = e),
        (r.maxWidth = t)),
      void 0 !== i ? i + '' : i
    );
  }

  function nn(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }

  function on() {
    var e;
    s &&
      ((Jt.style.cssText =
        'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
      (s.style.cssText =
        'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
      vt.appendChild(Jt).appendChild(s),
      (e = x.getComputedStyle(s)),
      (Qt = '1%' !== e.top),
      (Kt = 12 === rn(e.marginLeft)),
      (s.style.right = '60%'),
      (Xt = 36 === rn(e.right)),
      (Ut = 36 === rn(e.width)),
      (s.style.position = 'absolute'),
      (Vt = 12 === rn(s.offsetWidth / 3)),
      vt.removeChild(Jt),
      (s = null));
  }

  function rn(e) {
    return Math.round(parseFloat(e));
  }
  (Jt = C.createElement('div')),
    (s = C.createElement('div')).style &&
      ((s.style.backgroundClip = 'content-box'),
      (s.cloneNode(!0).style.backgroundClip = ''),
      (g.clearCloneStyle = 'content-box' === s.style.backgroundClip),
      T.extend(g, {
        boxSizingReliable: function () {
          return on(), Ut;
        },
        pixelBoxStyles: function () {
          return on(), Xt;
        },
        pixelPosition: function () {
          return on(), Qt;
        },
        reliableMarginLeft: function () {
          return on(), Kt;
        },
        scrollboxSize: function () {
          return on(), Vt;
        },
        reliableTrDimensions: function () {
          var e, t, n;
          return (
            null == Yt &&
              ((e = C.createElement('table')),
              (t = C.createElement('tr')),
              (n = C.createElement('div')),
              (e.style.cssText =
                'position:absolute;left:-11111px;border-collapse:separate'),
              (t.style.cssText = 'border:1px solid'),
              (t.style.height = '1px'),
              (n.style.height = '9px'),
              (n.style.display = 'block'),
              vt.appendChild(e).appendChild(t).appendChild(n),
              (n = x.getComputedStyle(t)),
              (Yt =
                parseInt(n.height, 10) +
                  parseInt(n.borderTopWidth, 10) +
                  parseInt(n.borderBottomWidth, 10) ===
                t.offsetHeight),
              vt.removeChild(e)),
            Yt
          );
        },
      }));
  var sn = ['Webkit', 'Moz', 'ms'],
    an = C.createElement('div').style,
    ln = {};

  function un(e) {
    return (
      T.cssProps[e] ||
      ln[e] ||
      (e in an
        ? e
        : (ln[e] =
            (function (e) {
              for (
                var t = e[0].toUpperCase() + e.slice(1), n = sn.length;
                n--;

              )
                if ((e = sn[n] + t) in an) return e;
            })(e) || e))
    );
  }
  var cn = /^(none|table(?!-c[ea]).+)/,
    hn = {
      position: 'absolute',
      visibility: 'hidden',
      display: 'block',
    },
    dn = {
      letterSpacing: '0',
      fontWeight: '400',
    };

  function fn(e, t, n) {
    var i = mt.exec(t);
    return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || 'px') : t;
  }

  function pn(e, t, n, i, o, r) {
    var s = 'width' === t ? 1 : 0,
      a = 0,
      l = 0,
      u = 0;
    if (n === (i ? 'border' : 'content')) return 0;
    for (; s < 4; s += 2)
      'margin' === n && (u += T.css(e, n + p[s], !0, o)),
        i
          ? ('content' === n && (l -= T.css(e, 'padding' + p[s], !0, o)),
            'margin' !== n && (l -= T.css(e, 'border' + p[s] + 'Width', !0, o)))
          : ((l += T.css(e, 'padding' + p[s], !0, o)),
            'padding' !== n
              ? (l += T.css(e, 'border' + p[s] + 'Width', !0, o))
              : (a += T.css(e, 'border' + p[s] + 'Width', !0, o)));
    return (
      !i &&
        0 <= r &&
        (l +=
          Math.max(
            0,
            Math.ceil(
              e['offset' + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5
            )
          ) || 0),
      l + u
    );
  }

  function gn(e, t, n) {
    var i = Wt(e),
      o =
        (!g.boxSizingReliable() || n) &&
        'border-box' === T.css(e, 'boxSizing', !1, i),
      r = o,
      s = tn(e, t, i),
      a = 'offset' + t[0].toUpperCase() + t.slice(1);
    if (Gt.test(s)) {
      if (!n) return s;
      s = 'auto';
    }
    return (
      ((!g.boxSizingReliable() && o) ||
        (!g.reliableTrDimensions() && b(e, 'tr')) ||
        'auto' === s ||
        (!parseFloat(s) && 'inline' === T.css(e, 'display', !1, i))) &&
        e.getClientRects().length &&
        ((o = 'border-box' === T.css(e, 'boxSizing', !1, i)), (r = a in e)) &&
        (s = e[a]),
      (s = parseFloat(s) || 0) +
        pn(e, t, n || (o ? 'border' : 'content'), r, i, s) +
        'px'
    );
  }

  function u(e, t, n, i, o) {
    return new u.prototype.init(e, t, n, i, o);
  }
  T.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) return '' === (t = tn(e, 'opacity')) ? '1' : t;
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageSlice: !0,
      columnCount: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      scale: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
    },
    cssProps: {},
    style: function (e, t, n, i) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var o,
          r,
          s,
          a = j(t),
          l = Zt.test(t),
          u = e.style;
        if (
          (l || (t = un(a)), (s = T.cssHooks[t] || T.cssHooks[a]), void 0 === n)
        )
          return s && 'get' in s && void 0 !== (o = s.get(e, !1, i)) ? o : u[t];
        'string' == (r = typeof n) &&
          (o = mt.exec(n)) &&
          o[1] &&
          ((n = bt(e, t, o)), (r = 'number')),
          null != n &&
            n == n &&
            ('number' !== r ||
              l ||
              (n += (o && o[3]) || (T.cssNumber[a] ? '' : 'px')),
            g.clearCloneStyle ||
              '' !== n ||
              0 !== t.indexOf('background') ||
              (u[t] = 'inherit'),
            (s && 'set' in s && void 0 === (n = s.set(e, n, i))) ||
              (l ? u.setProperty(t, n) : (u[t] = n)));
      }
    },
    css: function (e, t, n, i) {
      var o,
        r = j(t);
      return (
        Zt.test(t) || (t = un(r)),
        'normal' ===
          (o =
            void 0 ===
            (o =
              (r = T.cssHooks[t] || T.cssHooks[r]) && 'get' in r
                ? r.get(e, !0, n)
                : o)
              ? tn(e, t, i)
              : o) &&
          t in dn &&
          (o = dn[t]),
        ('' === n || n) && ((r = parseFloat(o)), !0 === n || isFinite(r))
          ? r || 0
          : o
      );
    },
  }),
    T.each(['height', 'width'], function (e, s) {
      T.cssHooks[s] = {
        get: function (e, t, n) {
          if (t)
            return !cn.test(T.css(e, 'display')) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? gn(e, s, n)
              : Bt(e, hn, function () {
                  return gn(e, s, n);
                });
        },
        set: function (e, t, n) {
          var i = Wt(e),
            o = !g.scrollboxSize() && 'absolute' === i.position,
            r = (o || n) && 'border-box' === T.css(e, 'boxSizing', !1, i),
            n = n ? pn(e, s, n, r, i) : 0;
          return (
            r &&
              o &&
              (n -= Math.ceil(
                e['offset' + s[0].toUpperCase() + s.slice(1)] -
                  parseFloat(i[s]) -
                  pn(e, s, 'border', !1, i) -
                  0.5
              )),
            n &&
              (r = mt.exec(t)) &&
              'px' !== (r[3] || 'px') &&
              ((e.style[s] = t), (t = T.css(e, s))),
            fn(0, t, n)
          );
        },
      };
    }),
    (T.cssHooks.marginLeft = nn(g.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(tn(e, 'marginLeft')) ||
            e.getBoundingClientRect().left -
              Bt(
                e,
                {
                  marginLeft: 0,
                },
                function () {
                  return e.getBoundingClientRect().left;
                }
              )) + 'px'
        );
    })),
    T.each(
      {
        margin: '',
        padding: '',
        border: 'Width',
      },
      function (o, r) {
        (T.cssHooks[o + r] = {
          expand: function (e) {
            for (
              var t = 0, n = {}, i = 'string' == typeof e ? e.split(' ') : [e];
              t < 4;
              t++
            )
              n[o + p[t] + r] = i[t] || i[t - 2] || i[0];
            return n;
          },
        }),
          'margin' !== o && (T.cssHooks[o + r].set = fn);
      }
    ),
    T.fn.extend({
      css: function (e, t) {
        return c(
          this,
          function (e, t, n) {
            var i,
              o,
              r = {},
              s = 0;
            if (Array.isArray(t)) {
              for (i = Wt(e), o = t.length; s < o; s++)
                r[t[s]] = T.css(e, t[s], !1, i);
              return r;
            }
            return void 0 !== n ? T.style(e, t, n) : T.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((T.Tween = u).prototype = {
      constructor: u,
      init: function (e, t, n, i, o, r) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = o || T.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = i),
          (this.unit = r || (T.cssNumber[n] ? '' : 'px'));
      },
      cur: function () {
        var e = u.propHooks[this.prop];
        return (e && e.get ? e : u.propHooks._default).get(this);
      },
      run: function (e) {
        var t,
          n = u.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                T.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          (n && n.set ? n : u.propHooks._default).set(this),
          this
        );
      },
    }).init.prototype = u.prototype),
    ((u.propHooks = {
      _default: {
        get: function (e) {
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (e = T.css(e.elem, e.prop, '')) && 'auto' !== e
            ? e
            : 0;
        },
        set: function (e) {
          T.fx.step[e.prop]
            ? T.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (!T.cssHooks[e.prop] && null == e.elem.style[un(e.prop)])
            ? (e.elem[e.prop] = e.now)
            : T.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = u.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (T.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: 'swing',
    }),
    (T.fx = u.prototype.init),
    (T.fx.step = {});
  var mn,
    vn,
    yn = /^(?:toggle|show|hide)$/,
    _n = /queueHooks$/;

  function bn() {
    vn &&
      (!1 === C.hidden && x.requestAnimationFrame
        ? x.requestAnimationFrame(bn)
        : x.setTimeout(bn, T.fx.interval),
      T.fx.tick());
  }

  function wn() {
    return (
      x.setTimeout(function () {
        mn = void 0;
      }),
      (mn = Date.now())
    );
  }

  function xn(e, t) {
    var n,
      i = 0,
      o = {
        height: e,
      };
    for (t = t ? 1 : 0; i < 4; i += 2 - t)
      o['margin' + (n = p[i])] = o['padding' + n] = e;
    return t && (o.opacity = o.width = e), o;
  }

  function Cn(e, t, n) {
    for (
      var i,
        o = (P.tweeners[t] || []).concat(P.tweeners['*']),
        r = 0,
        s = o.length;
      r < s;
      r++
    )
      if ((i = o[r].call(n, t, e))) return i;
  }

  function P(o, e, t) {
    var n,
      r,
      i,
      s,
      a,
      l,
      u,
      c = 0,
      h = P.prefilters.length,
      d = T.Deferred().always(function () {
        delete f.elem;
      }),
      f = function () {
        if (r) return !1;
        for (
          var e = mn || wn(),
            e = Math.max(0, p.startTime + p.duration - e),
            t = 1 - (e / p.duration || 0),
            n = 0,
            i = p.tweens.length;
          n < i;
          n++
        )
          p.tweens[n].run(t);
        return (
          d.notifyWith(o, [p, t, e]),
          t < 1 && i
            ? e
            : (i || d.notifyWith(o, [p, 1, 0]), d.resolveWith(o, [p]), !1)
        );
      },
      p = d.promise({
        elem: o,
        props: T.extend({}, e),
        opts: T.extend(
          !0,
          {
            specialEasing: {},
            easing: T.easing._default,
          },
          t
        ),
        originalProperties: e,
        originalOptions: t,
        startTime: mn || wn(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          t = T.Tween(
            o,
            p.opts,
            e,
            t,
            p.opts.specialEasing[e] || p.opts.easing
          );
          return p.tweens.push(t), t;
        },
        stop: function (e) {
          var t = 0,
            n = e ? p.tweens.length : 0;
          if (!r) {
            for (r = !0; t < n; t++) p.tweens[t].run(1);
            e
              ? (d.notifyWith(o, [p, 1, 0]), d.resolveWith(o, [p, e]))
              : d.rejectWith(o, [p, e]);
          }
          return this;
        },
      }),
      g = p.props,
      m = g,
      v = p.opts.specialEasing;
    for (i in m)
      if (
        ((a = v[(s = j(i))]),
        (l = m[i]),
        Array.isArray(l) && ((a = l[1]), (l = m[i] = l[0])),
        i !== s && ((m[s] = l), delete m[i]),
        (u = T.cssHooks[s]) && 'expand' in u)
      )
        for (i in ((l = u.expand(l)), delete m[s], l))
          i in m || ((m[i] = l[i]), (v[i] = a));
      else v[s] = a;
    for (; c < h; c++)
      if ((n = P.prefilters[c].call(p, o, g, p.opts)))
        return (
          y(n.stop) &&
            (T._queueHooks(p.elem, p.opts.queue).stop = n.stop.bind(n)),
          n
        );
    return (
      T.map(g, Cn, p),
      y(p.opts.start) && p.opts.start.call(o, p),
      p
        .progress(p.opts.progress)
        .done(p.opts.done, p.opts.complete)
        .fail(p.opts.fail)
        .always(p.opts.always),
      T.fx.timer(
        T.extend(f, {
          elem: o,
          anim: p,
          queue: p.opts.queue,
        })
      ),
      p
    );
  }
  (T.Animation = T.extend(P, {
    tweeners: {
      '*': [
        function (e, t) {
          var n = this.createTween(e, t);
          return bt(n.elem, e, mt.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      for (
        var n, i = 0, o = (e = y(e) ? ((t = e), ['*']) : e.match($)).length;
        i < o;
        i++
      )
        (n = e[i]),
          (P.tweeners[n] = P.tweeners[n] || []),
          P.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var i,
          o,
          r,
          s,
          a,
          l,
          u,
          c = 'width' in t || 'height' in t,
          h = this,
          d = {},
          f = e.style,
          p = e.nodeType && gt(e),
          g = v.get(e, 'fxshow');
        for (i in (n.queue ||
          (null == (s = T._queueHooks(e, 'fx')).unqueued &&
            ((s.unqueued = 0),
            (a = s.empty.fire),
            (s.empty.fire = function () {
              s.unqueued || a();
            })),
          s.unqueued++,
          h.always(function () {
            h.always(function () {
              s.unqueued--, T.queue(e, 'fx').length || s.empty.fire();
            });
          })),
        t))
          if (((o = t[i]), yn.test(o))) {
            if (
              (delete t[i],
              (r = r || 'toggle' === o),
              o === (p ? 'hide' : 'show'))
            ) {
              if ('show' !== o || !g || void 0 === g[i]) continue;
              p = !0;
            }
            d[i] = (g && g[i]) || T.style(e, i);
          }
        if ((l = !T.isEmptyObject(t)) || !T.isEmptyObject(d))
          for (i in (c &&
            1 === e.nodeType &&
            ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
            null == (u = g && g.display) && (u = v.get(e, 'display')),
            'none' === (c = T.css(e, 'display')) &&
              (u
                ? (c = u)
                : (xt([e], !0),
                  (u = e.style.display || u),
                  (c = T.css(e, 'display')),
                  xt([e]))),
            'inline' === c || ('inline-block' === c && null != u)) &&
            'none' === T.css(e, 'float') &&
            (l ||
              (h.done(function () {
                f.display = u;
              }),
              null == u && ((c = f.display), (u = 'none' === c ? '' : c))),
            (f.display = 'inline-block')),
          n.overflow &&
            ((f.overflow = 'hidden'),
            h.always(function () {
              (f.overflow = n.overflow[0]),
                (f.overflowX = n.overflow[1]),
                (f.overflowY = n.overflow[2]);
            })),
          (l = !1),
          d))
            l ||
              (g
                ? 'hidden' in g && (p = g.hidden)
                : (g = v.access(e, 'fxshow', {
                    display: u,
                  })),
              r && (g.hidden = !p),
              p && xt([e], !0),
              h.done(function () {
                for (i in (p || xt([e]), v.remove(e, 'fxshow'), d))
                  T.style(e, i, d[i]);
              })),
              (l = Cn(p ? g[i] : 0, i, h)),
              i in g ||
                ((g[i] = l.start), p && ((l.end = l.start), (l.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? P.prefilters.unshift(e) : P.prefilters.push(e);
    },
  })),
    (T.speed = function (e, t, n) {
      var i =
        e && 'object' == typeof e
          ? T.extend({}, e)
          : {
              complete: n || (!n && t) || (y(e) && e),
              duration: e,
              easing: (n && t) || (t && !y(t) && t),
            };
      return (
        T.fx.off
          ? (i.duration = 0)
          : 'number' != typeof i.duration &&
            (i.duration in T.fx.speeds
              ? (i.duration = T.fx.speeds[i.duration])
              : (i.duration = T.fx.speeds._default)),
        (null != i.queue && !0 !== i.queue) || (i.queue = 'fx'),
        (i.old = i.complete),
        (i.complete = function () {
          y(i.old) && i.old.call(this), i.queue && T.dequeue(this, i.queue);
        }),
        i
      );
    }),
    T.fn.extend({
      fadeTo: function (e, t, n, i) {
        return this.filter(gt).css('opacity', 0).show().end().animate(
          {
            opacity: t,
          },
          e,
          n,
          i
        );
      },
      animate: function (t, e, n, i) {
        function o() {
          var e = P(this, T.extend({}, t), s);
          (r || v.get(this, 'finish')) && e.stop(!0);
        }
        var r = T.isEmptyObject(t),
          s = T.speed(e, n, i);
        return (
          (o.finish = o),
          r || !1 === s.queue ? this.each(o) : this.queue(s.queue, o)
        );
      },
      stop: function (o, e, r) {
        function s(e) {
          var t = e.stop;
          delete e.stop, t(r);
        }
        return (
          'string' != typeof o && ((r = e), (e = o), (o = void 0)),
          e && this.queue(o || 'fx', []),
          this.each(function () {
            var e = !0,
              t = null != o && o + 'queueHooks',
              n = T.timers,
              i = v.get(this);
            if (t) i[t] && i[t].stop && s(i[t]);
            else for (t in i) i[t] && i[t].stop && _n.test(t) && s(i[t]);
            for (t = n.length; t--; )
              n[t].elem !== this ||
                (null != o && n[t].queue !== o) ||
                (n[t].anim.stop(r), (e = !1), n.splice(t, 1));
            (!e && r) || T.dequeue(this, o);
          })
        );
      },
      finish: function (s) {
        return (
          !1 !== s && (s = s || 'fx'),
          this.each(function () {
            var e,
              t = v.get(this),
              n = t[s + 'queue'],
              i = t[s + 'queueHooks'],
              o = T.timers,
              r = n ? n.length : 0;
            for (
              t.finish = !0,
                T.queue(this, s, []),
                i && i.stop && i.stop.call(this, !0),
                e = o.length;
              e--;

            )
              o[e].elem === this &&
                o[e].queue === s &&
                (o[e].anim.stop(!0), o.splice(e, 1));
            for (e = 0; e < r; e++)
              n[e] && n[e].finish && n[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    T.each(['toggle', 'show', 'hide'], function (e, i) {
      var o = T.fn[i];
      T.fn[i] = function (e, t, n) {
        return null == e || 'boolean' == typeof e
          ? o.apply(this, arguments)
          : this.animate(xn(i, !0), e, t, n);
      };
    }),
    T.each(
      {
        slideDown: xn('show'),
        slideUp: xn('hide'),
        slideToggle: xn('toggle'),
        fadeIn: {
          opacity: 'show',
        },
        fadeOut: {
          opacity: 'hide',
        },
        fadeToggle: {
          opacity: 'toggle',
        },
      },
      function (e, i) {
        T.fn[e] = function (e, t, n) {
          return this.animate(i, e, t, n);
        };
      }
    ),
    (T.timers = []),
    (T.fx.tick = function () {
      var e,
        t = 0,
        n = T.timers;
      for (mn = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || T.fx.stop(), (mn = void 0);
    }),
    (T.fx.timer = function (e) {
      T.timers.push(e), T.fx.start();
    }),
    (T.fx.interval = 13),
    (T.fx.start = function () {
      vn || ((vn = !0), bn());
    }),
    (T.fx.stop = function () {
      vn = null;
    }),
    (T.fx.speeds = {
      slow: 600,
      fast: 200,
      _default: 400,
    }),
    (T.fn.delay = function (i, e) {
      return (
        (i = (T.fx && T.fx.speeds[i]) || i),
        this.queue((e = e || 'fx'), function (e, t) {
          var n = x.setTimeout(e, i);
          t.stop = function () {
            x.clearTimeout(n);
          };
        })
      );
    }),
    (r = C.createElement('input')),
    (o = C.createElement('select').appendChild(C.createElement('option'))),
    (r.type = 'checkbox'),
    (g.checkOn = '' !== r.value),
    (g.optSelected = o.selected),
    ((r = C.createElement('input')).value = 't'),
    (r.type = 'radio'),
    (g.radioValue = 't' === r.value);
  var Tn,
    En = T.expr.attrHandle,
    Sn =
      (T.fn.extend({
        attr: function (e, t) {
          return c(this, T.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function (e) {
          return this.each(function () {
            T.removeAttr(this, e);
          });
        },
      }),
      T.extend({
        attr: function (e, t, n) {
          var i,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return void 0 === e.getAttribute
              ? T.prop(e, t, n)
              : ((1 === r && T.isXMLDoc(e)) ||
                  (o =
                    T.attrHooks[t.toLowerCase()] ||
                    (T.expr.match.bool.test(t) ? Tn : void 0)),
                void 0 !== n
                  ? null === n
                    ? void T.removeAttr(e, t)
                    : o && 'set' in o && void 0 !== (i = o.set(e, n, t))
                    ? i
                    : (e.setAttribute(t, n + ''), n)
                  : !(o && 'get' in o && null !== (i = o.get(e, t))) &&
                    null == (i = T.find.attr(e, t))
                  ? void 0
                  : i);
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              var n;
              if (!g.radioValue && 'radio' === t && b(e, 'input'))
                return (
                  (n = e.value),
                  e.setAttribute('type', t),
                  n && (e.value = n),
                  t
                );
            },
          },
        },
        removeAttr: function (e, t) {
          var n,
            i = 0,
            o = t && t.match($);
          if (o && 1 === e.nodeType)
            for (; (n = o[i++]); ) e.removeAttribute(n);
        },
      }),
      (Tn = {
        set: function (e, t, n) {
          return !1 === t ? T.removeAttr(e, n) : e.setAttribute(n, n), n;
        },
      }),
      T.each(T.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var s = En[t] || T.find.attr;
        En[t] = function (e, t, n) {
          var i,
            o,
            r = t.toLowerCase();
          return (
            n ||
              ((o = En[r]),
              (En[r] = i),
              (i = null != s(e, t, n) ? r : null),
              (En[r] = o)),
            i
          );
        };
      }),
      /^(?:input|select|textarea|button)$/i),
    kn = /^(?:a|area)$/i;

  function Dn(e) {
    return (e.match($) || []).join(' ');
  }

  function An(e) {
    return (e.getAttribute && e.getAttribute('class')) || '';
  }

  function Nn(e) {
    return Array.isArray(e) ? e : ('string' == typeof e && e.match($)) || [];
  }
  T.fn.extend({
    prop: function (e, t) {
      return c(this, T.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[T.propFix[e] || e];
      });
    },
  }),
    T.extend({
      prop: function (e, t, n) {
        var i,
          o,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return (
            (1 === r && T.isXMLDoc(e)) ||
              ((t = T.propFix[t] || t), (o = T.propHooks[t])),
            void 0 !== n
              ? o && 'set' in o && void 0 !== (i = o.set(e, n, t))
                ? i
                : (e[t] = n)
              : o && 'get' in o && null !== (i = o.get(e, t))
              ? i
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = T.find.attr(e, 'tabindex');
            return t
              ? parseInt(t, 10)
              : Sn.test(e.nodeName) || (kn.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: {
        for: 'htmlFor',
        class: 'className',
      },
    }),
    g.optSelected ||
      (T.propHooks.selected = {
        get: function (e) {
          e = e.parentNode;
          return e && e.parentNode && e.parentNode.selectedIndex, null;
        },
        set: function (e) {
          e = e.parentNode;
          e && (e.selectedIndex, e.parentNode) && e.parentNode.selectedIndex;
        },
      }),
    T.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable',
      ],
      function () {
        T.propFix[this.toLowerCase()] = this;
      }
    ),
    T.fn.extend({
      addClass: function (t) {
        var e, n, i, o, r, s;
        return y(t)
          ? this.each(function (e) {
              T(this).addClass(t.call(this, e, An(this)));
            })
          : (e = Nn(t)).length
          ? this.each(function () {
              if (
                ((i = An(this)), (n = 1 === this.nodeType && ' ' + Dn(i) + ' '))
              ) {
                for (r = 0; r < e.length; r++)
                  (o = e[r]), n.indexOf(' ' + o + ' ') < 0 && (n += o + ' ');
                (s = Dn(n)), i !== s && this.setAttribute('class', s);
              }
            })
          : this;
      },
      removeClass: function (t) {
        var e, n, i, o, r, s;
        return y(t)
          ? this.each(function (e) {
              T(this).removeClass(t.call(this, e, An(this)));
            })
          : arguments.length
          ? (e = Nn(t)).length
            ? this.each(function () {
                if (
                  ((i = An(this)),
                  (n = 1 === this.nodeType && ' ' + Dn(i) + ' '))
                ) {
                  for (r = 0; r < e.length; r++)
                    for (o = e[r]; -1 < n.indexOf(' ' + o + ' '); )
                      n = n.replace(' ' + o + ' ', ' ');
                  (s = Dn(n)), i !== s && this.setAttribute('class', s);
                }
              })
            : this
          : this.attr('class', '');
      },
      toggleClass: function (t, n) {
        var e,
          i,
          o,
          r,
          s = typeof t,
          a = 'string' == s || Array.isArray(t);
        return y(t)
          ? this.each(function (e) {
              T(this).toggleClass(t.call(this, e, An(this), n), n);
            })
          : 'boolean' == typeof n && a
          ? n
            ? this.addClass(t)
            : this.removeClass(t)
          : ((e = Nn(t)),
            this.each(function () {
              if (a)
                for (r = T(this), o = 0; o < e.length; o++)
                  (i = e[o]), r.hasClass(i) ? r.removeClass(i) : r.addClass(i);
              else
                (void 0 !== t && 'boolean' != s) ||
                  ((i = An(this)) && v.set(this, '__className__', i),
                  this.setAttribute &&
                    this.setAttribute(
                      'class',
                      (!i && !1 !== t && v.get(this, '__className__')) || ''
                    ));
            }));
      },
      hasClass: function (e) {
        for (var t, n = 0, i = ' ' + e + ' '; (t = this[n++]); )
          if (1 === t.nodeType && -1 < (' ' + Dn(An(t)) + ' ').indexOf(i))
            return !0;
        return !1;
      },
    });

  function In(e) {
    e.stopPropagation();
  }
  var $n = /\r/g,
    jn =
      (T.fn.extend({
        val: function (t) {
          var n,
            e,
            i,
            o = this[0];
          return arguments.length
            ? ((i = y(t)),
              this.each(function (e) {
                1 === this.nodeType &&
                  (null == (e = i ? t.call(this, e, T(this).val()) : t)
                    ? (e = '')
                    : 'number' == typeof e
                    ? (e += '')
                    : Array.isArray(e) &&
                      (e = T.map(e, function (e) {
                        return null == e ? '' : e + '';
                      })),
                  ((n =
                    T.valHooks[this.type] ||
                    T.valHooks[this.nodeName.toLowerCase()]) &&
                    'set' in n &&
                    void 0 !== n.set(this, e, 'value')) ||
                    (this.value = e));
              }))
            : o
            ? (n =
                T.valHooks[o.type] || T.valHooks[o.nodeName.toLowerCase()]) &&
              'get' in n &&
              void 0 !== (e = n.get(o, 'value'))
              ? e
              : 'string' == typeof (e = o.value)
              ? e.replace($n, '')
              : null == e
              ? ''
              : e
            : void 0;
        },
      }),
      T.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = T.find.attr(e, 'value');
              return null != t ? t : Dn(T.text(e));
            },
          },
          select: {
            get: function (e) {
              for (
                var t,
                  n = e.options,
                  i = e.selectedIndex,
                  o = 'select-one' === e.type,
                  r = o ? null : [],
                  s = o ? i + 1 : n.length,
                  a = i < 0 ? s : o ? i : 0;
                a < s;
                a++
              )
                if (
                  ((t = n[a]).selected || a === i) &&
                  !t.disabled &&
                  (!t.parentNode.disabled || !b(t.parentNode, 'optgroup'))
                ) {
                  if (((t = T(t).val()), o)) return t;
                  r.push(t);
                }
              return r;
            },
            set: function (e, t) {
              for (
                var n, i, o = e.options, r = T.makeArray(t), s = o.length;
                s--;

              )
                ((i = o[s]).selected =
                  -1 < T.inArray(T.valHooks.option.get(i), r)) && (n = !0);
              return n || (e.selectedIndex = -1), r;
            },
          },
        },
      }),
      T.each(['radio', 'checkbox'], function () {
        (T.valHooks[this] = {
          set: function (e, t) {
            if (Array.isArray(t))
              return (e.checked = -1 < T.inArray(T(e).val(), t));
          },
        }),
          g.checkOn ||
            (T.valHooks[this].get = function (e) {
              return null === e.getAttribute('value') ? 'on' : e.value;
            });
      }),
      x.location),
    On = {
      guid: Date.now(),
    },
    Pn = /\?/,
    Ln =
      ((T.parseXML = function (e) {
        var t, n;
        if (!e || 'string' != typeof e) return null;
        try {
          t = new x.DOMParser().parseFromString(e, 'text/xml');
        } catch (e) {}
        return (
          (n = t && t.getElementsByTagName('parsererror')[0]),
          (t && !n) ||
            T.error(
              'Invalid XML: ' +
                (n
                  ? T.map(n.childNodes, function (e) {
                      return e.textContent;
                    }).join('\n')
                  : e)
            ),
          t
        );
      }),
      /^(?:focusinfocus|focusoutblur)$/),
    Rn =
      (T.extend(T.event, {
        trigger: function (e, t, n, i) {
          var o,
            r,
            s,
            a,
            l,
            u,
            c,
            h = [n || C],
            d = W.call(e, 'type') ? e.type : e,
            f = W.call(e, 'namespace') ? e.namespace.split('.') : [],
            p = (c = r = n = n || C);
          if (
            3 !== n.nodeType &&
            8 !== n.nodeType &&
            !Ln.test(d + T.event.triggered) &&
            (-1 < d.indexOf('.') &&
              ((d = (f = d.split('.')).shift()), f.sort()),
            (a = d.indexOf(':') < 0 && 'on' + d),
            ((e = e[T.expando]
              ? e
              : new T.Event(d, 'object' == typeof e && e)).isTrigger = i
              ? 2
              : 3),
            (e.namespace = f.join('.')),
            (e.rnamespace = e.namespace
              ? new RegExp('(^|\\.)' + f.join('\\.(?:.*\\.|)') + '(\\.|$)')
              : null),
            (e.result = void 0),
            e.target || (e.target = n),
            (t = null == t ? [e] : T.makeArray(t, [e])),
            (u = T.event.special[d] || {}),
            i || !u.trigger || !1 !== u.trigger.apply(n, t))
          ) {
            if (!i && !u.noBubble && !R(n)) {
              for (
                s = u.delegateType || d, Ln.test(s + d) || (p = p.parentNode);
                p;
                p = p.parentNode
              )
                h.push(p), (r = p);
              r === (n.ownerDocument || C) &&
                h.push(r.defaultView || r.parentWindow || x);
            }
            for (o = 0; (p = h[o++]) && !e.isPropagationStopped(); )
              (c = p),
                (e.type = 1 < o ? s : u.bindType || d),
                (l =
                  (v.get(p, 'events') || Object.create(null))[e.type] &&
                  v.get(p, 'handle')) && l.apply(p, t),
                (l = a && p[a]) &&
                  l.apply &&
                  ct(p) &&
                  ((e.result = l.apply(p, t)), !1 === e.result) &&
                  e.preventDefault();
            return (
              (e.type = d),
              i ||
                e.isDefaultPrevented() ||
                (u._default && !1 !== u._default.apply(h.pop(), t)) ||
                !ct(n) ||
                (a &&
                  y(n[d]) &&
                  !R(n) &&
                  ((r = n[a]) && (n[a] = null),
                  (T.event.triggered = d),
                  e.isPropagationStopped() && c.addEventListener(d, In),
                  n[d](),
                  e.isPropagationStopped() && c.removeEventListener(d, In),
                  (T.event.triggered = void 0),
                  r) &&
                  (n[a] = r)),
              e.result
            );
          }
        },
        simulate: function (e, t, n) {
          n = T.extend(new T.Event(), n, {
            type: e,
            isSimulated: !0,
          });
          T.event.trigger(n, null, t);
        },
      }),
      T.fn.extend({
        trigger: function (e, t) {
          return this.each(function () {
            T.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var n = this[0];
          if (n) return T.event.trigger(e, t, n, !0);
        },
      }),
      /\[\]$/),
    zn = /\r?\n/g,
    Mn = /^(?:submit|button|image|reset|file)$/i,
    qn = /^(?:input|select|textarea|keygen)/i;
  (T.param = function (e, t) {
    function n(e, t) {
      (t = y(t) ? t() : t),
        (o[o.length] =
          encodeURIComponent(e) + '=' + encodeURIComponent(null == t ? '' : t));
    }
    var i,
      o = [];
    if (null == e) return '';
    if (Array.isArray(e) || (e.jquery && !T.isPlainObject(e)))
      T.each(e, function () {
        n(this.name, this.value);
      });
    else
      for (i in e)
        !(function n(i, e, o, r) {
          if (Array.isArray(e))
            T.each(e, function (e, t) {
              o || Rn.test(i)
                ? r(i, t)
                : n(
                    i +
                      '[' +
                      ('object' == typeof t && null != t ? e : '') +
                      ']',
                    t,
                    o,
                    r
                  );
            });
          else if (o || 'object' !== X(e)) r(i, e);
          else for (var t in e) n(i + '[' + t + ']', e[t], o, r);
        })(i, e[i], t, n);
    return o.join('&');
  }),
    T.fn.extend({
      serialize: function () {
        return T.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = T.prop(this, 'elements');
          return e ? T.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !T(this).is(':disabled') &&
              qn.test(this.nodeName) &&
              !Mn.test(e) &&
              (this.checked || !Ct.test(e))
            );
          })
          .map(function (e, t) {
            var n = T(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? T.map(n, function (e) {
                  return {
                    name: t.name,
                    value: e.replace(zn, '\r\n'),
                  };
                })
              : {
                  name: t.name,
                  value: n.replace(zn, '\r\n'),
                };
          })
          .get();
      },
    });
  var Hn = /%20/g,
    Fn = /#.*$/,
    Wn = /([?&])_=[^&]*/,
    Bn = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Qn = /^(?:GET|HEAD)$/,
    Un = /^\/\//,
    Vn = {},
    Xn = {},
    Yn = '*/'.concat('*'),
    Kn = C.createElement('a');

  function Jn(r) {
    return function (e, t) {
      'string' != typeof e && ((t = e), (e = '*'));
      var n,
        i = 0,
        o = e.toLowerCase().match($) || [];
      if (y(t))
        for (; (n = o[i++]); )
          '+' === n[0]
            ? ((n = n.slice(1) || '*'), (r[n] = r[n] || []).unshift(t))
            : (r[n] = r[n] || []).push(t);
    };
  }

  function Gn(t, i, o, r) {
    var s = {},
      a = t === Xn;

    function l(e) {
      var n;
      return (
        (s[e] = !0),
        T.each(t[e] || [], function (e, t) {
          t = t(i, o, r);
          return 'string' != typeof t || a || s[t]
            ? a
              ? !(n = t)
              : void 0
            : (i.dataTypes.unshift(t), l(t), !1);
        }),
        n
      );
    }
    return l(i.dataTypes[0]) || (!s['*'] && l('*'));
  }

  function Zn(e, t) {
    var n,
      i,
      o = T.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((o[n] ? e : (i = i || {}))[n] = t[n]);
    return i && T.extend(!0, e, i), e;
  }
  (Kn.href = jn.href),
    T.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: jn.href,
        type: 'GET',
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            jn.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        accepts: {
          '*': Yn,
          text: 'text/plain',
          html: 'text/html',
          xml: 'application/xml, text/xml',
          json: 'application/json, text/javascript',
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/,
        },
        responseFields: {
          xml: 'responseXML',
          text: 'responseText',
          json: 'responseJSON',
        },
        converters: {
          '* text': String,
          'text html': !0,
          'text json': JSON.parse,
          'text xml': T.parseXML,
        },
        flatOptions: {
          url: !0,
          context: !0,
        },
      },
      ajaxSetup: function (e, t) {
        return t ? Zn(Zn(e, T.ajaxSettings), t) : Zn(T.ajaxSettings, e);
      },
      ajaxPrefilter: Jn(Vn),
      ajaxTransport: Jn(Xn),
      ajax: function (e, t) {
        'object' == typeof e && ((t = e), (e = void 0));
        var l,
          u,
          c,
          n,
          h,
          d,
          f,
          i,
          o,
          p = T.ajaxSetup({}, (t = t || {})),
          g = p.context || p,
          m = p.context && (g.nodeType || g.jquery) ? T(g) : T.event,
          v = T.Deferred(),
          y = T.Callbacks('once memory'),
          _ = p.statusCode || {},
          r = {},
          s = {},
          a = 'canceled',
          b = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (d) {
                if (!n)
                  for (n = {}; (t = Bn.exec(c)); )
                    n[t[1].toLowerCase() + ' '] = (
                      n[t[1].toLowerCase() + ' '] || []
                    ).concat(t[2]);
                t = n[e.toLowerCase() + ' '];
              }
              return null == t ? null : t.join(', ');
            },
            getAllResponseHeaders: function () {
              return d ? c : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == d &&
                  ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e),
                  (r[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == d && (p.mimeType = e), this;
            },
            statusCode: function (e) {
              if (e)
                if (d) b.always(e[b.status]);
                else for (var t in e) _[t] = [_[t], e[t]];
              return this;
            },
            abort: function (e) {
              e = e || a;
              return l && l.abort(e), w(0, e), this;
            },
          };
        if (
          (v.promise(b),
          (p.url = ((e || p.url || jn.href) + '').replace(
            Un,
            jn.protocol + '//'
          )),
          (p.type = t.method || t.type || p.method || p.type),
          (p.dataTypes = (p.dataType || '*').toLowerCase().match($) || ['']),
          null == p.crossDomain)
        ) {
          o = C.createElement('a');
          try {
            (o.href = p.url),
              (o.href = o.href),
              (p.crossDomain =
                Kn.protocol + '//' + Kn.host != o.protocol + '//' + o.host);
          } catch (e) {
            p.crossDomain = !0;
          }
        }
        if (
          (p.data &&
            p.processData &&
            'string' != typeof p.data &&
            (p.data = T.param(p.data, p.traditional)),
          Gn(Vn, p, t, b),
          !d)
        ) {
          for (i in ((f = T.event && p.global) &&
            0 == T.active++ &&
            T.event.trigger('ajaxStart'),
          (p.type = p.type.toUpperCase()),
          (p.hasContent = !Qn.test(p.type)),
          (u = p.url.replace(Fn, '')),
          p.hasContent
            ? p.data &&
              p.processData &&
              0 ===
                (p.contentType || '').indexOf(
                  'application/x-www-form-urlencoded'
                ) &&
              (p.data = p.data.replace(Hn, '+'))
            : ((o = p.url.slice(u.length)),
              p.data &&
                (p.processData || 'string' == typeof p.data) &&
                ((u += (Pn.test(u) ? '&' : '?') + p.data), delete p.data),
              !1 === p.cache &&
                ((u = u.replace(Wn, '$1')),
                (o = (Pn.test(u) ? '&' : '?') + '_=' + On.guid++ + o)),
              (p.url = u + o)),
          p.ifModified &&
            (T.lastModified[u] &&
              b.setRequestHeader('If-Modified-Since', T.lastModified[u]),
            T.etag[u]) &&
            b.setRequestHeader('If-None-Match', T.etag[u]),
          ((p.data && p.hasContent && !1 !== p.contentType) || t.contentType) &&
            b.setRequestHeader('Content-Type', p.contentType),
          b.setRequestHeader(
            'Accept',
            p.dataTypes[0] && p.accepts[p.dataTypes[0]]
              ? p.accepts[p.dataTypes[0]] +
                  ('*' !== p.dataTypes[0] ? ', ' + Yn + '; q=0.01' : '')
              : p.accepts['*']
          ),
          p.headers))
            b.setRequestHeader(i, p.headers[i]);
          if (p.beforeSend && (!1 === p.beforeSend.call(g, b, p) || d))
            return b.abort();
          if (
            ((a = 'abort'),
            y.add(p.complete),
            b.done(p.success),
            b.fail(p.error),
            (l = Gn(Xn, p, t, b)))
          ) {
            if (((b.readyState = 1), f && m.trigger('ajaxSend', [b, p]), d))
              return b;
            p.async &&
              0 < p.timeout &&
              (h = x.setTimeout(function () {
                b.abort('timeout');
              }, p.timeout));
            try {
              (d = !1), l.send(r, w);
            } catch (e) {
              if (d) throw e;
              w(-1, e);
            }
          } else w(-1, 'No Transport');
        }
        return b;

        function w(e, t, n, i) {
          var o,
            r,
            s,
            a = t;
          d ||
            ((d = !0),
            h && x.clearTimeout(h),
            (l = void 0),
            (c = i || ''),
            (b.readyState = 0 < e ? 4 : 0),
            (i = (200 <= e && e < 300) || 304 === e),
            n &&
              (s = (function (e, t, n) {
                for (
                  var i, o, r, s, a = e.contents, l = e.dataTypes;
                  '*' === l[0];

                )
                  l.shift(),
                    void 0 === i &&
                      (i = e.mimeType || t.getResponseHeader('Content-Type'));
                if (i)
                  for (o in a)
                    if (a[o] && a[o].test(i)) {
                      l.unshift(o);
                      break;
                    }
                if (l[0] in n) r = l[0];
                else {
                  for (o in n) {
                    if (!l[0] || e.converters[o + ' ' + l[0]]) {
                      r = o;
                      break;
                    }
                    s = s || o;
                  }
                  r = r || s;
                }
                if (r) return r !== l[0] && l.unshift(r), n[r];
              })(p, b, n)),
            !i &&
              -1 < T.inArray('script', p.dataTypes) &&
              T.inArray('json', p.dataTypes) < 0 &&
              (p.converters['text script'] = function () {}),
            (s = (function (e, t, n, i) {
              var o,
                r,
                s,
                a,
                l,
                u = {},
                c = e.dataTypes.slice();
              if (c[1])
                for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
              for (r = c.shift(); r; )
                if (
                  (e.responseFields[r] && (n[e.responseFields[r]] = t),
                  !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (l = r),
                  (r = c.shift()))
                )
                  if ('*' === r) r = l;
                  else if ('*' !== l && l !== r) {
                    if (!(s = u[l + ' ' + r] || u['* ' + r]))
                      for (o in u)
                        if (
                          (a = o.split(' '))[1] === r &&
                          (s = u[l + ' ' + a[0]] || u['* ' + a[0]])
                        ) {
                          !0 === s
                            ? (s = u[o])
                            : !0 !== u[o] && ((r = a[0]), c.unshift(a[1]));
                          break;
                        }
                    if (!0 !== s)
                      if (s && e.throws) t = s(t);
                      else
                        try {
                          t = s(t);
                        } catch (e) {
                          return {
                            state: 'parsererror',
                            error: s
                              ? e
                              : 'No conversion from ' + l + ' to ' + r,
                          };
                        }
                  }
              return {
                state: 'success',
                data: t,
              };
            })(p, s, b, i)),
            i
              ? (p.ifModified &&
                  ((n = b.getResponseHeader('Last-Modified')) &&
                    (T.lastModified[u] = n),
                  (n = b.getResponseHeader('etag'))) &&
                  (T.etag[u] = n),
                204 === e || 'HEAD' === p.type
                  ? (a = 'nocontent')
                  : 304 === e
                  ? (a = 'notmodified')
                  : ((a = s.state), (o = s.data), (i = !(r = s.error))))
              : ((r = a), (!e && a) || ((a = 'error'), e < 0 && (e = 0))),
            (b.status = e),
            (b.statusText = (t || a) + ''),
            i ? v.resolveWith(g, [o, a, b]) : v.rejectWith(g, [b, a, r]),
            b.statusCode(_),
            (_ = void 0),
            f && m.trigger(i ? 'ajaxSuccess' : 'ajaxError', [b, p, i ? o : r]),
            y.fireWith(g, [b, a]),
            f &&
              (m.trigger('ajaxComplete', [b, p]),
              --T.active || T.event.trigger('ajaxStop')));
        }
      },
      getJSON: function (e, t, n) {
        return T.get(e, t, n, 'json');
      },
      getScript: function (e, t) {
        return T.get(e, void 0, t, 'script');
      },
    }),
    T.each(['get', 'post'], function (e, o) {
      T[o] = function (e, t, n, i) {
        return (
          y(t) && ((i = i || n), (n = t), (t = void 0)),
          T.ajax(
            T.extend(
              {
                url: e,
                type: o,
                dataType: i,
                data: t,
                success: n,
              },
              T.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    T.ajaxPrefilter(function (e) {
      for (var t in e.headers)
        'content-type' === t.toLowerCase() &&
          (e.contentType = e.headers[t] || '');
    }),
    (T._evalUrl = function (e, t, n) {
      return T.ajax({
        url: e,
        type: 'GET',
        dataType: 'script',
        cache: !0,
        async: !1,
        global: !1,
        converters: {
          'text script': function () {},
        },
        dataFilter: function (e) {
          T.globalEval(e, t, n);
        },
      });
    }),
    T.fn.extend({
      wrapAll: function (e) {
        return (
          this[0] &&
            (y(e) && (e = e.call(this[0])),
            (e = T(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && e.insertBefore(this[0]),
            e
              .map(function () {
                for (var e = this; e.firstElementChild; )
                  e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (n) {
        return y(n)
          ? this.each(function (e) {
              T(this).wrapInner(n.call(this, e));
            })
          : this.each(function () {
              var e = T(this),
                t = e.contents();
              t.length ? t.wrapAll(n) : e.append(n);
            });
      },
      wrap: function (t) {
        var n = y(t);
        return this.each(function (e) {
          T(this).wrapAll(n ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not('body')
            .each(function () {
              T(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (T.expr.pseudos.hidden = function (e) {
      return !T.expr.pseudos.visible(e);
    }),
    (T.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (T.ajaxSettings.xhr = function () {
      try {
        return new x.XMLHttpRequest();
      } catch (e) {}
    });
  var ei = {
      0: 200,
      1223: 204,
    },
    ti = T.ajaxSettings.xhr();
  (g.cors = !!ti && 'withCredentials' in ti),
    (g.ajax = ti = !!ti),
    T.ajaxTransport(function (o) {
      var r, s;
      if (g.cors || (ti && !o.crossDomain))
        return {
          send: function (e, t) {
            var n,
              i = o.xhr();
            if (
              (i.open(o.type, o.url, o.async, o.username, o.password),
              o.xhrFields)
            )
              for (n in o.xhrFields) i[n] = o.xhrFields[n];
            for (n in (o.mimeType &&
              i.overrideMimeType &&
              i.overrideMimeType(o.mimeType),
            o.crossDomain ||
              e['X-Requested-With'] ||
              (e['X-Requested-With'] = 'XMLHttpRequest'),
            e))
              i.setRequestHeader(n, e[n]);
            (r = function (e) {
              return function () {
                r &&
                  ((r =
                    s =
                    i.onload =
                    i.onerror =
                    i.onabort =
                    i.ontimeout =
                    i.onreadystatechange =
                      null),
                  'abort' === e
                    ? i.abort()
                    : 'error' === e
                    ? 'number' != typeof i.status
                      ? t(0, 'error')
                      : t(i.status, i.statusText)
                    : t(
                        ei[i.status] || i.status,
                        i.statusText,
                        'text' !== (i.responseType || 'text') ||
                          'string' != typeof i.responseText
                          ? {
                              binary: i.response,
                            }
                          : {
                              text: i.responseText,
                            },
                        i.getAllResponseHeaders()
                      ));
              };
            }),
              (i.onload = r()),
              (s = i.onerror = i.ontimeout = r('error')),
              void 0 !== i.onabort
                ? (i.onabort = s)
                : (i.onreadystatechange = function () {
                    4 === i.readyState &&
                      x.setTimeout(function () {
                        r && s();
                      });
                  }),
              (r = r('abort'));
            try {
              i.send((o.hasContent && o.data) || null);
            } catch (e) {
              if (r) throw e;
            }
          },
          abort: function () {
            r && r();
          },
        };
    }),
    T.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    T.ajaxSetup({
      accepts: {
        script:
          'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
      },
      contents: {
        script: /\b(?:java|ecma)script\b/,
      },
      converters: {
        'text script': function (e) {
          return T.globalEval(e), e;
        },
      },
    }),
    T.ajaxPrefilter('script', function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
    }),
    T.ajaxTransport('script', function (n) {
      var i, o;
      if (n.crossDomain || n.scriptAttrs)
        return {
          send: function (e, t) {
            (i = T('<script>')
              .attr(n.scriptAttrs || {})
              .prop({
                charset: n.scriptCharset,
                src: n.url,
              })
              .on(
                'load error',
                (o = function (e) {
                  i.remove(),
                    (o = null),
                    e && t('error' === e.type ? 404 : 200, e.type);
                })
              )),
              C.head.appendChild(i[0]);
          },
          abort: function () {
            o && o();
          },
        };
    });
  var ni = [],
    ii = /(=)\?(?=&|$)|\?\?/,
    oi =
      (T.ajaxSetup({
        jsonp: 'callback',
        jsonpCallback: function () {
          var e = ni.pop() || T.expando + '_' + On.guid++;
          return (this[e] = !0), e;
        },
      }),
      T.ajaxPrefilter('json jsonp', function (e, t, n) {
        var i,
          o,
          r,
          s =
            !1 !== e.jsonp &&
            (ii.test(e.url)
              ? 'url'
              : 'string' == typeof e.data &&
                0 ===
                  (e.contentType || '').indexOf(
                    'application/x-www-form-urlencoded'
                  ) &&
                ii.test(e.data) &&
                'data');
        if (s || 'jsonp' === e.dataTypes[0])
          return (
            (i = e.jsonpCallback =
              y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
            s
              ? (e[s] = e[s].replace(ii, '$1' + i))
              : !1 !== e.jsonp &&
                (e.url += (Pn.test(e.url) ? '&' : '?') + e.jsonp + '=' + i),
            (e.converters['script json'] = function () {
              return r || T.error(i + ' was not called'), r[0];
            }),
            (e.dataTypes[0] = 'json'),
            (o = x[i]),
            (x[i] = function () {
              r = arguments;
            }),
            n.always(function () {
              void 0 === o ? T(x).removeProp(i) : (x[i] = o),
                e[i] && ((e.jsonpCallback = t.jsonpCallback), ni.push(i)),
                r && y(o) && o(r[0]),
                (r = o = void 0);
            }),
            'script'
          );
      }),
      (g.createHTMLDocument =
        (((e = C.implementation.createHTMLDocument('').body).innerHTML =
          '<form></form><form></form>'),
        2 === e.childNodes.length)),
      (T.parseHTML = function (e, t, n) {
        return 'string' != typeof e
          ? []
          : ('boolean' == typeof t && ((n = t), (t = !1)),
            t ||
              (g.createHTMLDocument
                ? (((i = (t =
                    C.implementation.createHTMLDocument('')).createElement(
                    'base'
                  )).href = C.location.href),
                  t.head.appendChild(i))
                : (t = C)),
            (i = !n && []),
            (n = Xe.exec(e))
              ? [t.createElement(n[1])]
              : ((n = Dt([e], t, i)),
                i && i.length && T(i).remove(),
                T.merge([], n.childNodes)));
        var i;
      }),
      (T.fn.load = function (e, t, n) {
        var i,
          o,
          r,
          s = this,
          a = e.indexOf(' ');
        return (
          -1 < a && ((i = Dn(e.slice(a))), (e = e.slice(0, a))),
          y(t)
            ? ((n = t), (t = void 0))
            : t && 'object' == typeof t && (o = 'POST'),
          0 < s.length &&
            T.ajax({
              url: e,
              type: o || 'GET',
              dataType: 'html',
              data: t,
            })
              .done(function (e) {
                (r = arguments),
                  s.html(i ? T('<div>').append(T.parseHTML(e)).find(i) : e);
              })
              .always(
                n &&
                  function (e, t) {
                    s.each(function () {
                      n.apply(this, r || [e.responseText, t, e]);
                    });
                  }
              ),
          this
        );
      }),
      (T.expr.pseudos.animated = function (t) {
        return T.grep(T.timers, function (e) {
          return t === e.elem;
        }).length;
      }),
      (T.offset = {
        setOffset: function (e, t, n) {
          var i,
            o,
            r,
            s,
            a = T.css(e, 'position'),
            l = T(e),
            u = {};
          'static' === a && (e.style.position = 'relative'),
            (r = l.offset()),
            (i = T.css(e, 'top')),
            (s = T.css(e, 'left')),
            (a =
              ('absolute' === a || 'fixed' === a) &&
              -1 < (i + s).indexOf('auto')
                ? ((o = (a = l.position()).top), a.left)
                : ((o = parseFloat(i) || 0), parseFloat(s) || 0)),
            null != (t = y(t) ? t.call(e, n, T.extend({}, r)) : t).top &&
              (u.top = t.top - r.top + o),
            null != t.left && (u.left = t.left - r.left + a),
            'using' in t ? t.using.call(e, u) : l.css(u);
        },
      }),
      T.fn.extend({
        offset: function (t) {
          var e, n;
          return arguments.length
            ? void 0 === t
              ? this
              : this.each(function (e) {
                  T.offset.setOffset(this, t, e);
                })
            : (n = this[0])
            ? n.getClientRects().length
              ? ((e = n.getBoundingClientRect()),
                (n = n.ownerDocument.defaultView),
                {
                  top: e.top + n.pageYOffset,
                  left: e.left + n.pageXOffset,
                })
              : {
                  top: 0,
                  left: 0,
                }
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              n,
              i = this[0],
              o = {
                top: 0,
                left: 0,
              };
            if ('fixed' === T.css(i, 'position')) t = i.getBoundingClientRect();
            else {
              for (
                t = this.offset(),
                  n = i.ownerDocument,
                  e = i.offsetParent || n.documentElement;
                e &&
                (e === n.body || e === n.documentElement) &&
                'static' === T.css(e, 'position');

              )
                e = e.parentNode;
              e &&
                e !== i &&
                1 === e.nodeType &&
                (((o = T(e).offset()).top += T.css(e, 'borderTopWidth', !0)),
                (o.left += T.css(e, 'borderLeftWidth', !0)));
            }
            return {
              top: t.top - o.top - T.css(i, 'marginTop', !0),
              left: t.left - o.left - T.css(i, 'marginLeft', !0),
            };
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent;
              e && 'static' === T.css(e, 'position');

            )
              e = e.offsetParent;
            return e || vt;
          });
        },
      }),
      T.each(
        {
          scrollLeft: 'pageXOffset',
          scrollTop: 'pageYOffset',
        },
        function (t, o) {
          var r = 'pageYOffset' === o;
          T.fn[t] = function (e) {
            return c(
              this,
              function (e, t, n) {
                var i;
                if (
                  (R(e) ? (i = e) : 9 === e.nodeType && (i = e.defaultView),
                  void 0 === n)
                )
                  return i ? i[o] : e[t];
                i
                  ? i.scrollTo(r ? i.pageXOffset : n, r ? n : i.pageYOffset)
                  : (e[t] = n);
              },
              t,
              e,
              arguments.length
            );
          };
        }
      ),
      T.each(['top', 'left'], function (e, n) {
        T.cssHooks[n] = nn(g.pixelPosition, function (e, t) {
          if (t)
            return (t = tn(e, n)), Gt.test(t) ? T(e).position()[n] + 'px' : t;
        });
      }),
      T.each(
        {
          Height: 'height',
          Width: 'width',
        },
        function (s, a) {
          T.each(
            {
              padding: 'inner' + s,
              content: a,
              '': 'outer' + s,
            },
            function (i, r) {
              T.fn[r] = function (e, t) {
                var n = arguments.length && (i || 'boolean' != typeof e),
                  o = i || (!0 === e || !0 === t ? 'margin' : 'border');
                return c(
                  this,
                  function (e, t, n) {
                    var i;
                    return R(e)
                      ? 0 === r.indexOf('outer')
                        ? e['inner' + s]
                        : e.document.documentElement['client' + s]
                      : 9 === e.nodeType
                      ? ((i = e.documentElement),
                        Math.max(
                          e.body['scroll' + s],
                          i['scroll' + s],
                          e.body['offset' + s],
                          i['offset' + s],
                          i['client' + s]
                        ))
                      : void 0 === n
                      ? T.css(e, t, o)
                      : T.style(e, t, n, o);
                  },
                  a,
                  n ? e : void 0,
                  n
                );
              };
            }
          );
        }
      ),
      T.each(
        [
          'ajaxStart',
          'ajaxStop',
          'ajaxComplete',
          'ajaxError',
          'ajaxSuccess',
          'ajaxSend',
        ],
        function (e, t) {
          T.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      T.fn.extend({
        bind: function (e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, n, i) {
          return this.on(t, e, n, i);
        },
        undelegate: function (e, t, n) {
          return 1 === arguments.length
            ? this.off(e, '**')
            : this.off(t, e || '**', n);
        },
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
      }),
      T.each(
        'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
          ' '
        ),
        function (e, n) {
          T.fn[n] = function (e, t) {
            return 0 < arguments.length
              ? this.on(n, null, e, t)
              : this.trigger(n);
          };
        }
      ),
      /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g),
    ri =
      ((T.proxy = function (e, t) {
        var n, i;
        if (('string' == typeof t && ((i = e[t]), (t = e), (e = i)), y(e)))
          return (
            (n = a.call(arguments, 2)),
            ((i = function () {
              return e.apply(t || this, n.concat(a.call(arguments)));
            }).guid = e.guid =
              e.guid || T.guid++),
            i
          );
      }),
      (T.holdReady = function (e) {
        e ? T.readyWait++ : T.ready(!0);
      }),
      (T.isArray = Array.isArray),
      (T.parseJSON = JSON.parse),
      (T.nodeName = b),
      (T.isFunction = y),
      (T.isWindow = R),
      (T.camelCase = j),
      (T.type = X),
      (T.now = Date.now),
      (T.isNumeric = function (e) {
        var t = T.type(e);
        return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
      }),
      (T.trim = function (e) {
        return null == e ? '' : (e + '').replace(oi, '$1');
      }),
      'function' == typeof define &&
        define.amd &&
        define('jquery', [], function () {
          return T;
        }),
      x.jQuery),
    si = x.$;
  return (
    (T.noConflict = function (e) {
      return x.$ === T && (x.$ = si), e && x.jQuery === T && (x.jQuery = ri), T;
    }),
    void 0 === L && (x.jQuery = x.$ = T),
    T
  );
}),
  (function (e, t) {
    'object' == typeof exports && 'undefined' != typeof module
      ? (module.exports = t())
      : 'function' == typeof define && define.amd
      ? define(t)
      : (e.Popper = t());
  })(this, function () {
    'use strict';

    function s(e) {
      return e && '[object Function]' === {}.toString.call(e);
    }

    function h(e, t) {
      return 1 !== e.nodeType
        ? []
        : ((e = e.ownerDocument.defaultView.getComputedStyle(e, null)),
          t ? e[t] : e);
    }

    function l(e) {
      return 'HTML' === e.nodeName ? e : e.parentNode || e.host;
    }

    function c(e) {
      if (!e) return document.body;
      switch (e.nodeName) {
        case 'HTML':
        case 'BODY':
          return e.ownerDocument.body;
        case '#document':
          return e.body;
      }
      var t = h(e),
        n = t.overflow,
        i = t.overflowX,
        t = t.overflowY;
      return /(auto|scroll|overlay)/.test(n + t + i) ? e : c(l(e));
    }

    function u(e) {
      return e && e.referenceNode ? e.referenceNode : e;
    }

    function d(e) {
      return 11 === e ? X : (10 !== e && X) || Y;
    }

    function f(e) {
      if (!e) return document.documentElement;
      for (
        var t = d(10) ? document.body : null, n = e.offsetParent || null;
        n === t && e.nextElementSibling;

      )
        n = (e = e.nextElementSibling).offsetParent;
      var i = n && n.nodeName;
      return i && 'BODY' !== i && 'HTML' !== i
        ? -1 !== ['TH', 'TD', 'TABLE'].indexOf(n.nodeName) &&
          'static' === h(n, 'position')
          ? f(n)
          : n
        : (e ? e.ownerDocument : document).documentElement;
    }

    function r(e) {
      return null === e.parentNode ? e : r(e.parentNode);
    }

    function p(e, t) {
      var n, i, o;
      return e && e.nodeType && t && t.nodeType
        ? ((i = (o =
            e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING)
            ? e
            : t),
          (o = o ? t : e),
          (n = document.createRange()).setStart(i, 0),
          n.setEnd(o, 0),
          (e !== (n = n.commonAncestorContainer) && t !== n) || i.contains(o)
            ? 'BODY' === (o = (i = n).nodeName) ||
              ('HTML' !== o && f(i.firstElementChild) !== i)
              ? f(n)
              : n
            : (o = r(e)).host
            ? p(o.host, t)
            : p(e, r(t).host))
        : document.documentElement;
    }

    function g(e, t) {
      var t =
          'top' === (1 < arguments.length && void 0 !== t ? t : 'top')
            ? 'scrollTop'
            : 'scrollLeft',
        n = e.nodeName;
      return (
        'BODY' === n || 'HTML' === n
          ? ((n = e.ownerDocument.documentElement),
            e.ownerDocument.scrollingElement || n)
          : e
      )[t];
    }

    function o(e, t) {
      var t = 'x' === t ? 'Left' : 'Top',
        n = 'Left' == t ? 'Right' : 'Bottom';
      return (
        parseFloat(e['border' + t + 'Width']) +
        parseFloat(e['border' + n + 'Width'])
      );
    }

    function i(e, t, n, i) {
      return j(
        t['offset' + e],
        t['scroll' + e],
        n['client' + e],
        n['offset' + e],
        n['scroll' + e],
        d(10)
          ? parseInt(n['offset' + e]) +
              parseInt(i['margin' + ('Height' === e ? 'Top' : 'Left')]) +
              parseInt(i['margin' + ('Height' === e ? 'Bottom' : 'Right')])
          : 0
      );
    }

    function m(e) {
      var t = e.body,
        e = e.documentElement,
        n = d(10) && getComputedStyle(e);
      return {
        height: i('Height', t, e, n),
        width: i('Width', t, e, n),
      };
    }

    function v(e) {
      return O({}, e, {
        right: e.left + e.width,
        bottom: e.top + e.height,
      });
    }

    function y(e) {
      var t = {};
      try {
        d(10)
          ? ((t = e.getBoundingClientRect()),
            (n = g(e, 'top')),
            (i = g(e, 'left')),
            (t.top += n),
            (t.left += i),
            (t.bottom += n),
            (t.right += i))
          : (t = e.getBoundingClientRect());
      } catch (e) {}
      var n = {
          left: t.left,
          top: t.top,
          width: t.right - t.left,
          height: t.bottom - t.top,
        },
        i = 'HTML' === e.nodeName ? m(e.ownerDocument) : {},
        t = i.width || e.clientWidth || n.width,
        i = i.height || e.clientHeight || n.height,
        t = e.offsetWidth - t,
        i = e.offsetHeight - i;
      return (
        (t || i) &&
          ((t -= o((e = h(e)), 'x')),
          (i -= o(e, 'y')),
          (n.width -= t),
          (n.height -= i)),
        v(n)
      );
    }

    function _(e, t, n) {
      var n = 2 < arguments.length && void 0 !== n && n,
        i = d(10),
        o = 'HTML' === t.nodeName,
        r = y(e),
        s = y(t),
        e = c(e),
        a = h(t),
        l = parseFloat(a.borderTopWidth),
        u = parseFloat(a.borderLeftWidth),
        s =
          (n && o && ((s.top = j(s.top, 0)), (s.left = j(s.left, 0))),
          v({
            top: r.top - s.top - l,
            left: r.left - s.left - u,
            width: r.width,
            height: r.height,
          }));
      return (
        (s.marginTop = 0),
        (s.marginLeft = 0),
        !i &&
          o &&
          ((r = parseFloat(a.marginTop)),
          (o = parseFloat(a.marginLeft)),
          (s.top -= l - r),
          (s.bottom -= l - r),
          (s.left -= u - o),
          (s.right -= u - o),
          (s.marginTop = r),
          (s.marginLeft = o)),
        (s = (i && !n ? t.contains(e) : t === e && 'BODY' !== e.nodeName)
          ? (function (e, t, n) {
              var n = 2 < arguments.length && void 0 !== n && n,
                i = g(t, 'top'),
                t = g(t, 'left'),
                n = n ? -1 : 1;
              return (
                (e.top += i * n),
                (e.bottom += i * n),
                (e.left += t * n),
                (e.right += t * n),
                e
              );
            })(s, t)
          : s)
      );
    }

    function b(e) {
      if (!e || !e.parentElement || d()) return document.documentElement;
      for (var t = e.parentElement; t && 'none' === h(t, 'transform'); )
        t = t.parentElement;
      return t || document.documentElement;
    }

    function w(e, t, n, i, o) {
      var r,
        o = 4 < arguments.length && void 0 !== o && o,
        s = {
          top: 0,
          left: 0,
        },
        a = o ? b(e) : p(e, u(t)),
        a =
          ('viewport' === i
            ? (s = (function (e, t) {
                var t = 1 < arguments.length && void 0 !== t && t,
                  n = e.ownerDocument.documentElement,
                  e = _(e, n),
                  i = j(n.clientWidth, window.innerWidth || 0),
                  o = j(n.clientHeight, window.innerHeight || 0),
                  r = t ? 0 : g(n),
                  t = t ? 0 : g(n, 'left');
                return v({
                  top: r - e.top + e.marginTop,
                  left: t - e.left + e.marginLeft,
                  width: i,
                  height: o,
                });
              })(a, o))
            : ('scrollParent' === i
                ? 'BODY' === (r = c(l(t))).nodeName &&
                  (r = e.ownerDocument.documentElement)
                : (r = 'window' === i ? e.ownerDocument.documentElement : i),
              (t = _(r, a, o)),
              'HTML' !== r.nodeName ||
              (function e(t) {
                var n = t.nodeName;
                return (
                  'BODY' !== n &&
                  'HTML' !== n &&
                  ('fixed' === h(t, 'position') || (!!(n = l(t)) && e(n)))
                );
              })(a)
                ? (s = t)
                : ((o = (i = m(e.ownerDocument)).height),
                  (r = i.width),
                  (s.top += t.top - t.marginTop),
                  (s.bottom = o + t.top),
                  (s.left += t.left - t.marginLeft),
                  (s.right = r + t.left))),
          'number' == typeof (n = n || 0));
      return (
        (s.left += a ? n : n.left || 0),
        (s.top += a ? n : n.top || 0),
        (s.right -= a ? n : n.right || 0),
        (s.bottom -= a ? n : n.bottom || 0),
        s
      );
    }

    function a(e, t, n, i, o, r) {
      var s,
        r = 5 < arguments.length && void 0 !== r ? r : 0;
      return -1 === e.indexOf('auto')
        ? e
        : ((i = w(n, i, r, o)),
          (s = {
            top: {
              width: i.width,
              height: t.top - i.top,
            },
            right: {
              width: i.right - t.right,
              height: i.height,
            },
            bottom: {
              width: i.width,
              height: i.bottom - t.bottom,
            },
            left: {
              width: t.left - i.left,
              height: i.height,
            },
          }),
          (0 <
          (o = (r = Object.keys(s)
            .map(function (e) {
              return O(
                {
                  key: e,
                },
                s[e],
                {
                  area: (e = s[e]).width * e.height,
                }
              );
            })
            .sort(function (e, t) {
              return t.area - e.area;
            })).filter(function (e) {
            var t = e.width,
              e = e.height;
            return t >= n.clientWidth && e >= n.clientHeight;
          })).length
            ? o
            : r)[0].key + ((t = e.split('-')[1]) ? '-' + t : ''));
    }

    function x(e, t, n, i) {
      i = 3 < arguments.length && void 0 !== i ? i : null;
      return _(n, i ? b(t) : p(t, u(n)), i);
    }

    function C(e) {
      var t = e.ownerDocument.defaultView.getComputedStyle(e),
        n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
        t = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
      return {
        width: e.offsetWidth + t,
        height: e.offsetHeight + n,
      };
    }

    function T(e) {
      var t = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom',
      };
      return e.replace(/left|right|bottom|top/g, function (e) {
        return t[e];
      });
    }

    function E(e, t, n) {
      n = n.split('-')[0];
      var e = C(e),
        i = {
          width: e.width,
          height: e.height,
        },
        o = -1 !== ['right', 'left'].indexOf(n),
        r = o ? 'top' : 'left',
        s = o ? 'left' : 'top',
        a = o ? 'height' : 'width',
        o = o ? 'width' : 'height';
      return (
        (i[r] = t[r] + t[a] / 2 - e[a] / 2),
        (i[s] = n === s ? t[s] - e[o] : t[T(s)]),
        i
      );
    }

    function S(e, t) {
      return Array.prototype.find ? e.find(t) : e.filter(t)[0];
    }

    function k(e, n, t) {
      var i, o;
      return (
        (void 0 === t
          ? e
          : e.slice(
              0,
              ((e = e),
              (i = 'name'),
              (o = t),
              Array.prototype.findIndex
                ? e.findIndex(function (e) {
                    return e[i] === o;
                  })
                : ((t = S(e, function (e) {
                    return e[i] === o;
                  })),
                  e.indexOf(t)))
            )
        ).forEach(function (e) {
          e.function &&
            console.warn(
              '`modifier.function` is deprecated, use `modifier.fn`!'
            );
          var t = e.function || e.fn;
          e.enabled &&
            s(t) &&
            ((n.offsets.popper = v(n.offsets.popper)),
            (n.offsets.reference = v(n.offsets.reference)),
            (n = t(n, e)));
        }),
        n
      );
    }

    function t(e, n) {
      return e.some(function (e) {
        var t = e.name;
        return e.enabled && t === n;
      });
    }

    function D(e) {
      for (
        var t = [!1, 'ms', 'Webkit', 'Moz', 'O'],
          n = e.charAt(0).toUpperCase() + e.slice(1),
          i = 0;
        i < t.length;
        i++
      ) {
        var o = t[i],
          o = o ? '' + o + n : e;
        if (void 0 !== document.body.style[o]) return o;
      }
      return null;
    }

    function R(e) {
      e = e.ownerDocument;
      return e ? e.defaultView : window;
    }

    function z(e, t, n, i) {
      (n.updateBound = i),
        R(e).addEventListener('resize', n.updateBound, {
          passive: !0,
        });
      i = c(e);
      return (
        (function e(t, n, i, o) {
          var r = 'BODY' === t.nodeName,
            t = r ? t.ownerDocument.defaultView : t;
          t.addEventListener(n, i, {
            passive: !0,
          }),
            r || e(c(t.parentNode), n, i, o),
            o.push(t);
        })(i, 'scroll', n.updateBound, n.scrollParents),
        (n.scrollElement = i),
        (n.eventsEnabled = !0),
        n
      );
    }

    function M() {
      var e, t;
      this.state.eventsEnabled &&
        (cancelAnimationFrame(this.scheduleUpdate),
        (this.state =
          ((e = this.reference),
          (t = this.state),
          R(e).removeEventListener('resize', t.updateBound),
          t.scrollParents.forEach(function (e) {
            e.removeEventListener('scroll', t.updateBound);
          }),
          (t.updateBound = null),
          (t.scrollParents = []),
          (t.scrollElement = null),
          (t.eventsEnabled = !1),
          t)));
    }

    function A(e) {
      return '' !== e && !isNaN(parseFloat(e)) && isFinite(e);
    }

    function N(n, i) {
      Object.keys(i).forEach(function (e) {
        var t = '';
        -1 !==
          ['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(e) &&
          A(i[e]) &&
          (t = 'px'),
          (n.style[e] = i[e] + t);
      });
    }

    function q(e, t) {
      function n(e) {
        return e;
      }
      var i = e.offsets,
        o = i.popper,
        i = i.reference,
        r = Q,
        i = r(i.width),
        s = r(o.width),
        a = -1 !== ['left', 'right'].indexOf(e.placement),
        e = -1 !== e.placement.indexOf('-'),
        a = t ? (a || e || i % 2 == s % 2 ? r : $) : n,
        r = t ? r : n;
      return {
        left: a(1 == i % 2 && 1 == s % 2 && !e && t ? o.left - 1 : o.left),
        top: r(o.top),
        bottom: r(o.bottom),
        right: a(o.right),
      };
    }

    function H(e, t, n) {
      var i,
        o = S(e, function (e) {
          return e.name === t;
        }),
        e =
          !!o &&
          e.some(function (e) {
            return e.name === n && e.enabled && e.order < o.order;
          });
      return (
        e ||
          ((i = '`' + t + '`'),
          console.warn(
            '`' +
              n +
              '` modifier is required by ' +
              i +
              ' modifier in order to work, be sure to include it before ' +
              i +
              '!'
          )),
        e
      );
    }

    function F(e, t) {
      (t = 1 < arguments.length && void 0 !== t && t),
        (e = P.indexOf(e)),
        (e = P.slice(e + 1).concat(P.slice(0, e)));
      return t ? e.reverse() : e;
    }

    function W(e, a, l, t) {
      var o = [0, 0],
        i = -1 !== ['right', 'left'].indexOf(t),
        t = e.split(/(\+|\-)/).map(function (e) {
          return e.trim();
        }),
        e = t.indexOf(
          S(t, function (e) {
            return -1 !== e.search(/,|\s/);
          })
        ),
        n =
          (t[e] &&
            -1 === t[e].indexOf(',') &&
            console.warn(
              'Offsets separated by white space(s) are deprecated, use a comma (,) instead.'
            ),
          /\s*,\s*|\s+/);
      return (
        (-1 === e
          ? [t]
          : [
              t.slice(0, e).concat([t[e].split(n)[0]]),
              [t[e].split(n)[1]].concat(t.slice(e + 1)),
            ]
        )
          .map(function (e, t) {
            var s = (1 === t ? !i : i) ? 'height' : 'width',
              n = !1;
            return e
              .reduce(function (e, t) {
                return '' === e[e.length - 1] && -1 !== ['+', '-'].indexOf(t)
                  ? ((e[e.length - 1] = t), (n = !0), e)
                  : n
                  ? ((e[e.length - 1] += t), (n = !1), e)
                  : e.concat(t);
              }, [])
              .map(function (e) {
                return (
                  (t = s),
                  (n = a),
                  (i = l),
                  (o = +(r = (e = e).match(/((?:\-|\+)?\d*\.?\d*)(.*)/))[1]),
                  (r = r[2]),
                  o
                    ? 0 === r.indexOf('%')
                      ? (v('%p' === r ? n : i)[t] / 100) * o
                      : 'vh' === r || 'vw' === r
                      ? (('vh' === r
                          ? j(
                              document.documentElement.clientHeight,
                              window.innerHeight || 0
                            )
                          : j(
                              document.documentElement.clientWidth,
                              window.innerWidth || 0
                            )) /
                          100) *
                        o
                      : o
                    : e
                );
                var t, n, i, o, r;
              });
          })
          .forEach(function (n, i) {
            n.forEach(function (e, t) {
              A(e) && (o[i] += e * ('-' === n[t - 1] ? -1 : 1));
            });
          }),
        o
      );
    }

    function I(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    var B = Math.min,
      $ = Math.floor,
      Q = Math.round,
      j = Math.max,
      n =
        'undefined' != typeof window &&
        'undefined' != typeof document &&
        'undefined' != typeof navigator,
      U = (function () {
        for (
          var e = ['Edge', 'Trident', 'Firefox'], t = 0;
          t < e.length;
          t += 1
        )
          if (n && 0 <= navigator.userAgent.indexOf(e[t])) return 1;
        return 0;
      })(),
      V =
        n && window.Promise
          ? function (e) {
              var t = !1;
              return function () {
                t ||
                  ((t = !0),
                  window.Promise.resolve().then(function () {
                    (t = !1), e();
                  }));
              };
            }
          : function (e) {
              var t = !1;
              return function () {
                t ||
                  ((t = !0),
                  setTimeout(function () {
                    (t = !1), e();
                  }, U));
              };
            },
      X = n && !(!window.MSInputMethodContext || !document.documentMode),
      Y = n && /MSIE 10/.test(navigator.userAgent),
      e = function (e, t, n) {
        return t && te(e.prototype, t), n && te(e, n), e;
      },
      O =
        Object.assign ||
        function (e) {
          for (var t, n = 1; n < arguments.length; n++)
            for (var i in (t = arguments[n]))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        },
      K = n && /Firefox/i.test(navigator.userAgent),
      J = [
        'auto-start',
        'auto',
        'auto-end',
        'top-start',
        'top',
        'top-end',
        'right-start',
        'right',
        'right-end',
        'bottom-end',
        'bottom',
        'bottom-start',
        'left-end',
        'left',
        'left-start',
      ],
      P = J.slice(3),
      G = 'flip',
      Z = 'clockwise',
      ee = 'counterclockwise',
      e =
        (e(L, [
          {
            key: 'update',
            value: function () {
              return function () {
                var e;
                this.state.isDestroyed ||
                  (((e = {
                    instance: this,
                    styles: {},
                    arrowStyles: {},
                    attributes: {},
                    flipped: !1,
                    offsets: {},
                  }).offsets.reference = x(
                    this.state,
                    this.popper,
                    this.reference,
                    this.options.positionFixed
                  )),
                  (e.placement = a(
                    this.options.placement,
                    e.offsets.reference,
                    this.popper,
                    this.reference,
                    this.options.modifiers.flip.boundariesElement,
                    this.options.modifiers.flip.padding
                  )),
                  (e.originalPlacement = e.placement),
                  (e.positionFixed = this.options.positionFixed),
                  (e.offsets.popper = E(
                    this.popper,
                    e.offsets.reference,
                    e.placement
                  )),
                  (e.offsets.popper.position = this.options.positionFixed
                    ? 'fixed'
                    : 'absolute'),
                  (e = k(this.modifiers, e)),
                  this.state.isCreated
                    ? this.options.onUpdate(e)
                    : ((this.state.isCreated = !0), this.options.onCreate(e)));
              }.call(this);
            },
          },
          {
            key: 'destroy',
            value: function () {
              return function () {
                return (
                  (this.state.isDestroyed = !0),
                  t(this.modifiers, 'applyStyle') &&
                    (this.popper.removeAttribute('x-placement'),
                    (this.popper.style.position = ''),
                    (this.popper.style.top = ''),
                    (this.popper.style.left = ''),
                    (this.popper.style.right = ''),
                    (this.popper.style.bottom = ''),
                    (this.popper.style.willChange = ''),
                    (this.popper.style[D('transform')] = '')),
                  this.disableEventListeners(),
                  this.options.removeOnDestroy &&
                    this.popper.parentNode.removeChild(this.popper),
                  this
                );
              }.call(this);
            },
          },
          {
            key: 'enableEventListeners',
            value: function () {
              return function () {
                this.state.eventsEnabled ||
                  (this.state = z(
                    this.reference,
                    this.options,
                    this.state,
                    this.scheduleUpdate
                  ));
              }.call(this);
            },
          },
          {
            key: 'disableEventListeners',
            value: function () {
              return M.call(this);
            },
          },
        ]),
        L);

    function L(e, t) {
      var n = this,
        i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
        o = this,
        r = L;
      if (!(o instanceof r))
        throw new TypeError('Cannot call a class as a function');
      (this.scheduleUpdate = function () {
        return requestAnimationFrame(n.update);
      }),
        (this.update = V(this.update.bind(this))),
        (this.options = O({}, L.Defaults, i)),
        (this.state = {
          isDestroyed: !1,
          isCreated: !1,
          scrollParents: [],
        }),
        (this.reference = e && e.jquery ? e[0] : e),
        (this.popper = t && t.jquery ? t[0] : t),
        (this.options.modifiers = {}),
        Object.keys(O({}, L.Defaults.modifiers, i.modifiers)).forEach(function (
          e
        ) {
          n.options.modifiers[e] = O(
            {},
            L.Defaults.modifiers[e] || {},
            i.modifiers ? i.modifiers[e] : {}
          );
        }),
        (this.modifiers = Object.keys(this.options.modifiers)
          .map(function (e) {
            return O(
              {
                name: e,
              },
              n.options.modifiers[e]
            );
          })
          .sort(function (e, t) {
            return e.order - t.order;
          })),
        this.modifiers.forEach(function (e) {
          e.enabled &&
            s(e.onLoad) &&
            e.onLoad(n.reference, n.popper, n.options, e, n.state);
        }),
        this.update();
      o = this.options.eventsEnabled;
      o && this.enableEventListeners(), (this.state.eventsEnabled = o);
    }

    function te(e, t) {
      for (var n, i = 0; i < t.length; i++)
        ((n = t[i]).enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
    }
    return (
      (e.Utils = ('undefined' == typeof window ? global : window).PopperUtils),
      (e.placements = J),
      (e.Defaults = {
        placement: 'bottom',
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function () {},
        onUpdate: function () {},
        modifiers: {
          shift: {
            order: 100,
            enabled: !0,
            fn: function (e) {
              var t,
                n,
                i,
                o = e.placement,
                r = o.split('-')[0],
                o = o.split('-')[1];
              return (
                o &&
                  ((t = (n = e.offsets).reference),
                  (n = n.popper),
                  (i = (r = -1 !== ['bottom', 'top'].indexOf(r))
                    ? 'width'
                    : 'height'),
                  (r = {
                    start: I({}, (r = r ? 'left' : 'top'), t[r]),
                    end: I({}, r, t[r] + t[i] - n[i]),
                  }),
                  (e.offsets.popper = O({}, n, r[o]))),
                e
              );
            },
          },
          offset: {
            order: 200,
            enabled: !0,
            fn: function (e, t) {
              var t = t.offset,
                n = e.placement,
                i = (o = e.offsets).popper,
                o = o.reference,
                n = n.split('-')[0],
                t = A(+t) ? [+t, 0] : W(t, i, o, n);
              return (
                'left' === n
                  ? ((i.top += t[0]), (i.left -= t[1]))
                  : 'right' === n
                  ? ((i.top += t[0]), (i.left += t[1]))
                  : 'top' === n
                  ? ((i.left += t[0]), (i.top -= t[1]))
                  : 'bottom' === n && ((i.left += t[0]), (i.top += t[1])),
                (e.popper = i),
                e
              );
            },
            offset: 0,
          },
          preventOverflow: {
            order: 300,
            enabled: !0,
            fn: function (e, i) {
              var t = i.boundariesElement || f(e.instance.popper),
                n = (e.instance.reference === t && (t = f(t)), D('transform')),
                o = e.instance.popper.style,
                r = o.top,
                s = o.left,
                a = o[n],
                l =
                  ((o.top = ''),
                  (o.left = ''),
                  (o[n] = ''),
                  w(
                    e.instance.popper,
                    e.instance.reference,
                    i.padding,
                    t,
                    e.positionFixed
                  )),
                t =
                  ((o.top = r),
                  (o.left = s),
                  (o[n] = a),
                  (i.boundaries = l),
                  i.priority),
                u = e.offsets.popper,
                c = {
                  primary: function (e) {
                    var t = u[e];
                    return (
                      u[e] < l[e] &&
                        !i.escapeWithReference &&
                        (t = j(u[e], l[e])),
                      I({}, e, t)
                    );
                  },
                  secondary: function (e) {
                    var t = 'right' === e ? 'left' : 'top',
                      n = u[t];
                    return (
                      u[e] > l[e] &&
                        !i.escapeWithReference &&
                        (n = B(
                          u[t],
                          l[e] - ('right' === e ? u.width : u.height)
                        )),
                      I({}, t, n)
                    );
                  },
                };
              return (
                t.forEach(function (e) {
                  var t =
                    -1 === ['left', 'top'].indexOf(e) ? 'secondary' : 'primary';
                  u = O({}, u, c[t](e));
                }),
                (e.offsets.popper = u),
                e
              );
            },
            priority: ['left', 'right', 'top', 'bottom'],
            padding: 5,
            boundariesElement: 'scrollParent',
          },
          keepTogether: {
            order: 400,
            enabled: !0,
            fn: function (e) {
              var t = e.offsets,
                n = t.popper,
                t = t.reference,
                i = e.placement.split('-')[0],
                o = $,
                i = -1 !== ['top', 'bottom'].indexOf(i),
                r = i ? 'right' : 'bottom',
                s = i ? 'left' : 'top',
                i = i ? 'width' : 'height';
              return (
                n[r] < o(t[s]) && (e.offsets.popper[s] = o(t[s]) - n[i]),
                n[s] > o(t[r]) && (e.offsets.popper[s] = o(t[r])),
                e
              );
            },
          },
          arrow: {
            order: 500,
            enabled: !0,
            fn: function (e, t) {
              if (H(e.instance.modifiers, 'arrow', 'keepTogether')) {
                t = t.element;
                if ('string' == typeof t) {
                  if (!(t = e.instance.popper.querySelector(t))) return e;
                } else if (!e.instance.popper.contains(t))
                  return (
                    console.warn(
                      'WARNING: `arrow.element` must be child of its popper element!'
                    ),
                    e
                  );
                var n = e.placement.split('-')[0],
                  i = e.offsets,
                  o = i.popper,
                  i = i.reference,
                  n = -1 !== ['left', 'right'].indexOf(n),
                  r = n ? 'height' : 'width',
                  s = n ? 'Top' : 'Left',
                  a = s.toLowerCase(),
                  l = n ? 'left' : 'top',
                  n = n ? 'bottom' : 'right',
                  u = C(t)[r],
                  n =
                    (i[n] - u < o[a] &&
                      (e.offsets.popper[a] -= o[a] - (i[n] - u)),
                    i[a] + u > o[n] && (e.offsets.popper[a] += i[a] + u - o[n]),
                    (e.offsets.popper = v(e.offsets.popper)),
                    i[a] + i[r] / 2 - u / 2),
                  i = h(e.instance.popper),
                  c = parseFloat(i['margin' + s]),
                  i = parseFloat(i['border' + s + 'Width']),
                  s = n - e.offsets.popper[a] - c - i,
                  s = j(B(o[r] - u, s), 0);
                (e.arrowElement = t),
                  (e.offsets.arrow = (I((n = {}), a, Q(s)), I(n, l, ''), n));
              }
              return e;
            },
            element: '[x-arrow]',
          },
          flip: {
            order: 600,
            enabled: !0,
            fn: function (u, c) {
              if (
                !(
                  t(u.instance.modifiers, 'inner') ||
                  (u.flipped && u.placement === u.originalPlacement)
                )
              ) {
                var h = w(
                    u.instance.popper,
                    u.instance.reference,
                    c.padding,
                    c.boundariesElement,
                    u.positionFixed
                  ),
                  d = u.placement.split('-')[0],
                  f = T(d),
                  p = u.placement.split('-')[1] || '',
                  g = [];
                switch (c.behavior) {
                  case G:
                    g = [d, f];
                    break;
                  case Z:
                    g = F(d);
                    break;
                  case ee:
                    g = F(d, !0);
                    break;
                  default:
                    g = c.behavior;
                }
                g.forEach(function (e, t) {
                  if (d !== e || g.length === t + 1) return u;
                  (d = u.placement.split('-')[0]), (f = T(d));
                  var e = u.offsets.popper,
                    n = u.offsets.reference,
                    i = $,
                    n =
                      ('left' === d && i(e.right) > i(n.left)) ||
                      ('right' === d && i(e.left) < i(n.right)) ||
                      ('top' === d && i(e.bottom) > i(n.top)) ||
                      ('bottom' === d && i(e.top) < i(n.bottom)),
                    o = i(e.left) < i(h.left),
                    r = i(e.right) > i(h.right),
                    s = i(e.top) < i(h.top),
                    e = i(e.bottom) > i(h.bottom),
                    i =
                      ('left' === d && o) ||
                      ('right' === d && r) ||
                      ('top' === d && s) ||
                      ('bottom' === d && e),
                    a = -1 !== ['top', 'bottom'].indexOf(d),
                    l =
                      !!c.flipVariations &&
                      ((a && 'start' === p && o) ||
                        (a && 'end' === p && r) ||
                        (!a && 'start' === p && s) ||
                        (!a && 'end' === p && e)),
                    r =
                      !!c.flipVariationsByContent &&
                      ((a && 'start' === p && r) ||
                        (a && 'end' === p && o) ||
                        (!a && 'start' === p && e) ||
                        (!a && 'end' === p && s)),
                    o = l || r;
                  (n || i || o) &&
                    ((u.flipped = !0),
                    (n || i) && (d = g[t + 1]),
                    o &&
                      (p =
                        'end' === (e = p)
                          ? 'start'
                          : 'start' === e
                          ? 'end'
                          : e),
                    (u.placement = d + (p ? '-' + p : '')),
                    (u.offsets.popper = O(
                      {},
                      u.offsets.popper,
                      E(u.instance.popper, u.offsets.reference, u.placement)
                    )),
                    (u = k(u.instance.modifiers, u, 'flip')));
                });
              }
              return u;
            },
            behavior: 'flip',
            padding: 5,
            boundariesElement: 'viewport',
            flipVariations: !1,
            flipVariationsByContent: !1,
          },
          inner: {
            order: 700,
            enabled: !1,
            fn: function (e) {
              var t = e.placement,
                n = t.split('-')[0],
                i = e.offsets,
                o = i.popper,
                i = i.reference,
                r = -1 !== ['left', 'right'].indexOf(n),
                s = -1 === ['top', 'left'].indexOf(n);
              return (
                (o[r ? 'left' : 'top'] =
                  i[n] - (s ? o[r ? 'width' : 'height'] : 0)),
                (e.placement = T(t)),
                (e.offsets.popper = v(o)),
                e
              );
            },
          },
          hide: {
            order: 800,
            enabled: !0,
            fn: function (e) {
              if (H(e.instance.modifiers, 'hide', 'preventOverflow')) {
                var t = e.offsets.reference,
                  n = S(e.instance.modifiers, function (e) {
                    return 'preventOverflow' === e.name;
                  }).boundaries;
                if (
                  t.bottom < n.top ||
                  t.left > n.right ||
                  t.top > n.bottom ||
                  t.right < n.left
                ) {
                  if (!0 === e.hide) return e;
                  (e.hide = !0), (e.attributes['x-out-of-boundaries'] = '');
                } else {
                  if (!1 === e.hide) return e;
                  (e.hide = !1), (e.attributes['x-out-of-boundaries'] = !1);
                }
              }
              return e;
            },
          },
          computeStyle: {
            order: 850,
            enabled: !0,
            fn: function (e, t) {
              var n = t.x,
                i = t.y,
                o = e.offsets.popper,
                r = S(e.instance.modifiers, function (e) {
                  return 'applyStyle' === e.name;
                }).gpuAcceleration;
              void 0 !== r &&
                console.warn(
                  'WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!'
                );
              var t = void 0 === r ? t.gpuAcceleration : r,
                r = f(e.instance.popper),
                s = y(r),
                o = {
                  position: o.position,
                },
                a = q(e, window.devicePixelRatio < 2 || !K),
                n = 'bottom' === n ? 'top' : 'bottom',
                i = 'right' === i ? 'left' : 'right',
                l = D('transform'),
                u =
                  'bottom' == n
                    ? 'HTML' === r.nodeName
                      ? -r.clientHeight + a.bottom
                      : -s.height + a.bottom
                    : a.top,
                r =
                  'right' == i
                    ? 'HTML' === r.nodeName
                      ? -r.clientWidth + a.right
                      : -s.width + a.right
                    : a.left,
                a =
                  (t && l
                    ? ((o[l] = 'translate3d(' + r + 'px, ' + u + 'px, 0)'),
                      (o[n] = 0),
                      (o[i] = 0),
                      (o.willChange = 'transform'))
                    : ((s = 'right' == i ? -1 : 1),
                      (o[n] = u * ('bottom' == n ? -1 : 1)),
                      (o[i] = r * s),
                      (o.willChange = n + ', ' + i)),
                  {
                    'x-placement': e.placement,
                  });
              return (
                (e.attributes = O({}, a, e.attributes)),
                (e.styles = O({}, o, e.styles)),
                (e.arrowStyles = O({}, e.offsets.arrow, e.arrowStyles)),
                e
              );
            },
            gpuAcceleration: !0,
            x: 'bottom',
            y: 'right',
          },
          applyStyle: {
            order: 900,
            enabled: !0,
            fn: function (e) {
              return (
                N(e.instance.popper, e.styles),
                (t = e.instance.popper),
                (n = e.attributes),
                Object.keys(n).forEach(function (e) {
                  !1 === n[e] ? t.removeAttribute(e) : t.setAttribute(e, n[e]);
                }),
                e.arrowElement &&
                  Object.keys(e.arrowStyles).length &&
                  N(e.arrowElement, e.arrowStyles),
                e
              );
              var t, n;
            },
            onLoad: function (e, t, n, i, o) {
              (o = x(o, t, e, n.positionFixed)),
                (o = a(
                  n.placement,
                  o,
                  t,
                  e,
                  n.modifiers.flip.boundariesElement,
                  n.modifiers.flip.padding
                ));
              return (
                t.setAttribute('x-placement', o),
                N(t, {
                  position: n.positionFixed ? 'fixed' : 'absolute',
                }),
                n
              );
            },
            gpuAcceleration: void 0,
          },
        },
      }),
      e
    );
  }),
  (function (e, t) {
    'object' == typeof exports && 'undefined' != typeof module
      ? t(exports, require('jquery'), require('popper.js'))
      : 'function' == typeof define && define.amd
      ? define(['exports', 'jquery', 'popper.js'], t)
      : t(
          ((e =
            'undefined' != typeof globalThis
              ? globalThis
              : e || self).bootstrap = {}),
          e.jQuery,
          e.Popper
        );
  })(this, function (e, t, n) {
    'use strict';

    function L(e) {
      return e && 'object' == typeof e && 'default' in e
        ? e
        : {
            default: e,
          };
    }
    var c = L(t),
      R = L(n);

    function z(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }

    function i(e, t, n) {
      t && z(e.prototype, t),
        n && z(e, n),
        Object.defineProperty(e, 'prototype', {
          writable: !1,
        });
    }

    function r() {
      return (r = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n,
                i = arguments[t];
              for (n in i)
                Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
            }
            return e;
          }).apply(this, arguments);
    }

    function M(e, t) {
      return (M = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (e, t) {
            return (e.__proto__ = t), e;
          })(e, t);
    }
    var q = 'transitionend',
      h = {
        TRANSITION_END: 'bsTransitionEnd',
        getUID: function (e) {
          for (; (e += ~~(1e6 * Math.random())), document.getElementById(e); );
          return e;
        },
        getSelectorFromElement: function (e) {
          var t,
            n = e.getAttribute('data-target');
          (n && '#' !== n) ||
            (n = (t = e.getAttribute('href')) && '#' !== t ? t.trim() : '');
          try {
            return document.querySelector(n) ? n : null;
          } catch (e) {
            return null;
          }
        },
        getTransitionDurationFromElement: function (e) {
          var t, n, i;
          return e &&
            ((t = c.default(e).css('transition-duration')),
            (e = c.default(e).css('transition-delay')),
            (n = parseFloat(t)),
            (i = parseFloat(e)),
            n || i)
            ? ((t = t.split(',')[0]),
              (e = e.split(',')[0]),
              1e3 * (parseFloat(t) + parseFloat(e)))
            : 0;
        },
        reflow: function (e) {
          return e.offsetHeight;
        },
        triggerTransitionEnd: function (e) {
          c.default(e).trigger(q);
        },
        supportsTransitionEnd: function () {
          return Boolean(q);
        },
        isElement: function (e) {
          return (e[0] || e).nodeType;
        },
        typeCheckConfig: function (e, t, n) {
          for (var i in n)
            if (Object.prototype.hasOwnProperty.call(n, i)) {
              var o = n[i],
                r = t[i],
                r =
                  r && h.isElement(r)
                    ? 'element'
                    : null == (r = r)
                    ? '' + r
                    : {}.toString
                        .call(r)
                        .match(/\s([a-z]+)/i)[1]
                        .toLowerCase();
              if (!new RegExp(o).test(r))
                throw new Error(
                  e.toUpperCase() +
                    ': Option "' +
                    i +
                    '" provided type "' +
                    r +
                    '" but expected type "' +
                    o +
                    '".'
                );
            }
        },
        findShadowRoot: function (e) {
          var t;
          return document.documentElement.attachShadow
            ? 'function' == typeof e.getRootNode
              ? (t = e.getRootNode()) instanceof ShadowRoot
                ? t
                : null
              : e instanceof ShadowRoot
              ? e
              : e.parentNode
              ? h.findShadowRoot(e.parentNode)
              : null
            : null;
        },
        jQueryDetection: function () {
          if (void 0 === c.default)
            throw new TypeError(
              "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript."
            );
          var e = c.default.fn.jquery.split(' ')[0].split('.');
          if (
            (e[0] < 2 && e[1] < 9) ||
            (1 === e[0] && 9 === e[1] && e[2] < 1) ||
            4 <= e[0]
          )
            throw new Error(
              "Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0"
            );
        },
      },
      H =
        (h.jQueryDetection(),
        (c.default.fn.emulateTransitionEnd = function (e) {
          var t = this,
            n = !1;
          return (
            c.default(this).one(h.TRANSITION_END, function () {
              n = !0;
            }),
            setTimeout(function () {
              n || h.triggerTransitionEnd(t);
            }, e),
            this
          );
        }),
        (c.default.event.special[h.TRANSITION_END] = {
          bindType: q,
          delegateType: q,
          handle: function (e) {
            if (c.default(e.target).is(this))
              return e.handleObj.handler.apply(this, arguments);
          },
        }),
        'bs.alert'),
      F = c.default.fn.alert,
      o =
        (((t = s.prototype).close = function (e) {
          var t = this._element;
          e && (t = this._getRootElement(e)),
            this._triggerCloseEvent(t).isDefaultPrevented() ||
              this._removeElement(t);
        }),
        (t.dispose = function () {
          c.default.removeData(this._element, H), (this._element = null);
        }),
        (t._getRootElement = function (e) {
          var t = h.getSelectorFromElement(e),
            n = !1;
          return (n =
            (n = t ? document.querySelector(t) : n) ||
            c.default(e).closest('.alert')[0]);
        }),
        (t._triggerCloseEvent = function (e) {
          var t = c.default.Event('close.bs.alert');
          return c.default(e).trigger(t), t;
        }),
        (t._removeElement = function (t) {
          var e,
            n = this;
          c.default(t).removeClass('show'),
            c.default(t).hasClass('fade')
              ? ((e = h.getTransitionDurationFromElement(t)),
                c
                  .default(t)
                  .one(h.TRANSITION_END, function (e) {
                    return n._destroyElement(t, e);
                  })
                  .emulateTransitionEnd(e))
              : this._destroyElement(t);
        }),
        (t._destroyElement = function (e) {
          c.default(e).detach().trigger('closed.bs.alert').remove();
        }),
        (s._jQueryInterface = function (n) {
          return this.each(function () {
            var e = c.default(this),
              t = e.data(H);
            t || ((t = new s(this)), e.data(H, t)), 'close' === n && t[n](this);
          });
        }),
        (s._handleDismiss = function (t) {
          return function (e) {
            e && e.preventDefault(), t.close(this);
          };
        }),
        i(s, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
        ]),
        s);

    function s(e) {
      this._element = e;
    }
    c
      .default(document)
      .on(
        'click.bs.alert.data-api',
        '[data-dismiss="alert"]',
        o._handleDismiss(new o())
      ),
      (c.default.fn.alert = o._jQueryInterface),
      (c.default.fn.alert.Constructor = o),
      (c.default.fn.alert.noConflict = function () {
        return (c.default.fn.alert = F), o._jQueryInterface;
      });
    var W = 'bs.button',
      B = c.default.fn.button,
      l = 'active',
      n = '[data-toggle^="button"]',
      Q = 'input:not([type="hidden"])',
      a =
        (((t = u.prototype).toggle = function () {
          var e,
            t = !0,
            n = !0,
            i = c.default(this._element).closest('[data-toggle="buttons"]')[0];
          i &&
            (e = this._element.querySelector(Q)) &&
            ('radio' === e.type &&
              (e.checked && this._element.classList.contains(l)
                ? (t = !1)
                : (i = i.querySelector('.active')) &&
                  c.default(i).removeClass(l)),
            t &&
              (('checkbox' !== e.type && 'radio' !== e.type) ||
                (e.checked = !this._element.classList.contains(l)),
              this.shouldAvoidTriggerChange || c.default(e).trigger('change')),
            e.focus(),
            (n = !1)),
            this._element.hasAttribute('disabled') ||
              this._element.classList.contains('disabled') ||
              (n &&
                this._element.setAttribute(
                  'aria-pressed',
                  !this._element.classList.contains(l)
                ),
              t && c.default(this._element).toggleClass(l));
        }),
        (t.dispose = function () {
          c.default.removeData(this._element, W), (this._element = null);
        }),
        (u._jQueryInterface = function (n, i) {
          return this.each(function () {
            var e = c.default(this),
              t = e.data(W);
            t || ((t = new u(this)), e.data(W, t)),
              (t.shouldAvoidTriggerChange = i),
              'toggle' === n && t[n]();
          });
        }),
        i(u, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
        ]),
        u);

    function u(e) {
      (this._element = e), (this.shouldAvoidTriggerChange = !1);
    }
    c
      .default(document)
      .on('click.bs.button.data-api', n, function (e) {
        var t,
          n = e.target,
          i = n;
        !(n = c.default(n).hasClass('btn')
          ? n
          : c.default(n).closest('.btn')[0]) ||
        n.hasAttribute('disabled') ||
        n.classList.contains('disabled') ||
        ((t = n.querySelector(Q)) &&
          (t.hasAttribute('disabled') || t.classList.contains('disabled')))
          ? e.preventDefault()
          : ('INPUT' !== i.tagName && 'LABEL' === n.tagName) ||
            a._jQueryInterface.call(
              c.default(n),
              'toggle',
              'INPUT' === i.tagName
            );
      })
      .on('focus.bs.button.data-api blur.bs.button.data-api', n, function (e) {
        var t = c.default(e.target).closest('.btn')[0];
        c.default(t).toggleClass('focus', /^focus(in)?$/.test(e.type));
      }),
      c.default(window).on('load.bs.button.data-api', function () {
        for (
          var e = [].slice.call(
              document.querySelectorAll('[data-toggle="buttons"] .btn')
            ),
            t = 0,
            n = e.length;
          t < n;
          t++
        ) {
          var i = e[t],
            o = i.querySelector(Q);
          o.checked || o.hasAttribute('checked')
            ? i.classList.add(l)
            : i.classList.remove(l);
        }
        for (
          var r = 0,
            s = (e = [].slice.call(
              document.querySelectorAll('[data-toggle="button"]')
            )).length;
          r < s;
          r++
        ) {
          var a = e[r];
          'true' === a.getAttribute('aria-pressed')
            ? a.classList.add(l)
            : a.classList.remove(l);
        }
      }),
      (c.default.fn.button = a._jQueryInterface),
      (c.default.fn.button.Constructor = a),
      (c.default.fn.button.noConflict = function () {
        return (c.default.fn.button = B), a._jQueryInterface;
      });
    var d = 'carousel',
      U = 'bs.carousel',
      V = c.default.fn[d],
      f = 'active',
      X = 'next',
      Y = 'prev',
      K = 'slid.bs.carousel',
      J = '.active.carousel-item',
      G = {
        interval: 5e3,
        keyboard: !0,
        slide: !1,
        pause: 'hover',
        wrap: !0,
        touch: !0,
      },
      Z = {
        interval: '(number|boolean)',
        keyboard: 'boolean',
        slide: '(boolean|string)',
        pause: '(string|boolean)',
        wrap: 'boolean',
        touch: 'boolean',
      },
      ee = {
        TOUCH: 'touch',
        PEN: 'pen',
      },
      p =
        (((t = g.prototype).next = function () {
          this._isSliding || this._slide(X);
        }),
        (t.nextWhenVisible = function () {
          var e = c.default(this._element);
          !document.hidden &&
            e.is(':visible') &&
            'hidden' !== e.css('visibility') &&
            this.next();
        }),
        (t.prev = function () {
          this._isSliding || this._slide(Y);
        }),
        (t.pause = function (e) {
          e || (this._isPaused = !0),
            this._element.querySelector(
              '.carousel-item-next, .carousel-item-prev'
            ) && (h.triggerTransitionEnd(this._element), this.cycle(!0)),
            clearInterval(this._interval),
            (this._interval = null);
        }),
        (t.cycle = function (e) {
          e || (this._isPaused = !1),
            this._interval &&
              (clearInterval(this._interval), (this._interval = null)),
            this._config.interval &&
              !this._isPaused &&
              (this._updateInterval(),
              (this._interval = setInterval(
                (document.visibilityState
                  ? this.nextWhenVisible
                  : this.next
                ).bind(this),
                this._config.interval
              )));
        }),
        (t.to = function (e) {
          var t = this,
            n =
              ((this._activeElement = this._element.querySelector(J)),
              this._getItemIndex(this._activeElement));
          e > this._items.length - 1 ||
            e < 0 ||
            (this._isSliding
              ? c.default(this._element).one(K, function () {
                  return t.to(e);
                })
              : n === e
              ? (this.pause(), this.cycle())
              : this._slide(n < e ? X : Y, this._items[e]));
        }),
        (t.dispose = function () {
          c.default(this._element).off('.bs.carousel'),
            c.default.removeData(this._element, U),
            (this._items = null),
            (this._config = null),
            (this._element = null),
            (this._interval = null),
            (this._isPaused = null),
            (this._isSliding = null),
            (this._activeElement = null),
            (this._indicatorsElement = null);
        }),
        (t._getConfig = function (e) {
          return (e = r({}, G, e)), h.typeCheckConfig(d, e, Z), e;
        }),
        (t._handleSwipe = function () {
          var e = Math.abs(this.touchDeltaX);
          e <= 40 ||
            ((e = e / this.touchDeltaX),
            (this.touchDeltaX = 0) < e && this.prev(),
            e < 0 && this.next());
        }),
        (t._addEventListeners = function () {
          var t = this;
          this._config.keyboard &&
            c.default(this._element).on('keydown.bs.carousel', function (e) {
              return t._keydown(e);
            }),
            'hover' === this._config.pause &&
              c
                .default(this._element)
                .on('mouseenter.bs.carousel', function (e) {
                  return t.pause(e);
                })
                .on('mouseleave.bs.carousel', function (e) {
                  return t.cycle(e);
                }),
            this._config.touch && this._addTouchEventListeners();
        }),
        (t._addTouchEventListeners = function () {
          var e,
            t,
            n = this;
          this._touchSupported &&
            ((e = function (e) {
              n._pointerEvent && ee[e.originalEvent.pointerType.toUpperCase()]
                ? (n.touchStartX = e.originalEvent.clientX)
                : n._pointerEvent ||
                  (n.touchStartX = e.originalEvent.touches[0].clientX);
            }),
            (t = function (e) {
              n._pointerEvent &&
                ee[e.originalEvent.pointerType.toUpperCase()] &&
                (n.touchDeltaX = e.originalEvent.clientX - n.touchStartX),
                n._handleSwipe(),
                'hover' === n._config.pause &&
                  (n.pause(),
                  n.touchTimeout && clearTimeout(n.touchTimeout),
                  (n.touchTimeout = setTimeout(function (e) {
                    return n.cycle(e);
                  }, 500 + n._config.interval)));
            }),
            c
              .default(this._element.querySelectorAll('.carousel-item img'))
              .on('dragstart.bs.carousel', function (e) {
                return e.preventDefault();
              }),
            this._pointerEvent
              ? (c.default(this._element).on('pointerdown.bs.carousel', e),
                c.default(this._element).on('pointerup.bs.carousel', t),
                this._element.classList.add('pointer-event'))
              : (c.default(this._element).on('touchstart.bs.carousel', e),
                c
                  .default(this._element)
                  .on('touchmove.bs.carousel', function (e) {
                    n.touchDeltaX =
                      e.originalEvent.touches &&
                      1 < e.originalEvent.touches.length
                        ? 0
                        : e.originalEvent.touches[0].clientX - n.touchStartX;
                  }),
                c.default(this._element).on('touchend.bs.carousel', t)));
        }),
        (t._keydown = function (e) {
          if (!/input|textarea/i.test(e.target.tagName))
            switch (e.which) {
              case 37:
                e.preventDefault(), this.prev();
                break;
              case 39:
                e.preventDefault(), this.next();
            }
        }),
        (t._getItemIndex = function (e) {
          return (
            (this._items =
              e && e.parentNode
                ? [].slice.call(e.parentNode.querySelectorAll('.carousel-item'))
                : []),
            this._items.indexOf(e)
          );
        }),
        (t._getItemByDirection = function (e, t) {
          var n = e === X,
            i = e === Y,
            o = this._getItemIndex(t),
            r = this._items.length - 1;
          return ((i && 0 === o) || (n && o === r)) && !this._config.wrap
            ? t
            : -1 == (i = (o + (e === Y ? -1 : 1)) % this._items.length)
            ? this._items[this._items.length - 1]
            : this._items[i];
        }),
        (t._triggerSlideEvent = function (e, t) {
          var n = this._getItemIndex(e),
            i = this._getItemIndex(this._element.querySelector(J)),
            e = c.default.Event('slide.bs.carousel', {
              relatedTarget: e,
              direction: t,
              from: i,
              to: n,
            });
          return c.default(this._element).trigger(e), e;
        }),
        (t._setActiveIndicatorElement = function (e) {
          var t;
          this._indicatorsElement &&
            ((t = [].slice.call(
              this._indicatorsElement.querySelectorAll('.active')
            )),
            c.default(t).removeClass(f),
            (t = this._indicatorsElement.children[this._getItemIndex(e)])) &&
            c.default(t).addClass(f);
        }),
        (t._updateInterval = function () {
          var e = this._activeElement || this._element.querySelector(J);
          e &&
            ((e = parseInt(e.getAttribute('data-interval'), 10))
              ? ((this._config.defaultInterval =
                  this._config.defaultInterval || this._config.interval),
                (this._config.interval = e))
              : (this._config.interval =
                  this._config.defaultInterval || this._config.interval));
        }),
        (t._slide = function (e, t) {
          var n,
            i,
            o,
            r = this,
            s = this._element.querySelector(J),
            a = this._getItemIndex(s),
            l = t || (s && this._getItemByDirection(e, s)),
            t = this._getItemIndex(l),
            u = Boolean(this._interval),
            e =
              e === X
                ? ((n = 'carousel-item-left'),
                  (i = 'carousel-item-next'),
                  'left')
                : ((n = 'carousel-item-right'),
                  (i = 'carousel-item-prev'),
                  'right');
          l && c.default(l).hasClass(f)
            ? (this._isSliding = !1)
            : !this._triggerSlideEvent(l, e).isDefaultPrevented() &&
              s &&
              l &&
              ((this._isSliding = !0),
              u && this.pause(),
              this._setActiveIndicatorElement(l),
              (this._activeElement = l),
              (o = c.default.Event(K, {
                relatedTarget: l,
                direction: e,
                from: a,
                to: t,
              })),
              c.default(this._element).hasClass('slide')
                ? (c.default(l).addClass(i),
                  h.reflow(l),
                  c.default(s).addClass(n),
                  c.default(l).addClass(n),
                  (e = h.getTransitionDurationFromElement(s)),
                  c
                    .default(s)
                    .one(h.TRANSITION_END, function () {
                      c
                        .default(l)
                        .removeClass(n + ' ' + i)
                        .addClass(f),
                        c.default(s).removeClass('active ' + i + ' ' + n),
                        (r._isSliding = !1),
                        setTimeout(function () {
                          return c.default(r._element).trigger(o);
                        }, 0);
                    })
                    .emulateTransitionEnd(e))
                : (c.default(s).removeClass(f),
                  c.default(l).addClass(f),
                  (this._isSliding = !1),
                  c.default(this._element).trigger(o)),
              u) &&
              this.cycle();
        }),
        (g._jQueryInterface = function (i) {
          return this.each(function () {
            var e = c.default(this).data(U),
              t = r({}, G, c.default(this).data()),
              n =
                ('object' == typeof i && (t = r({}, t, i)),
                'string' == typeof i ? i : t.slide);
            if (
              (e || ((e = new g(this, t)), c.default(this).data(U, e)),
              'number' == typeof i)
            )
              e.to(i);
            else if ('string' == typeof n) {
              if (void 0 === e[n])
                throw new TypeError('No method named "' + n + '"');
              e[n]();
            } else t.interval && t.ride && (e.pause(), e.cycle());
          });
        }),
        (g._dataApiClickHandler = function (e) {
          var t,
            n,
            i = h.getSelectorFromElement(this);
          i &&
            (i = c.default(i)[0]) &&
            c.default(i).hasClass('carousel') &&
            ((t = r({}, c.default(i).data(), c.default(this).data())),
            (n = this.getAttribute('data-slide-to')) && (t.interval = !1),
            g._jQueryInterface.call(c.default(i), t),
            n && c.default(i).data(U).to(n),
            e.preventDefault());
        }),
        i(g, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return G;
            },
          },
        ]),
        g);

    function g(e, t) {
      (this._items = null),
        (this._interval = null),
        (this._activeElement = null),
        (this._isPaused = !1),
        (this._isSliding = !1),
        (this.touchTimeout = null),
        (this.touchStartX = 0),
        (this.touchDeltaX = 0),
        (this._config = this._getConfig(t)),
        (this._element = e),
        (this._indicatorsElement = this._element.querySelector(
          '.carousel-indicators'
        )),
        (this._touchSupported =
          'ontouchstart' in document.documentElement ||
          0 < navigator.maxTouchPoints),
        (this._pointerEvent = Boolean(
          window.PointerEvent || window.MSPointerEvent
        )),
        this._addEventListeners();
    }
    c
      .default(document)
      .on(
        'click.bs.carousel.data-api',
        '[data-slide], [data-slide-to]',
        p._dataApiClickHandler
      ),
      c.default(window).on('load.bs.carousel.data-api', function () {
        for (
          var e = [].slice.call(
              document.querySelectorAll('[data-ride="carousel"]')
            ),
            t = 0,
            n = e.length;
          t < n;
          t++
        ) {
          var i = c.default(e[t]);
          p._jQueryInterface.call(i, i.data());
        }
      }),
      (c.default.fn[d] = p._jQueryInterface),
      (c.default.fn[d].Constructor = p),
      (c.default.fn[d].noConflict = function () {
        return (c.default.fn[d] = V), p._jQueryInterface;
      });
    var m = 'collapse',
      v = 'bs.collapse',
      te = c.default.fn[m],
      y = 'show',
      ne = 'collapse',
      ie = 'collapsing',
      oe = 'collapsed',
      re = '[data-toggle="collapse"]',
      se = {
        toggle: !0,
        parent: '',
      },
      ae = {
        toggle: 'boolean',
        parent: '(string|element)',
      },
      _ =
        (((n = b.prototype).toggle = function () {
          c.default(this._element).hasClass(y) ? this.hide() : this.show();
        }),
        (n.show = function () {
          var e,
            t,
            n,
            i,
            o = this;
          this._isTransitioning ||
            c.default(this._element).hasClass(y) ||
            ((e =
              this._parent &&
              0 ===
                (e = [].slice
                  .call(this._parent.querySelectorAll('.show, .collapsing'))
                  .filter(function (e) {
                    return 'string' == typeof o._config.parent
                      ? e.getAttribute('data-parent') === o._config.parent
                      : e.classList.contains(ne);
                  })).length
                ? null
                : e) &&
              (i = c.default(e).not(this._selector).data(v)) &&
              i._isTransitioning) ||
            ((n = c.default.Event('show.bs.collapse')),
            c.default(this._element).trigger(n),
            n.isDefaultPrevented() ||
              (e &&
                (b._jQueryInterface.call(
                  c.default(e).not(this._selector),
                  'hide'
                ),
                i || c.default(e).data(v, null)),
              (t = this._getDimension()),
              c.default(this._element).removeClass(ne).addClass(ie),
              (this._element.style[t] = 0),
              this._triggerArray.length &&
                c
                  .default(this._triggerArray)
                  .removeClass(oe)
                  .attr('aria-expanded', !0),
              this.setTransitioning(!0),
              (n = 'scroll' + (t[0].toUpperCase() + t.slice(1))),
              (i = h.getTransitionDurationFromElement(this._element)),
              c
                .default(this._element)
                .one(h.TRANSITION_END, function () {
                  c
                    .default(o._element)
                    .removeClass(ie)
                    .addClass('collapse show'),
                    (o._element.style[t] = ''),
                    o.setTransitioning(!1),
                    c.default(o._element).trigger('shown.bs.collapse');
                })
                .emulateTransitionEnd(i),
              (this._element.style[t] = this._element[n] + 'px')));
        }),
        (n.hide = function () {
          var e = this;
          if (!this._isTransitioning && c.default(this._element).hasClass(y)) {
            var t = c.default.Event('hide.bs.collapse');
            if (
              (c.default(this._element).trigger(t), !t.isDefaultPrevented())
            ) {
              var t = this._getDimension(),
                n =
                  ((this._element.style[t] =
                    this._element.getBoundingClientRect()[t] + 'px'),
                  h.reflow(this._element),
                  c
                    .default(this._element)
                    .addClass(ie)
                    .removeClass('collapse show'),
                  this._triggerArray.length);
              if (0 < n)
                for (var i = 0; i < n; i++) {
                  var o = this._triggerArray[i],
                    r = h.getSelectorFromElement(o);
                  null === r ||
                    c
                      .default([].slice.call(document.querySelectorAll(r)))
                      .hasClass(y) ||
                    c.default(o).addClass(oe).attr('aria-expanded', !1);
                }
              this.setTransitioning(!0), (this._element.style[t] = '');
              t = h.getTransitionDurationFromElement(this._element);
              c.default(this._element)
                .one(h.TRANSITION_END, function () {
                  e.setTransitioning(!1),
                    c
                      .default(e._element)
                      .removeClass(ie)
                      .addClass(ne)
                      .trigger('hidden.bs.collapse');
                })
                .emulateTransitionEnd(t);
            }
          }
        }),
        (n.setTransitioning = function (e) {
          this._isTransitioning = e;
        }),
        (n.dispose = function () {
          c.default.removeData(this._element, v),
            (this._config = null),
            (this._parent = null),
            (this._element = null),
            (this._triggerArray = null),
            (this._isTransitioning = null);
        }),
        (n._getConfig = function (e) {
          return (
            ((e = r({}, se, e)).toggle = Boolean(e.toggle)),
            h.typeCheckConfig(m, e, ae),
            e
          );
        }),
        (n._getDimension = function () {
          return c.default(this._element).hasClass('width')
            ? 'width'
            : 'height';
        }),
        (n._getParent = function () {
          var e,
            n = this,
            t =
              (h.isElement(this._config.parent)
                ? ((e = this._config.parent),
                  void 0 !== this._config.parent.jquery &&
                    (e = this._config.parent[0]))
                : (e = document.querySelector(this._config.parent)),
              '[data-toggle="collapse"][data-parent="' +
                this._config.parent +
                '"]'),
            t = [].slice.call(e.querySelectorAll(t));
          return (
            c.default(t).each(function (e, t) {
              n._addAriaAndCollapsedClass(b._getTargetFromElement(t), [t]);
            }),
            e
          );
        }),
        (n._addAriaAndCollapsedClass = function (e, t) {
          e = c.default(e).hasClass(y);
          t.length && c.default(t).toggleClass(oe, !e).attr('aria-expanded', e);
        }),
        (b._getTargetFromElement = function (e) {
          e = h.getSelectorFromElement(e);
          return e ? document.querySelector(e) : null;
        }),
        (b._jQueryInterface = function (i) {
          return this.each(function () {
            var e = c.default(this),
              t = e.data(v),
              n = r({}, se, e.data(), 'object' == typeof i && i ? i : {});
            if (
              (!t &&
                n.toggle &&
                'string' == typeof i &&
                /show|hide/.test(i) &&
                (n.toggle = !1),
              t || ((t = new b(this, n)), e.data(v, t)),
              'string' == typeof i)
            ) {
              if (void 0 === t[i])
                throw new TypeError('No method named "' + i + '"');
              t[i]();
            }
          });
        }),
        i(b, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return se;
            },
          },
        ]),
        b);

    function b(t, e) {
      (this._isTransitioning = !1),
        (this._element = t),
        (this._config = this._getConfig(e)),
        (this._triggerArray = [].slice.call(
          document.querySelectorAll(
            '[data-toggle="collapse"][href="#' +
              t.id +
              '"],[data-toggle="collapse"][data-target="#' +
              t.id +
              '"]'
          )
        ));
      for (
        var n = [].slice.call(document.querySelectorAll(re)),
          i = 0,
          o = n.length;
        i < o;
        i++
      ) {
        var r = n[i],
          s = h.getSelectorFromElement(r),
          a = [].slice.call(document.querySelectorAll(s)).filter(function (e) {
            return e === t;
          });
        null !== s &&
          0 < a.length &&
          ((this._selector = s), this._triggerArray.push(r));
      }
      (this._parent = this._config.parent ? this._getParent() : null),
        this._config.parent ||
          this._addAriaAndCollapsedClass(this._element, this._triggerArray),
        this._config.toggle && this.toggle();
    }
    c.default(document).on('click.bs.collapse.data-api', re, function (e) {
      'A' === e.currentTarget.tagName && e.preventDefault();
      var n = c.default(this),
        e = h.getSelectorFromElement(this),
        e = [].slice.call(document.querySelectorAll(e));
      c.default(e).each(function () {
        var e = c.default(this),
          t = e.data(v) ? 'toggle' : n.data();
        _._jQueryInterface.call(e, t);
      });
    }),
      (c.default.fn[m] = _._jQueryInterface),
      (c.default.fn[m].Constructor = _),
      (c.default.fn[m].noConflict = function () {
        return (c.default.fn[m] = te), _._jQueryInterface;
      });
    var w = 'dropdown',
      le = 'bs.dropdown',
      ue = c.default.fn[w],
      ce = new RegExp('38|40|27'),
      he = 'disabled',
      x = 'show',
      de = 'dropdown-menu-right',
      fe = 'hide.bs.dropdown',
      pe = 'hidden.bs.dropdown',
      t = 'click.bs.dropdown.data-api',
      n = 'keydown.bs.dropdown.data-api',
      ge = '[data-toggle="dropdown"]',
      me = '.dropdown-menu',
      ve = {
        offset: 0,
        flip: !0,
        boundary: 'scrollParent',
        reference: 'toggle',
        display: 'dynamic',
        popperConfig: null,
      },
      ye = {
        offset: '(number|string|function)',
        flip: 'boolean',
        boundary: '(string|element)',
        reference: '(string|element)',
        display: 'string',
        popperConfig: '(null|object)',
      },
      C =
        (((P = T.prototype).toggle = function () {
          var e;
          this._element.disabled ||
            c.default(this._element).hasClass(he) ||
            ((e = c.default(this._menu).hasClass(x)), T._clearMenus(), e) ||
            this.show(!0);
        }),
        (P.show = function (e) {
          if (
            (void 0 === e && (e = !1),
            !(
              this._element.disabled ||
              c.default(this._element).hasClass(he) ||
              c.default(this._menu).hasClass(x)
            ))
          ) {
            var t = {
                relatedTarget: this._element,
              },
              n = c.default.Event('show.bs.dropdown', t),
              i = T._getParentFromElement(this._element);
            if ((c.default(i).trigger(n), !n.isDefaultPrevented())) {
              if (!this._inNavbar && e) {
                if (void 0 === R.default)
                  throw new TypeError(
                    "Bootstrap's dropdowns require Popper (https://popper.js.org)"
                  );
                n = this._element;
                'parent' === this._config.reference
                  ? (n = i)
                  : h.isElement(this._config.reference) &&
                    ((n = this._config.reference),
                    void 0 !== this._config.reference.jquery) &&
                    (n = this._config.reference[0]),
                  'scrollParent' !== this._config.boundary &&
                    c.default(i).addClass('position-static'),
                  (this._popper = new R.default(
                    n,
                    this._menu,
                    this._getPopperConfig()
                  ));
              }
              'ontouchstart' in document.documentElement &&
                0 === c.default(i).closest('.navbar-nav').length &&
                c
                  .default(document.body)
                  .children()
                  .on('mouseover', null, c.default.noop),
                this._element.focus(),
                this._element.setAttribute('aria-expanded', !0),
                c.default(this._menu).toggleClass(x),
                c
                  .default(i)
                  .toggleClass(x)
                  .trigger(c.default.Event('shown.bs.dropdown', t));
            }
          }
        }),
        (P.hide = function () {
          var e, t, n;
          this._element.disabled ||
            c.default(this._element).hasClass(he) ||
            !c.default(this._menu).hasClass(x) ||
            ((e = {
              relatedTarget: this._element,
            }),
            (t = c.default.Event(fe, e)),
            (n = T._getParentFromElement(this._element)),
            c.default(n).trigger(t),
            t.isDefaultPrevented()) ||
            (this._popper && this._popper.destroy(),
            c.default(this._menu).toggleClass(x),
            c.default(n).toggleClass(x).trigger(c.default.Event(pe, e)));
        }),
        (P.dispose = function () {
          c.default.removeData(this._element, le),
            c.default(this._element).off('.bs.dropdown'),
            (this._element = null),
            (this._menu = null) !== this._popper &&
              (this._popper.destroy(), (this._popper = null));
        }),
        (P.update = function () {
          (this._inNavbar = this._detectNavbar()),
            null !== this._popper && this._popper.scheduleUpdate();
        }),
        (P._addEventListeners = function () {
          var t = this;
          c.default(this._element).on('click.bs.dropdown', function (e) {
            e.preventDefault(), e.stopPropagation(), t.toggle();
          });
        }),
        (P._getConfig = function (e) {
          return (
            (e = r(
              {},
              this.constructor.Default,
              c.default(this._element).data(),
              e
            )),
            h.typeCheckConfig(w, e, this.constructor.DefaultType),
            e
          );
        }),
        (P._getMenuElement = function () {
          var e;
          return (
            this._menu ||
              ((e = T._getParentFromElement(this._element)) &&
                (this._menu = e.querySelector(me))),
            this._menu
          );
        }),
        (P._getPlacement = function () {
          var e = c.default(this._element.parentNode),
            t = 'bottom-start';
          return (
            e.hasClass('dropup')
              ? (t = c.default(this._menu).hasClass(de)
                  ? 'top-end'
                  : 'top-start')
              : e.hasClass('dropright')
              ? (t = 'right-start')
              : e.hasClass('dropleft')
              ? (t = 'left-start')
              : c.default(this._menu).hasClass(de) && (t = 'bottom-end'),
            t
          );
        }),
        (P._detectNavbar = function () {
          return 0 < c.default(this._element).closest('.navbar').length;
        }),
        (P._getOffset = function () {
          var t = this,
            e = {};
          return (
            'function' == typeof this._config.offset
              ? (e.fn = function (e) {
                  return (
                    (e.offsets = r(
                      {},
                      e.offsets,
                      t._config.offset(e.offsets, t._element)
                    )),
                    e
                  );
                })
              : (e.offset = this._config.offset),
            e
          );
        }),
        (P._getPopperConfig = function () {
          var e = {
            placement: this._getPlacement(),
            modifiers: {
              offset: this._getOffset(),
              flip: {
                enabled: this._config.flip,
              },
              preventOverflow: {
                boundariesElement: this._config.boundary,
              },
            },
          };
          return (
            'static' === this._config.display &&
              (e.modifiers.applyStyle = {
                enabled: !1,
              }),
            r({}, e, this._config.popperConfig)
          );
        }),
        (T._jQueryInterface = function (t) {
          return this.each(function () {
            var e = c.default(this).data(le);
            if (
              (e ||
                ((e = new T(this, 'object' == typeof t ? t : null)),
                c.default(this).data(le, e)),
              'string' == typeof t)
            ) {
              if (void 0 === e[t])
                throw new TypeError('No method named "' + t + '"');
              e[t]();
            }
          });
        }),
        (T._clearMenus = function (e) {
          if (!e || (3 !== e.which && ('keyup' !== e.type || 9 === e.which)))
            for (
              var t = [].slice.call(document.querySelectorAll(ge)),
                n = 0,
                i = t.length;
              n < i;
              n++
            ) {
              var o,
                r,
                s = T._getParentFromElement(t[n]),
                a = c.default(t[n]).data(le),
                l = {
                  relatedTarget: t[n],
                };
              e && 'click' === e.type && (l.clickEvent = e),
                a &&
                  ((o = a._menu),
                  !c.default(s).hasClass(x) ||
                    (e &&
                      (('click' === e.type &&
                        /input|textarea/i.test(e.target.tagName)) ||
                        ('keyup' === e.type && 9 === e.which)) &&
                      c.default.contains(s, e.target)) ||
                    ((r = c.default.Event(fe, l)),
                    c.default(s).trigger(r),
                    r.isDefaultPrevented()) ||
                    ('ontouchstart' in document.documentElement &&
                      c
                        .default(document.body)
                        .children()
                        .off('mouseover', null, c.default.noop),
                    t[n].setAttribute('aria-expanded', 'false'),
                    a._popper && a._popper.destroy(),
                    c.default(o).removeClass(x),
                    c
                      .default(s)
                      .removeClass(x)
                      .trigger(c.default.Event(pe, l))));
            }
        }),
        (T._getParentFromElement = function (e) {
          var t,
            n = h.getSelectorFromElement(e);
          return (t = n ? document.querySelector(n) : t) || e.parentNode;
        }),
        (T._dataApiKeydownHandler = function (e) {
          var t, n, i;
          (/input|textarea/i.test(e.target.tagName)
            ? 32 === e.which ||
              (27 !== e.which &&
                ((40 !== e.which && 38 !== e.which) ||
                  c.default(e.target).closest(me).length))
            : !ce.test(e.which)) ||
            this.disabled ||
            c.default(this).hasClass(he) ||
            ((t = T._getParentFromElement(this)),
            !(n = c.default(t).hasClass(x)) && 27 === e.which) ||
            (e.preventDefault(),
            e.stopPropagation(),
            n && 27 !== e.which && 32 !== e.which
              ? 0 !==
                  (n = [].slice
                    .call(
                      t.querySelectorAll(
                        '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
                      )
                    )
                    .filter(function (e) {
                      return c.default(e).is(':visible');
                    })).length &&
                ((i = n.indexOf(e.target)),
                38 === e.which && 0 < i && i--,
                40 === e.which && i < n.length - 1 && i++,
                n[(i = i < 0 ? 0 : i)].focus())
              : (27 === e.which &&
                  c.default(t.querySelector(ge)).trigger('focus'),
                c.default(this).trigger('click')));
        }),
        i(T, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return ve;
            },
          },
          {
            key: 'DefaultType',
            get: function () {
              return ye;
            },
          },
        ]),
        T);

    function T(e, t) {
      (this._element = e),
        (this._popper = null),
        (this._config = this._getConfig(t)),
        (this._menu = this._getMenuElement()),
        (this._inNavbar = this._detectNavbar()),
        this._addEventListeners();
    }
    c
      .default(document)
      .on(n, ge, C._dataApiKeydownHandler)
      .on(n, me, C._dataApiKeydownHandler)
      .on(t + ' keyup.bs.dropdown.data-api', C._clearMenus)
      .on(t, ge, function (e) {
        e.preventDefault(),
          e.stopPropagation(),
          C._jQueryInterface.call(c.default(this), 'toggle');
      })
      .on(t, '.dropdown form', function (e) {
        e.stopPropagation();
      }),
      (c.default.fn[w] = C._jQueryInterface),
      (c.default.fn[w].Constructor = C),
      (c.default.fn[w].noConflict = function () {
        return (c.default.fn[w] = ue), C._jQueryInterface;
      });
    var _e = 'bs.modal',
      be = c.default.fn.modal,
      we = 'modal-open',
      E = 'fade',
      xe = 'show',
      Ce = 'modal-static',
      Te = 'hidden.bs.modal',
      Ee = 'show.bs.modal',
      Se = 'focusin.bs.modal',
      ke = 'resize.bs.modal',
      De = 'click.dismiss.bs.modal',
      Ae = 'keydown.dismiss.bs.modal',
      Ne = 'mousedown.dismiss.bs.modal',
      Ie = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
      $e = {
        backdrop: !0,
        keyboard: !0,
        focus: !0,
        show: !0,
      },
      je = {
        backdrop: '(boolean|string)',
        keyboard: 'boolean',
        focus: 'boolean',
        show: 'boolean',
      },
      S =
        (((P = k.prototype).toggle = function (e) {
          return this._isShown ? this.hide() : this.show(e);
        }),
        (P.show = function (e) {
          var t,
            n = this;
          this._isShown ||
            this._isTransitioning ||
            ((t = c.default.Event(Ee, {
              relatedTarget: e,
            })),
            c.default(this._element).trigger(t),
            t.isDefaultPrevented()) ||
            ((this._isShown = !0),
            c.default(this._element).hasClass(E) &&
              (this._isTransitioning = !0),
            this._checkScrollbar(),
            this._setScrollbar(),
            this._adjustDialog(),
            this._setEscapeEvent(),
            this._setResizeEvent(),
            c
              .default(this._element)
              .on(De, '[data-dismiss="modal"]', function (e) {
                return n.hide(e);
              }),
            c.default(this._dialog).on(Ne, function () {
              c.default(n._element).one(
                'mouseup.dismiss.bs.modal',
                function (e) {
                  c.default(e.target).is(n._element) &&
                    (n._ignoreBackdropClick = !0);
                }
              );
            }),
            this._showBackdrop(function () {
              return n._showElement(e);
            }));
        }),
        (P.hide = function (e) {
          var t = this;
          e && e.preventDefault(),
            this._isShown &&
              !this._isTransitioning &&
              ((e = c.default.Event('hide.bs.modal')),
              c.default(this._element).trigger(e),
              this._isShown) &&
              !e.isDefaultPrevented() &&
              ((this._isShown = !1),
              (e = c.default(this._element).hasClass(E)) &&
                (this._isTransitioning = !0),
              this._setEscapeEvent(),
              this._setResizeEvent(),
              c.default(document).off(Se),
              c.default(this._element).removeClass(xe),
              c.default(this._element).off(De),
              c.default(this._dialog).off(Ne),
              e
                ? ((e = h.getTransitionDurationFromElement(this._element)),
                  c
                    .default(this._element)
                    .one(h.TRANSITION_END, function (e) {
                      return t._hideModal(e);
                    })
                    .emulateTransitionEnd(e))
                : this._hideModal());
        }),
        (P.dispose = function () {
          [window, this._element, this._dialog].forEach(function (e) {
            return c.default(e).off('.bs.modal');
          }),
            c.default(document).off(Se),
            c.default.removeData(this._element, _e),
            (this._config = null),
            (this._element = null),
            (this._dialog = null),
            (this._backdrop = null),
            (this._isShown = null),
            (this._isBodyOverflowing = null),
            (this._ignoreBackdropClick = null),
            (this._isTransitioning = null),
            (this._scrollbarWidth = null);
        }),
        (P.handleUpdate = function () {
          this._adjustDialog();
        }),
        (P._getConfig = function (e) {
          return (e = r({}, $e, e)), h.typeCheckConfig('modal', e, je), e;
        }),
        (P._triggerBackdropTransition = function () {
          var e,
            t,
            n = this,
            i = c.default.Event('hidePrevented.bs.modal');
          c.default(this._element).trigger(i),
            i.isDefaultPrevented() ||
              ((e =
                this._element.scrollHeight >
                document.documentElement.clientHeight) ||
                (this._element.style.overflowY = 'hidden'),
              this._element.classList.add(Ce),
              (t = h.getTransitionDurationFromElement(this._dialog)),
              c.default(this._element).off(h.TRANSITION_END),
              c
                .default(this._element)
                .one(h.TRANSITION_END, function () {
                  n._element.classList.remove(Ce),
                    e ||
                      c
                        .default(n._element)
                        .one(h.TRANSITION_END, function () {
                          n._element.style.overflowY = '';
                        })
                        .emulateTransitionEnd(n._element, t);
                })
                .emulateTransitionEnd(t),
              this._element.focus());
        }),
        (P._showElement = function (e) {
          function t() {
            n._config.focus && n._element.focus(),
              (n._isTransitioning = !1),
              c.default(n._element).trigger(r);
          }
          var n = this,
            i = c.default(this._element).hasClass(E),
            o = this._dialog ? this._dialog.querySelector('.modal-body') : null,
            r =
              ((this._element.parentNode &&
                this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
                document.body.appendChild(this._element),
              (this._element.style.display = 'block'),
              this._element.removeAttribute('aria-hidden'),
              this._element.setAttribute('aria-modal', !0),
              this._element.setAttribute('role', 'dialog'),
              c.default(this._dialog).hasClass('modal-dialog-scrollable') && o
                ? (o.scrollTop = 0)
                : (this._element.scrollTop = 0),
              i && h.reflow(this._element),
              c.default(this._element).addClass(xe),
              this._config.focus && this._enforceFocus(),
              c.default.Event('shown.bs.modal', {
                relatedTarget: e,
              }));
          i
            ? ((o = h.getTransitionDurationFromElement(this._dialog)),
              c
                .default(this._dialog)
                .one(h.TRANSITION_END, t)
                .emulateTransitionEnd(o))
            : t();
        }),
        (P._enforceFocus = function () {
          var t = this;
          c.default(document)
            .off(Se)
            .on(Se, function (e) {
              document !== e.target &&
                t._element !== e.target &&
                0 === c.default(t._element).has(e.target).length &&
                t._element.focus();
            });
        }),
        (P._setEscapeEvent = function () {
          var t = this;
          this._isShown
            ? c.default(this._element).on(Ae, function (e) {
                t._config.keyboard && 27 === e.which
                  ? (e.preventDefault(), t.hide())
                  : t._config.keyboard ||
                    27 !== e.which ||
                    t._triggerBackdropTransition();
              })
            : this._isShown || c.default(this._element).off(Ae);
        }),
        (P._setResizeEvent = function () {
          var t = this;
          this._isShown
            ? c.default(window).on(ke, function (e) {
                return t.handleUpdate(e);
              })
            : c.default(window).off(ke);
        }),
        (P._hideModal = function () {
          var e = this;
          (this._element.style.display = 'none'),
            this._element.setAttribute('aria-hidden', !0),
            this._element.removeAttribute('aria-modal'),
            this._element.removeAttribute('role'),
            (this._isTransitioning = !1),
            this._showBackdrop(function () {
              c.default(document.body).removeClass(we),
                e._resetAdjustments(),
                e._resetScrollbar(),
                c.default(e._element).trigger(Te);
            });
        }),
        (P._removeBackdrop = function () {
          this._backdrop &&
            (c.default(this._backdrop).remove(), (this._backdrop = null));
        }),
        (P._showBackdrop = function (e) {
          var t,
            n = this,
            i = c.default(this._element).hasClass(E) ? E : '';
          this._isShown && this._config.backdrop
            ? ((this._backdrop = document.createElement('div')),
              (this._backdrop.className = 'modal-backdrop'),
              i && this._backdrop.classList.add(i),
              c.default(this._backdrop).appendTo(document.body),
              c.default(this._element).on(De, function (e) {
                n._ignoreBackdropClick
                  ? (n._ignoreBackdropClick = !1)
                  : e.target === e.currentTarget &&
                    ('static' === n._config.backdrop
                      ? n._triggerBackdropTransition()
                      : n.hide());
              }),
              i && h.reflow(this._backdrop),
              c.default(this._backdrop).addClass(xe),
              e &&
                (i
                  ? ((i = h.getTransitionDurationFromElement(this._backdrop)),
                    c
                      .default(this._backdrop)
                      .one(h.TRANSITION_END, e)
                      .emulateTransitionEnd(i))
                  : e()))
            : !this._isShown && this._backdrop
            ? (c.default(this._backdrop).removeClass(xe),
              (i = function () {
                n._removeBackdrop(), e && e();
              }),
              c.default(this._element).hasClass(E)
                ? ((t = h.getTransitionDurationFromElement(this._backdrop)),
                  c
                    .default(this._backdrop)
                    .one(h.TRANSITION_END, i)
                    .emulateTransitionEnd(t))
                : i())
            : e && e();
        }),
        (P._adjustDialog = function () {
          var e =
            this._element.scrollHeight > document.documentElement.clientHeight;
          !this._isBodyOverflowing &&
            e &&
            (this._element.style.paddingLeft = this._scrollbarWidth + 'px'),
            this._isBodyOverflowing &&
              !e &&
              (this._element.style.paddingRight = this._scrollbarWidth + 'px');
        }),
        (P._resetAdjustments = function () {
          (this._element.style.paddingLeft = ''),
            (this._element.style.paddingRight = '');
        }),
        (P._checkScrollbar = function () {
          var e = document.body.getBoundingClientRect();
          (this._isBodyOverflowing =
            Math.round(e.left + e.right) < window.innerWidth),
            (this._scrollbarWidth = this._getScrollbarWidth());
        }),
        (P._setScrollbar = function () {
          var e,
            t,
            o = this;
          this._isBodyOverflowing &&
            ((e = [].slice.call(document.querySelectorAll(Ie))),
            (t = [].slice.call(document.querySelectorAll('.sticky-top'))),
            c.default(e).each(function (e, t) {
              var n = t.style.paddingRight,
                i = c.default(t).css('padding-right');
              c.default(t)
                .data('padding-right', n)
                .css('padding-right', parseFloat(i) + o._scrollbarWidth + 'px');
            }),
            c.default(t).each(function (e, t) {
              var n = t.style.marginRight,
                i = c.default(t).css('margin-right');
              c.default(t)
                .data('margin-right', n)
                .css('margin-right', parseFloat(i) - o._scrollbarWidth + 'px');
            }),
            (e = document.body.style.paddingRight),
            (t = c.default(document.body).css('padding-right')),
            c
              .default(document.body)
              .data('padding-right', e)
              .css(
                'padding-right',
                parseFloat(t) + this._scrollbarWidth + 'px'
              )),
            c.default(document.body).addClass(we);
        }),
        (P._resetScrollbar = function () {
          var e = [].slice.call(document.querySelectorAll(Ie)),
            e =
              (c.default(e).each(function (e, t) {
                var n = c.default(t).data('padding-right');
                c.default(t).removeData('padding-right'),
                  (t.style.paddingRight = n || '');
              }),
              [].slice.call(document.querySelectorAll('.sticky-top'))),
            e =
              (c.default(e).each(function (e, t) {
                var n = c.default(t).data('margin-right');
                void 0 !== n &&
                  c
                    .default(t)
                    .css('margin-right', n)
                    .removeData('margin-right');
              }),
              c.default(document.body).data('padding-right'));
          c.default(document.body).removeData('padding-right'),
            (document.body.style.paddingRight = e || '');
        }),
        (P._getScrollbarWidth = function () {
          var e = document.createElement('div'),
            t =
              ((e.className = 'modal-scrollbar-measure'),
              document.body.appendChild(e),
              e.getBoundingClientRect().width - e.clientWidth);
          return document.body.removeChild(e), t;
        }),
        (k._jQueryInterface = function (n, i) {
          return this.each(function () {
            var e = c.default(this).data(_e),
              t = r(
                {},
                $e,
                c.default(this).data(),
                'object' == typeof n && n ? n : {}
              );
            if (
              (e || ((e = new k(this, t)), c.default(this).data(_e, e)),
              'string' == typeof n)
            ) {
              if (void 0 === e[n])
                throw new TypeError('No method named "' + n + '"');
              e[n](i);
            } else t.show && e.show(i);
          });
        }),
        i(k, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return $e;
            },
          },
        ]),
        k);

    function k(e, t) {
      (this._config = this._getConfig(t)),
        (this._element = e),
        (this._dialog = e.querySelector('.modal-dialog')),
        (this._backdrop = null),
        (this._isShown = !1),
        (this._isBodyOverflowing = !1),
        (this._ignoreBackdropClick = !1),
        (this._isTransitioning = !1),
        (this._scrollbarWidth = 0);
    }
    c
      .default(document)
      .on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
        var t,
          n = this,
          i = h.getSelectorFromElement(this),
          i =
            (i && (t = document.querySelector(i)),
            c.default(t).data(_e)
              ? 'toggle'
              : r({}, c.default(t).data(), c.default(this).data())),
          o =
            (('A' !== this.tagName && 'AREA' !== this.tagName) ||
              e.preventDefault(),
            c.default(t).one(Ee, function (e) {
              e.isDefaultPrevented() ||
                o.one(Te, function () {
                  c.default(n).is(':visible') && n.focus();
                });
            }));
        S._jQueryInterface.call(c.default(t), i, this);
      }),
      (c.default.fn.modal = S._jQueryInterface),
      (c.default.fn.modal.Constructor = S),
      (c.default.fn.modal.noConflict = function () {
        return (c.default.fn.modal = be), S._jQueryInterface;
      });
    var Oe = [
        'background',
        'cite',
        'href',
        'itemtype',
        'longdesc',
        'poster',
        'src',
        'xlink:href',
      ],
      Pe = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,
      Le =
        /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

    function Re(e, o, t) {
      if (0 === e.length) return e;
      if (t && 'function' == typeof t) return t(e);
      for (
        var t = new window.DOMParser().parseFromString(e, 'text/html'),
          r = Object.keys(o),
          s = [].slice.call(t.body.querySelectorAll('*')),
          n = 0,
          i = s.length;
        n < i;
        n++
      )
        !(function (e) {
          var t = s[e],
            e = t.nodeName.toLowerCase();
          if (-1 === r.indexOf(t.nodeName.toLowerCase()))
            return t.parentNode.removeChild(t);
          var n = [].slice.call(t.attributes),
            i = [].concat(o['*'] || [], o[e] || []);
          n.forEach(function (e) {
            !(function (e, t) {
              var n = e.nodeName.toLowerCase();
              if (-1 !== t.indexOf(n))
                return (
                  -1 === Oe.indexOf(n) ||
                  Boolean(Pe.test(e.nodeValue) || Le.test(e.nodeValue))
                );
              for (
                var i = t.filter(function (e) {
                    return e instanceof RegExp;
                  }),
                  o = 0,
                  r = i.length;
                o < r;
                o++
              )
                if (i[o].test(n)) return 1;
            })(e, i) && t.removeAttribute(e.nodeName);
          });
        })(n);
      return t.body.innerHTML;
    }
    var ze = 'tooltip',
      Me = 'bs.tooltip',
      qe = c.default.fn.tooltip,
      He = new RegExp('(^|\\s)bs-tooltip\\S+', 'g'),
      Fe = ['sanitize', 'whiteList', 'sanitizeFn'],
      We = 'fade',
      Be = 'show',
      D = 'show',
      Qe = 'hover',
      Ue = {
        AUTO: 'auto',
        TOP: 'top',
        RIGHT: 'right',
        BOTTOM: 'bottom',
        LEFT: 'left',
      },
      Ve = {
        animation: !0,
        template:
          '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: !1,
        selector: !1,
        placement: 'top',
        offset: 0,
        container: !1,
        fallbackPlacement: 'flip',
        boundary: 'scrollParent',
        customClass: '',
        sanitize: !0,
        sanitizeFn: null,
        whiteList: {
          '*': ['class', 'dir', 'id', 'lang', 'role', /^aria-[\w-]*$/i],
          a: ['target', 'href', 'title', 'rel'],
          area: [],
          b: [],
          br: [],
          col: [],
          code: [],
          div: [],
          em: [],
          hr: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          i: [],
          img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
          li: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
        },
        popperConfig: null,
      },
      Xe = {
        animation: 'boolean',
        template: 'string',
        title: '(string|element|function)',
        trigger: 'string',
        delay: '(number|object)',
        html: 'boolean',
        selector: '(string|boolean)',
        placement: '(string|function)',
        offset: '(number|string|function)',
        container: '(string|element|boolean)',
        fallbackPlacement: '(string|array)',
        boundary: '(string|element)',
        customClass: '(string|function)',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        whiteList: 'object',
        popperConfig: '(null|object)',
      },
      Ye = {
        HIDE: 'hide.bs.tooltip',
        HIDDEN: 'hidden.bs.tooltip',
        SHOW: 'show.bs.tooltip',
        SHOWN: 'shown.bs.tooltip',
        INSERTED: 'inserted.bs.tooltip',
        CLICK: 'click.bs.tooltip',
        FOCUSIN: 'focusin.bs.tooltip',
        FOCUSOUT: 'focusout.bs.tooltip',
        MOUSEENTER: 'mouseenter.bs.tooltip',
        MOUSELEAVE: 'mouseleave.bs.tooltip',
      },
      A =
        (((n = N.prototype).enable = function () {
          this._isEnabled = !0;
        }),
        (n.disable = function () {
          this._isEnabled = !1;
        }),
        (n.toggleEnabled = function () {
          this._isEnabled = !this._isEnabled;
        }),
        (n.toggle = function (e) {
          var t, n;
          this._isEnabled &&
            (e
              ? ((t = this.constructor.DATA_KEY),
                (n = c.default(e.currentTarget).data(t)) ||
                  ((n = new this.constructor(
                    e.currentTarget,
                    this._getDelegateConfig()
                  )),
                  c.default(e.currentTarget).data(t, n)),
                (n._activeTrigger.click = !n._activeTrigger.click),
                n._isWithActiveTrigger()
                  ? n._enter(null, n)
                  : n._leave(null, n))
              : c.default(this.getTipElement()).hasClass(Be)
              ? this._leave(null, this)
              : this._enter(null, this));
        }),
        (n.dispose = function () {
          clearTimeout(this._timeout),
            c.default.removeData(this.element, this.constructor.DATA_KEY),
            c.default(this.element).off(this.constructor.EVENT_KEY),
            c
              .default(this.element)
              .closest('.modal')
              .off('hide.bs.modal', this._hideModalHandler),
            this.tip && c.default(this.tip).remove(),
            (this._isEnabled = null),
            (this._timeout = null),
            (this._hoverState = null),
            (this._activeTrigger = null),
            this._popper && this._popper.destroy(),
            (this._popper = null),
            (this.element = null),
            (this.config = null),
            (this.tip = null);
        }),
        (n.show = function () {
          var t = this;
          if ('none' === c.default(this.element).css('display'))
            throw new Error('Please use show on visible elements');
          var e,
            n,
            i = c.default.Event(this.constructor.Event.SHOW);
          this.isWithContent() &&
            this._isEnabled &&
            (c.default(this.element).trigger(i),
            (n = h.findShadowRoot(this.element)),
            (n = c.default.contains(
              null !== n ? n : this.element.ownerDocument.documentElement,
              this.element
            )),
            !i.isDefaultPrevented()) &&
            n &&
            ((i = this.getTipElement()),
            (n = h.getUID(this.constructor.NAME)),
            i.setAttribute('id', n),
            this.element.setAttribute('aria-describedby', n),
            this.setContent(),
            this.config.animation && c.default(i).addClass(We),
            (n =
              'function' == typeof this.config.placement
                ? this.config.placement.call(this, i, this.element)
                : this.config.placement),
            (n = this._getAttachment(n)),
            this.addAttachmentClass(n),
            (e = this._getContainer()),
            c.default(i).data(this.constructor.DATA_KEY, this),
            c.default.contains(
              this.element.ownerDocument.documentElement,
              this.tip
            ) || c.default(i).appendTo(e),
            c.default(this.element).trigger(this.constructor.Event.INSERTED),
            (this._popper = new R.default(
              this.element,
              i,
              this._getPopperConfig(n)
            )),
            c.default(i).addClass(Be),
            c.default(i).addClass(this.config.customClass),
            'ontouchstart' in document.documentElement &&
              c
                .default(document.body)
                .children()
                .on('mouseover', null, c.default.noop),
            (e = function () {
              t.config.animation && t._fixTransition();
              var e = t._hoverState;
              (t._hoverState = null),
                c.default(t.element).trigger(t.constructor.Event.SHOWN),
                'out' === e && t._leave(null, t);
            }),
            c.default(this.tip).hasClass(We)
              ? ((n = h.getTransitionDurationFromElement(this.tip)),
                c
                  .default(this.tip)
                  .one(h.TRANSITION_END, e)
                  .emulateTransitionEnd(n))
              : e());
        }),
        (n.hide = function (e) {
          function t() {
            n._hoverState !== D && i.parentNode && i.parentNode.removeChild(i),
              n._cleanTipClass(),
              n.element.removeAttribute('aria-describedby'),
              c.default(n.element).trigger(n.constructor.Event.HIDDEN),
              null !== n._popper && n._popper.destroy(),
              e && e();
          }
          var n = this,
            i = this.getTipElement(),
            o = c.default.Event(this.constructor.Event.HIDE);
          c.default(this.element).trigger(o),
            o.isDefaultPrevented() ||
              (c.default(i).removeClass(Be),
              'ontouchstart' in document.documentElement &&
                c
                  .default(document.body)
                  .children()
                  .off('mouseover', null, c.default.noop),
              (this._activeTrigger.click = !1),
              (this._activeTrigger.focus = !1),
              (this._activeTrigger.hover = !1),
              c.default(this.tip).hasClass(We)
                ? ((o = h.getTransitionDurationFromElement(i)),
                  c.default(i).one(h.TRANSITION_END, t).emulateTransitionEnd(o))
                : t(),
              (this._hoverState = ''));
        }),
        (n.update = function () {
          null !== this._popper && this._popper.scheduleUpdate();
        }),
        (n.isWithContent = function () {
          return Boolean(this.getTitle());
        }),
        (n.addAttachmentClass = function (e) {
          c.default(this.getTipElement()).addClass('bs-tooltip-' + e);
        }),
        (n.getTipElement = function () {
          return (
            (this.tip = this.tip || c.default(this.config.template)[0]),
            this.tip
          );
        }),
        (n.setContent = function () {
          var e = this.getTipElement();
          this.setElementContent(
            c.default(e.querySelectorAll('.tooltip-inner')),
            this.getTitle()
          ),
            c.default(e).removeClass('fade show');
        }),
        (n.setElementContent = function (e, t) {
          'object' != typeof t || (!t.nodeType && !t.jquery)
            ? this.config.html
              ? (this.config.sanitize &&
                  (t = Re(t, this.config.whiteList, this.config.sanitizeFn)),
                e.html(t))
              : e.text(t)
            : this.config.html
            ? c.default(t).parent().is(e) || e.empty().append(t)
            : e.text(c.default(t).text());
        }),
        (n.getTitle = function () {
          return (
            this.element.getAttribute('data-original-title') ||
            ('function' == typeof this.config.title
              ? this.config.title.call(this.element)
              : this.config.title)
          );
        }),
        (n._getPopperConfig = function (e) {
          var t = this;
          return r(
            {},
            {
              placement: e,
              modifiers: {
                offset: this._getOffset(),
                flip: {
                  behavior: this.config.fallbackPlacement,
                },
                arrow: {
                  element: '.arrow',
                },
                preventOverflow: {
                  boundariesElement: this.config.boundary,
                },
              },
              onCreate: function (e) {
                e.originalPlacement !== e.placement &&
                  t._handlePopperPlacementChange(e);
              },
              onUpdate: function (e) {
                return t._handlePopperPlacementChange(e);
              },
            },
            this.config.popperConfig
          );
        }),
        (n._getOffset = function () {
          var t = this,
            e = {};
          return (
            'function' == typeof this.config.offset
              ? (e.fn = function (e) {
                  return (
                    (e.offsets = r(
                      {},
                      e.offsets,
                      t.config.offset(e.offsets, t.element)
                    )),
                    e
                  );
                })
              : (e.offset = this.config.offset),
            e
          );
        }),
        (n._getContainer = function () {
          return !1 === this.config.container
            ? document.body
            : h.isElement(this.config.container)
            ? c.default(this.config.container)
            : c.default(document).find(this.config.container);
        }),
        (n._getAttachment = function (e) {
          return Ue[e.toUpperCase()];
        }),
        (n._setListeners = function () {
          var n = this;
          this.config.trigger.split(' ').forEach(function (e) {
            var t;
            'click' === e
              ? c
                  .default(n.element)
                  .on(
                    n.constructor.Event.CLICK,
                    n.config.selector,
                    function (e) {
                      return n.toggle(e);
                    }
                  )
              : 'manual' !== e &&
                ((t =
                  e === Qe
                    ? n.constructor.Event.MOUSEENTER
                    : n.constructor.Event.FOCUSIN),
                (e =
                  e === Qe
                    ? n.constructor.Event.MOUSELEAVE
                    : n.constructor.Event.FOCUSOUT),
                c
                  .default(n.element)
                  .on(t, n.config.selector, function (e) {
                    return n._enter(e);
                  })
                  .on(e, n.config.selector, function (e) {
                    return n._leave(e);
                  }));
          }),
            (this._hideModalHandler = function () {
              n.element && n.hide();
            }),
            c
              .default(this.element)
              .closest('.modal')
              .on('hide.bs.modal', this._hideModalHandler),
            this.config.selector
              ? (this.config = r({}, this.config, {
                  trigger: 'manual',
                  selector: '',
                }))
              : this._fixTitle();
        }),
        (n._fixTitle = function () {
          var e = typeof this.element.getAttribute('data-original-title');
          (!this.element.getAttribute('title') && 'string' == e) ||
            (this.element.setAttribute(
              'data-original-title',
              this.element.getAttribute('title') || ''
            ),
            this.element.setAttribute('title', ''));
        }),
        (n._enter = function (e, t) {
          var n = this.constructor.DATA_KEY;
          (t = t || c.default(e.currentTarget).data(n)) ||
            ((t = new this.constructor(
              e.currentTarget,
              this._getDelegateConfig()
            )),
            c.default(e.currentTarget).data(n, t)),
            e && (t._activeTrigger['focusin' === e.type ? 'focus' : Qe] = !0),
            c.default(t.getTipElement()).hasClass(Be) || t._hoverState === D
              ? (t._hoverState = D)
              : (clearTimeout(t._timeout),
                (t._hoverState = D),
                t.config.delay && t.config.delay.show
                  ? (t._timeout = setTimeout(function () {
                      t._hoverState === D && t.show();
                    }, t.config.delay.show))
                  : t.show());
        }),
        (n._leave = function (e, t) {
          var n = this.constructor.DATA_KEY;
          (t = t || c.default(e.currentTarget).data(n)) ||
            ((t = new this.constructor(
              e.currentTarget,
              this._getDelegateConfig()
            )),
            c.default(e.currentTarget).data(n, t)),
            e && (t._activeTrigger['focusout' === e.type ? 'focus' : Qe] = !1),
            t._isWithActiveTrigger() ||
              (clearTimeout(t._timeout),
              (t._hoverState = 'out'),
              t.config.delay && t.config.delay.hide
                ? (t._timeout = setTimeout(function () {
                    'out' === t._hoverState && t.hide();
                  }, t.config.delay.hide))
                : t.hide());
        }),
        (n._isWithActiveTrigger = function () {
          for (var e in this._activeTrigger)
            if (this._activeTrigger[e]) return !0;
          return !1;
        }),
        (n._getConfig = function (e) {
          var t = c.default(this.element).data();
          return (
            Object.keys(t).forEach(function (e) {
              -1 !== Fe.indexOf(e) && delete t[e];
            }),
            'number' ==
              typeof (e = r(
                {},
                this.constructor.Default,
                t,
                'object' == typeof e && e ? e : {}
              )).delay &&
              (e.delay = {
                show: e.delay,
                hide: e.delay,
              }),
            'number' == typeof e.title && (e.title = e.title.toString()),
            'number' == typeof e.content && (e.content = e.content.toString()),
            h.typeCheckConfig(ze, e, this.constructor.DefaultType),
            e.sanitize &&
              (e.template = Re(e.template, e.whiteList, e.sanitizeFn)),
            e
          );
        }),
        (n._getDelegateConfig = function () {
          var e = {};
          if (this.config)
            for (var t in this.config)
              this.constructor.Default[t] !== this.config[t] &&
                (e[t] = this.config[t]);
          return e;
        }),
        (n._cleanTipClass = function () {
          var e = c.default(this.getTipElement()),
            t = e.attr('class').match(He);
          null !== t && t.length && e.removeClass(t.join(''));
        }),
        (n._handlePopperPlacementChange = function (e) {
          (this.tip = e.instance.popper),
            this._cleanTipClass(),
            this.addAttachmentClass(this._getAttachment(e.placement));
        }),
        (n._fixTransition = function () {
          var e = this.getTipElement(),
            t = this.config.animation;
          null === e.getAttribute('x-placement') &&
            (c.default(e).removeClass(We),
            (this.config.animation = !1),
            this.hide(),
            this.show(),
            (this.config.animation = t));
        }),
        (N._jQueryInterface = function (i) {
          return this.each(function () {
            var e = c.default(this),
              t = e.data(Me),
              n = 'object' == typeof i && i;
            if (
              (t || !/dispose|hide/.test(i)) &&
              (t || ((t = new N(this, n)), e.data(Me, t)), 'string' == typeof i)
            ) {
              if (void 0 === t[i])
                throw new TypeError('No method named "' + i + '"');
              t[i]();
            }
          });
        }),
        i(N, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return Ve;
            },
          },
          {
            key: 'NAME',
            get: function () {
              return ze;
            },
          },
          {
            key: 'DATA_KEY',
            get: function () {
              return Me;
            },
          },
          {
            key: 'Event',
            get: function () {
              return Ye;
            },
          },
          {
            key: 'EVENT_KEY',
            get: function () {
              return '.bs.tooltip';
            },
          },
          {
            key: 'DefaultType',
            get: function () {
              return Xe;
            },
          },
        ]),
        N);

    function N(e, t) {
      if (void 0 === R.default)
        throw new TypeError(
          "Bootstrap's tooltips require Popper (https://popper.js.org)"
        );
      (this._isEnabled = !0),
        (this._timeout = 0),
        (this._hoverState = ''),
        (this._activeTrigger = {}),
        (this._popper = null),
        (this.element = e),
        (this.config = this._getConfig(t)),
        (this.tip = null),
        this._setListeners();
    }
    (c.default.fn.tooltip = A._jQueryInterface),
      (c.default.fn.tooltip.Constructor = A),
      (c.default.fn.tooltip.noConflict = function () {
        return (c.default.fn.tooltip = qe), A._jQueryInterface;
      });
    var Ke,
      Je = 'bs.popover',
      Ge = c.default.fn.popover,
      Ze = new RegExp('(^|\\s)bs-popover\\S+', 'g'),
      et = r({}, A.Default, {
        placement: 'right',
        trigger: 'click',
        content: '',
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      }),
      tt = r({}, A.DefaultType, {
        content: '(string|element|function)',
      }),
      nt = {
        HIDE: 'hide.bs.popover',
        HIDDEN: 'hidden.bs.popover',
        SHOW: 'show.bs.popover',
        SHOWN: 'shown.bs.popover',
        INSERTED: 'inserted.bs.popover',
        CLICK: 'click.bs.popover',
        FOCUSIN: 'focusin.bs.popover',
        FOCUSOUT: 'focusout.bs.popover',
        MOUSEENTER: 'mouseenter.bs.popover',
        MOUSELEAVE: 'mouseleave.bs.popover',
      },
      it =
        ((t = Ke = A),
        ((P = I).prototype = Object.create(t.prototype)),
        M((P.prototype.constructor = P), t),
        ((P = I.prototype).isWithContent = function () {
          return this.getTitle() || this._getContent();
        }),
        (P.addAttachmentClass = function (e) {
          c.default(this.getTipElement()).addClass('bs-popover-' + e);
        }),
        (P.getTipElement = function () {
          return (
            (this.tip = this.tip || c.default(this.config.template)[0]),
            this.tip
          );
        }),
        (P.setContent = function () {
          var e = c.default(this.getTipElement()),
            t =
              (this.setElementContent(
                e.find('.popover-header'),
                this.getTitle()
              ),
              this._getContent());
          'function' == typeof t && (t = t.call(this.element)),
            this.setElementContent(e.find('.popover-body'), t),
            e.removeClass('fade show');
        }),
        (P._getContent = function () {
          return (
            this.element.getAttribute('data-content') || this.config.content
          );
        }),
        (P._cleanTipClass = function () {
          var e = c.default(this.getTipElement()),
            t = e.attr('class').match(Ze);
          null !== t && 0 < t.length && e.removeClass(t.join(''));
        }),
        (I._jQueryInterface = function (n) {
          return this.each(function () {
            var e = c.default(this).data(Je),
              t = 'object' == typeof n ? n : null;
            if (
              (e || !/dispose|hide/.test(n)) &&
              (e || ((e = new I(this, t)), c.default(this).data(Je, e)),
              'string' == typeof n)
            ) {
              if (void 0 === e[n])
                throw new TypeError('No method named "' + n + '"');
              e[n]();
            }
          });
        }),
        i(I, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return et;
            },
          },
          {
            key: 'NAME',
            get: function () {
              return 'popover';
            },
          },
          {
            key: 'DATA_KEY',
            get: function () {
              return Je;
            },
          },
          {
            key: 'Event',
            get: function () {
              return nt;
            },
          },
          {
            key: 'EVENT_KEY',
            get: function () {
              return '.bs.popover';
            },
          },
          {
            key: 'DefaultType',
            get: function () {
              return tt;
            },
          },
        ]),
        I);

    function I() {
      return Ke.apply(this, arguments) || this;
    }
    (c.default.fn.popover = it._jQueryInterface),
      (c.default.fn.popover.Constructor = it),
      (c.default.fn.popover.noConflict = function () {
        return (c.default.fn.popover = Ge), it._jQueryInterface;
      });
    var $ = 'scrollspy',
      ot = 'bs.scrollspy',
      rt = c.default.fn[$],
      j = 'active',
      st = 'position',
      at = '.nav, .list-group',
      lt = {
        offset: 10,
        method: 'auto',
        target: '',
      },
      ut = {
        offset: 'number',
        method: 'string',
        target: '(string|element)',
      },
      O =
        (((n = ct.prototype).refresh = function () {
          var t = this,
            e =
              this._scrollElement === this._scrollElement.window
                ? 'offset'
                : st,
            i = 'auto' === this._config.method ? e : this._config.method,
            o = i === st ? this._getScrollTop() : 0;
          (this._offsets = []),
            (this._targets = []),
            (this._scrollHeight = this._getScrollHeight()),
            [].slice
              .call(document.querySelectorAll(this._selector))
              .map(function (e) {
                var t,
                  e = h.getSelectorFromElement(e);
                if ((t = e ? document.querySelector(e) : t)) {
                  var n = t.getBoundingClientRect();
                  if (n.width || n.height)
                    return [c.default(t)[i]().top + o, e];
                }
                return null;
              })
              .filter(Boolean)
              .sort(function (e, t) {
                return e[0] - t[0];
              })
              .forEach(function (e) {
                t._offsets.push(e[0]), t._targets.push(e[1]);
              });
        }),
        (n.dispose = function () {
          c.default.removeData(this._element, ot),
            c.default(this._scrollElement).off('.bs.scrollspy'),
            (this._element = null),
            (this._scrollElement = null),
            (this._config = null),
            (this._selector = null),
            (this._offsets = null),
            (this._targets = null),
            (this._activeTarget = null),
            (this._scrollHeight = null);
        }),
        (n._getConfig = function (e) {
          var t;
          return (
            'string' !=
              typeof (e = r({}, lt, 'object' == typeof e && e ? e : {}))
                .target &&
              h.isElement(e.target) &&
              ((t = c.default(e.target).attr('id')) ||
                ((t = h.getUID($)), c.default(e.target).attr('id', t)),
              (e.target = '#' + t)),
            h.typeCheckConfig($, e, ut),
            e
          );
        }),
        (n._getScrollTop = function () {
          return this._scrollElement === window
            ? this._scrollElement.pageYOffset
            : this._scrollElement.scrollTop;
        }),
        (n._getScrollHeight = function () {
          return (
            this._scrollElement.scrollHeight ||
            Math.max(
              document.body.scrollHeight,
              document.documentElement.scrollHeight
            )
          );
        }),
        (n._getOffsetHeight = function () {
          return this._scrollElement === window
            ? window.innerHeight
            : this._scrollElement.getBoundingClientRect().height;
        }),
        (n._process = function () {
          var e = this._getScrollTop() + this._config.offset,
            t = this._getScrollHeight(),
            n = this._config.offset + t - this._getOffsetHeight();
          if ((this._scrollHeight !== t && this.refresh(), n <= e)) {
            t = this._targets[this._targets.length - 1];
            this._activeTarget !== t && this._activate(t);
          } else if (
            this._activeTarget &&
            e < this._offsets[0] &&
            0 < this._offsets[0]
          )
            (this._activeTarget = null), this._clear();
          else
            for (var i = this._offsets.length; i--; )
              this._activeTarget !== this._targets[i] &&
                e >= this._offsets[i] &&
                (void 0 === this._offsets[i + 1] || e < this._offsets[i + 1]) &&
                this._activate(this._targets[i]);
        }),
        (n._activate = function (t) {
          (this._activeTarget = t), this._clear();
          var e = this._selector.split(',').map(function (e) {
              return (
                e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]'
              );
            }),
            e = c.default(
              [].slice.call(document.querySelectorAll(e.join(',')))
            );
          (e.hasClass('dropdown-item')
            ? (e.closest('.dropdown').find('.dropdown-toggle').addClass(j), e)
            : (e.addClass(j),
              e.parents(at).prev('.nav-link, .list-group-item').addClass(j),
              e.parents(at).prev('.nav-item').children('.nav-link'))
          ).addClass(j),
            c.default(this._scrollElement).trigger('activate.bs.scrollspy', {
              relatedTarget: t,
            });
        }),
        (n._clear = function () {
          [].slice
            .call(document.querySelectorAll(this._selector))
            .filter(function (e) {
              return e.classList.contains(j);
            })
            .forEach(function (e) {
              return e.classList.remove(j);
            });
        }),
        (ct._jQueryInterface = function (t) {
          return this.each(function () {
            var e = c.default(this).data(ot);
            if (
              (e ||
                ((e = new ct(this, 'object' == typeof t && t)),
                c.default(this).data(ot, e)),
              'string' == typeof t)
            ) {
              if (void 0 === e[t])
                throw new TypeError('No method named "' + t + '"');
              e[t]();
            }
          });
        }),
        i(ct, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'Default',
            get: function () {
              return lt;
            },
          },
        ]),
        ct);

    function ct(e, t) {
      var n = this;
      (this._element = e),
        (this._scrollElement = 'BODY' === e.tagName ? window : e),
        (this._config = this._getConfig(t)),
        (this._selector =
          this._config.target +
          ' .nav-link,' +
          this._config.target +
          ' .list-group-item,' +
          this._config.target +
          ' .dropdown-item'),
        (this._offsets = []),
        (this._targets = []),
        (this._activeTarget = null),
        (this._scrollHeight = 0),
        c.default(this._scrollElement).on('scroll.bs.scrollspy', function (e) {
          return n._process(e);
        }),
        this.refresh(),
        this._process();
    }
    c.default(window).on('load.bs.scrollspy.data-api', function () {
      for (
        var e = [].slice.call(document.querySelectorAll('[data-spy="scroll"]')),
          t = e.length;
        t--;

      ) {
        var n = c.default(e[t]);
        O._jQueryInterface.call(n, n.data());
      }
    }),
      (c.default.fn[$] = O._jQueryInterface),
      (c.default.fn[$].Constructor = O),
      (c.default.fn[$].noConflict = function () {
        return (c.default.fn[$] = rt), O._jQueryInterface;
      });
    var ht = 'bs.tab',
      dt = c.default.fn.tab,
      ft = 'active',
      pt = '.active',
      gt = '> li > .active',
      mt =
        (((t = vt.prototype).show = function () {
          var e,
            t,
            n,
            i,
            o,
            r,
            s = this;
          (this._element.parentNode &&
            this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
            c.default(this._element).hasClass(ft)) ||
            c.default(this._element).hasClass('disabled') ||
            this._element.hasAttribute('disabled') ||
            ((t = c.default(this._element).closest('.nav, .list-group')[0]),
            (n = h.getSelectorFromElement(this._element)),
            t &&
              ((o = 'UL' === t.nodeName || 'OL' === t.nodeName ? gt : pt),
              (i = (i = c.default.makeArray(c.default(t).find(o)))[
                i.length - 1
              ])),
            (o = c.default.Event('hide.bs.tab', {
              relatedTarget: this._element,
            })),
            (r = c.default.Event('show.bs.tab', {
              relatedTarget: i,
            })),
            i && c.default(i).trigger(o),
            c.default(this._element).trigger(r),
            r.isDefaultPrevented()) ||
            o.isDefaultPrevented() ||
            (n && (e = document.querySelector(n)),
            this._activate(this._element, t),
            (r = function () {
              var e = c.default.Event('hidden.bs.tab', {
                  relatedTarget: s._element,
                }),
                t = c.default.Event('shown.bs.tab', {
                  relatedTarget: i,
                });
              c.default(i).trigger(e), c.default(s._element).trigger(t);
            }),
            e ? this._activate(e, e.parentNode, r) : r());
        }),
        (t.dispose = function () {
          c.default.removeData(this._element, ht), (this._element = null);
        }),
        (t._activate = function (e, t, n) {
          function i() {
            return o._transitionComplete(e, r, n);
          }
          var o = this,
            r = (
              !t || ('UL' !== t.nodeName && 'OL' !== t.nodeName)
                ? c.default(t).children(pt)
                : c.default(t).find(gt)
            )[0],
            t = n && r && c.default(r).hasClass('fade');
          r && t
            ? ((t = h.getTransitionDurationFromElement(r)),
              c
                .default(r)
                .removeClass('show')
                .one(h.TRANSITION_END, i)
                .emulateTransitionEnd(t))
            : i();
        }),
        (t._transitionComplete = function (e, t, n) {
          t &&
            (c.default(t).removeClass(ft),
            (i = c.default(t.parentNode).find('> .dropdown-menu .active')[0]) &&
              c.default(i).removeClass(ft),
            'tab' === t.getAttribute('role')) &&
            t.setAttribute('aria-selected', !1),
            c.default(e).addClass(ft),
            'tab' === e.getAttribute('role') &&
              e.setAttribute('aria-selected', !0),
            h.reflow(e),
            e.classList.contains('fade') && e.classList.add('show');
          var i = e.parentNode;
          (i = i && 'LI' === i.nodeName ? i.parentNode : i) &&
            c.default(i).hasClass('dropdown-menu') &&
            ((t = c.default(e).closest('.dropdown')[0]) &&
              ((i = [].slice.call(t.querySelectorAll('.dropdown-toggle'))),
              c.default(i).addClass(ft)),
            e.setAttribute('aria-expanded', !0)),
            n && n();
        }),
        (vt._jQueryInterface = function (n) {
          return this.each(function () {
            var e = c.default(this),
              t = e.data(ht);
            if (
              (t || ((t = new vt(this)), e.data(ht, t)), 'string' == typeof n)
            ) {
              if (void 0 === t[n])
                throw new TypeError('No method named "' + n + '"');
              t[n]();
            }
          });
        }),
        i(vt, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
        ]),
        vt);

    function vt(e) {
      this._element = e;
    }
    c
      .default(document)
      .on(
        'click.bs.tab.data-api',
        '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
        function (e) {
          e.preventDefault(), mt._jQueryInterface.call(c.default(this), 'show');
        }
      ),
      (c.default.fn.tab = mt._jQueryInterface),
      (c.default.fn.tab.Constructor = mt),
      (c.default.fn.tab.noConflict = function () {
        return (c.default.fn.tab = dt), mt._jQueryInterface;
      });
    var P,
      yt = 'bs.toast',
      _t = c.default.fn.toast,
      bt = 'show',
      wt = 'showing',
      xt = 'click.dismiss.bs.toast',
      Ct = {
        animation: !0,
        autohide: !0,
        delay: 500,
      },
      Tt = {
        animation: 'boolean',
        autohide: 'boolean',
        delay: 'number',
      },
      Et =
        (((P = St.prototype).show = function () {
          var e,
            t = this,
            n = c.default.Event('show.bs.toast');
          c.default(this._element).trigger(n),
            n.isDefaultPrevented() ||
              (this._clearTimeout(),
              this._config.animation && this._element.classList.add('fade'),
              (n = function () {
                t._element.classList.remove(wt),
                  t._element.classList.add(bt),
                  c.default(t._element).trigger('shown.bs.toast'),
                  t._config.autohide &&
                    (t._timeout = setTimeout(function () {
                      t.hide();
                    }, t._config.delay));
              }),
              this._element.classList.remove('hide'),
              h.reflow(this._element),
              this._element.classList.add(wt),
              this._config.animation
                ? ((e = h.getTransitionDurationFromElement(this._element)),
                  c
                    .default(this._element)
                    .one(h.TRANSITION_END, n)
                    .emulateTransitionEnd(e))
                : n());
        }),
        (P.hide = function () {
          var e;
          this._element.classList.contains(bt) &&
            ((e = c.default.Event('hide.bs.toast')),
            c.default(this._element).trigger(e),
            e.isDefaultPrevented() || this._close());
        }),
        (P.dispose = function () {
          this._clearTimeout(),
            this._element.classList.contains(bt) &&
              this._element.classList.remove(bt),
            c.default(this._element).off(xt),
            c.default.removeData(this._element, yt),
            (this._element = null),
            (this._config = null);
        }),
        (P._getConfig = function (e) {
          return (
            (e = r(
              {},
              Ct,
              c.default(this._element).data(),
              'object' == typeof e && e ? e : {}
            )),
            h.typeCheckConfig('toast', e, this.constructor.DefaultType),
            e
          );
        }),
        (P._setListeners = function () {
          var e = this;
          c.default(this._element).on(
            xt,
            '[data-dismiss="toast"]',
            function () {
              return e.hide();
            }
          );
        }),
        (P._close = function () {
          function e() {
            n._element.classList.add('hide'),
              c.default(n._element).trigger('hidden.bs.toast');
          }
          var t,
            n = this;
          this._element.classList.remove(bt),
            this._config.animation
              ? ((t = h.getTransitionDurationFromElement(this._element)),
                c
                  .default(this._element)
                  .one(h.TRANSITION_END, e)
                  .emulateTransitionEnd(t))
              : e();
        }),
        (P._clearTimeout = function () {
          clearTimeout(this._timeout), (this._timeout = null);
        }),
        (St._jQueryInterface = function (n) {
          return this.each(function () {
            var e = c.default(this),
              t = e.data(yt);
            if (
              (t ||
                ((t = new St(this, 'object' == typeof n && n)), e.data(yt, t)),
              'string' == typeof n)
            ) {
              if (void 0 === t[n])
                throw new TypeError('No method named "' + n + '"');
              t[n](this);
            }
          });
        }),
        i(St, null, [
          {
            key: 'VERSION',
            get: function () {
              return '4.6.2';
            },
          },
          {
            key: 'DefaultType',
            get: function () {
              return Tt;
            },
          },
          {
            key: 'Default',
            get: function () {
              return Ct;
            },
          },
        ]),
        St);

    function St(e, t) {
      (this._element = e),
        (this._config = this._getConfig(t)),
        (this._timeout = null),
        this._setListeners();
    }
    (c.default.fn.toast = Et._jQueryInterface),
      (c.default.fn.toast.Constructor = Et),
      (c.default.fn.toast.noConflict = function () {
        return (c.default.fn.toast = _t), Et._jQueryInterface;
      }),
      (e.Alert = o),
      (e.Button = a),
      (e.Carousel = p),
      (e.Collapse = _),
      (e.Dropdown = C),
      (e.Modal = S),
      (e.Popover = it),
      (e.Scrollspy = O),
      (e.Tab = mt),
      (e.Toast = Et),
      (e.Tooltip = A),
      (e.Util = h),
      Object.defineProperty(e, '__esModule', {
        value: !0,
      });
  }),
  (function (l, n, i, a) {
    function u(e, t) {
      (this.settings = null),
        (this.options = l.extend({}, u.Defaults, t)),
        (this.$element = l(e)),
        (this._handlers = {}),
        (this._plugins = {}),
        (this._supress = {}),
        (this._current = null),
        (this._speed = null),
        (this._coordinates = []),
        (this._breakpoint = null),
        (this._width = null),
        (this._items = []),
        (this._clones = []),
        (this._mergers = []),
        (this._widths = []),
        (this._invalidated = {}),
        (this._pipe = []),
        (this._drag = {
          time: null,
          target: null,
          pointer: null,
          stage: {
            start: null,
            current: null,
          },
          direction: null,
        }),
        (this._states = {
          current: {},
          tags: {
            initializing: ['busy'],
            animating: ['busy'],
            dragging: ['interacting'],
          },
        }),
        l.each(
          ['onResize', 'onThrottledResize'],
          l.proxy(function (e, t) {
            this._handlers[t] = l.proxy(this[t], this);
          }, this)
        ),
        l.each(
          u.Plugins,
          l.proxy(function (e, t) {
            this._plugins[e.charAt(0).toLowerCase() + e.slice(1)] = new t(this);
          }, this)
        ),
        l.each(
          u.Workers,
          l.proxy(function (e, t) {
            this._pipe.push({
              filter: t.filter,
              run: l.proxy(t.run, this),
            });
          }, this)
        ),
        this.setup(),
        this.initialize();
    }
    (u.Defaults = {
      items: 3,
      loop: !1,
      center: !1,
      rewind: !1,
      checkVisibility: !0,
      mouseDrag: !0,
      touchDrag: !0,
      pullDrag: !0,
      freeDrag: !1,
      margin: 0,
      stagePadding: 0,
      merge: !1,
      mergeFit: !0,
      autoWidth: !1,
      startPosition: 0,
      rtl: !1,
      smartSpeed: 250,
      fluidSpeed: !1,
      dragEndSpeed: !1,
      responsive: {},
      responsiveRefreshRate: 200,
      responsiveBaseElement: n,
      fallbackEasing: 'swing',
      slideTransition: '',
      info: !1,
      nestedItemSelector: !1,
      itemElement: 'div',
      stageElement: 'div',
      refreshClass: 'owl-refresh',
      loadedClass: 'owl-loaded',
      loadingClass: 'owl-loading',
      rtlClass: 'owl-rtl',
      responsiveClass: 'owl-responsive',
      dragClass: 'owl-drag',
      itemClass: 'owl-item',
      stageClass: 'owl-stage',
      stageOuterClass: 'owl-stage-outer',
      grabClass: 'owl-grab',
    }),
      (u.Width = {
        Default: 'default',
        Inner: 'inner',
        Outer: 'outer',
      }),
      (u.Type = {
        Event: 'event',
        State: 'state',
      }),
      (u.Plugins = {}),
      (u.Workers = [
        {
          filter: ['width', 'settings'],
          run: function () {
            this._width = this.$element.width();
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (e) {
            e.current =
              this._items && this._items[this.relative(this._current)];
          },
        },
        {
          filter: ['items', 'settings'],
          run: function () {
            this.$stage.children('.cloned').remove();
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (e) {
            var t = this.settings.margin || '',
              n = !this.settings.autoWidth,
              i = this.settings.rtl,
              i = {
                width: 'auto',
                'margin-left': i ? t : '',
                'margin-right': i ? '' : t,
              };
            n || this.$stage.children().css(i), (e.css = i);
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (e) {
            var t,
              n =
                (this.width() / this.settings.items).toFixed(3) -
                this.settings.margin,
              i = this._items.length,
              o = !this.settings.autoWidth,
              r = [];
            for (
              e.items = {
                merge: !1,
                width: n,
              };
              i--;

            )
              (t = this._mergers[i]),
                (t =
                  (this.settings.mergeFit &&
                    Math.min(t, this.settings.items)) ||
                  t),
                (e.items.merge = 1 < t || e.items.merge),
                (r[i] = o ? n * t : this._items[i].width());
            this._widths = r;
          },
        },
        {
          filter: ['items', 'settings'],
          run: function () {
            var e = [],
              t = this._items,
              n = this.settings,
              i = Math.max(2 * n.items, 4),
              o = 2 * Math.ceil(t.length / 2),
              r = n.loop && t.length ? (n.rewind ? i : Math.max(i, o)) : 0,
              s = '',
              a = '';
            for (r /= 2; 0 < r; )
              e.push(this.normalize(e.length / 2, !0)),
                (s += t[e[e.length - 1]][0].outerHTML),
                e.push(this.normalize(t.length - 1 - (e.length - 1) / 2, !0)),
                (a = t[e[e.length - 1]][0].outerHTML + a),
                --r;
            (this._clones = e),
              l(s).addClass('cloned').appendTo(this.$stage),
              l(a).addClass('cloned').prependTo(this.$stage);
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function () {
            for (
              var e,
                t,
                n = this.settings.rtl ? 1 : -1,
                i = this._clones.length + this._items.length,
                o = -1,
                r = [];
              ++o < i;

            )
              (e = r[o - 1] || 0),
                (t = this._widths[this.relative(o)] + this.settings.margin),
                r.push(e + t * n);
            this._coordinates = r;
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function () {
            var e = this.settings.stagePadding,
              t = this._coordinates,
              t = {
                width: Math.ceil(Math.abs(t[t.length - 1])) + 2 * e,
                'padding-left': e || '',
                'padding-right': e || '',
              };
            this.$stage.css(t);
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (e) {
            var t = this._coordinates.length,
              n = !this.settings.autoWidth,
              i = this.$stage.children();
            if (n && e.items.merge)
              for (; t--; )
                (e.css.width = this._widths[this.relative(t)]),
                  i.eq(t).css(e.css);
            else n && ((e.css.width = e.items.width), i.css(e.css));
          },
        },
        {
          filter: ['items'],
          run: function () {
            this._coordinates.length < 1 && this.$stage.removeAttr('style');
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (e) {
            (e.current = e.current
              ? this.$stage.children().index(e.current)
              : 0),
              (e.current = Math.max(
                this.minimum(),
                Math.min(this.maximum(), e.current)
              )),
              this.reset(e.current);
          },
        },
        {
          filter: ['position'],
          run: function () {
            this.animate(this.coordinates(this._current));
          },
        },
        {
          filter: ['width', 'position', 'items', 'settings'],
          run: function () {
            for (
              var e,
                t,
                n = this.settings.rtl ? 1 : -1,
                i = 2 * this.settings.stagePadding,
                o = this.coordinates(this.current()) + i,
                r = o + this.width() * n,
                s = [],
                a = 0,
                l = this._coordinates.length;
              a < l;
              a++
            )
              (e = this._coordinates[a - 1] || 0),
                (t = Math.abs(this._coordinates[a]) + i * n),
                ((this.op(e, '<=', o) && this.op(e, '>', r)) ||
                  (this.op(t, '<', o) && this.op(t, '>', r))) &&
                  s.push(a);
            this.$stage.children('.active').removeClass('active'),
              this.$stage
                .children(':eq(' + s.join('), :eq(') + ')')
                .addClass('active'),
              this.$stage.children('.center').removeClass('center'),
              this.settings.center &&
                this.$stage.children().eq(this.current()).addClass('center');
          },
        },
      ]),
      (u.prototype.initializeStage = function () {
        (this.$stage = this.$element.find('.' + this.settings.stageClass)),
          this.$stage.length ||
            (this.$element.addClass(this.options.loadingClass),
            (this.$stage = l('<' + this.settings.stageElement + '>', {
              class: this.settings.stageClass,
            }).wrap(
              l('<div/>', {
                class: this.settings.stageOuterClass,
              })
            )),
            this.$element.append(this.$stage.parent()));
      }),
      (u.prototype.initializeItems = function () {
        var e = this.$element.find('.owl-item');
        e.length
          ? ((this._items = e.get().map(function (e) {
              return l(e);
            })),
            (this._mergers = this._items.map(function () {
              return 1;
            })),
            this.refresh())
          : (this.replace(this.$element.children().not(this.$stage.parent())),
            this.isVisible() ? this.refresh() : this.invalidate('width'),
            this.$element
              .removeClass(this.options.loadingClass)
              .addClass(this.options.loadedClass));
      }),
      (u.prototype.initialize = function () {
        var e, t;
        this.enter('initializing'),
          this.trigger('initialize'),
          this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
          this.settings.autoWidth &&
            !this.is('pre-loading') &&
            ((e = this.$element.find('img')),
            (t = this.settings.nestedItemSelector
              ? '.' + this.settings.nestedItemSelector
              : a),
            (t = this.$element.children(t).width()),
            e.length) &&
            t <= 0 &&
            this.preloadAutoWidthImages(e),
          this.initializeStage(),
          this.initializeItems(),
          this.registerEventHandlers(),
          this.leave('initializing'),
          this.trigger('initialized');
      }),
      (u.prototype.isVisible = function () {
        return !this.settings.checkVisibility || this.$element.is(':visible');
      }),
      (u.prototype.setup = function () {
        var t = this.viewport(),
          e = this.options.responsive,
          n = -1,
          i = null;
        e
          ? (l.each(e, function (e) {
              e <= t && n < e && (n = Number(e));
            }),
            'function' ==
              typeof (i = l.extend({}, this.options, e[n])).stagePadding &&
              (i.stagePadding = i.stagePadding()),
            delete i.responsive,
            i.responsiveClass &&
              this.$element.attr(
                'class',
                this.$element
                  .attr('class')
                  .replace(
                    new RegExp(
                      '(' + this.options.responsiveClass + '-)\\S+\\s',
                      'g'
                    ),
                    '$1' + n
                  )
              ))
          : (i = l.extend({}, this.options)),
          this.trigger('change', {
            property: {
              name: 'settings',
              value: i,
            },
          }),
          (this._breakpoint = n),
          (this.settings = i),
          this.invalidate('settings'),
          this.trigger('changed', {
            property: {
              name: 'settings',
              value: this.settings,
            },
          });
      }),
      (u.prototype.optionsLogic = function () {
        this.settings.autoWidth &&
          ((this.settings.stagePadding = !1), (this.settings.merge = !1));
      }),
      (u.prototype.prepare = function (e) {
        var t = this.trigger('prepare', {
          content: e,
        });
        return (
          t.data ||
            (t.data = l('<' + this.settings.itemElement + '/>')
              .addClass(this.options.itemClass)
              .append(e)),
          this.trigger('prepared', {
            content: t.data,
          }),
          t.data
        );
      }),
      (u.prototype.update = function () {
        for (
          var e = 0,
            t = this._pipe.length,
            n = l.proxy(function (e) {
              return this[e];
            }, this._invalidated),
            i = {};
          e < t;

        )
          (this._invalidated.all ||
            0 < l.grep(this._pipe[e].filter, n).length) &&
            this._pipe[e].run(i),
            e++;
        (this._invalidated = {}), this.is('valid') || this.enter('valid');
      }),
      (u.prototype.width = function (e) {
        switch ((e = e || u.Width.Default)) {
          case u.Width.Inner:
          case u.Width.Outer:
            return this._width;
          default:
            return (
              this._width -
              2 * this.settings.stagePadding +
              this.settings.margin
            );
        }
      }),
      (u.prototype.refresh = function () {
        this.enter('refreshing'),
          this.trigger('refresh'),
          this.setup(),
          this.optionsLogic(),
          this.$element.addClass(this.options.refreshClass),
          this.update(),
          this.$element.removeClass(this.options.refreshClass),
          this.leave('refreshing'),
          this.trigger('refreshed');
      }),
      (u.prototype.onThrottledResize = function () {
        n.clearTimeout(this.resizeTimer),
          (this.resizeTimer = n.setTimeout(
            this._handlers.onResize,
            this.settings.responsiveRefreshRate
          ));
      }),
      (u.prototype.onResize = function () {
        return (
          !!this._items.length &&
          this._width !== this.$element.width() &&
          !!this.isVisible() &&
          (this.enter('resizing'),
          this.trigger('resize').isDefaultPrevented()
            ? (this.leave('resizing'), !1)
            : (this.invalidate('width'),
              this.refresh(),
              this.leave('resizing'),
              void this.trigger('resized')))
        );
      }),
      (u.prototype.registerEventHandlers = function () {
        l.support.transition &&
          this.$stage.on(
            l.support.transition.end + '.owl.core',
            l.proxy(this.onTransitionEnd, this)
          ),
          !1 !== this.settings.responsive &&
            this.on(n, 'resize', this._handlers.onThrottledResize),
          this.settings.mouseDrag &&
            (this.$element.addClass(this.options.dragClass),
            this.$stage.on(
              'mousedown.owl.core',
              l.proxy(this.onDragStart, this)
            ),
            this.$stage.on(
              'dragstart.owl.core selectstart.owl.core',
              function () {
                return !1;
              }
            )),
          this.settings.touchDrag &&
            (this.$stage.on(
              'touchstart.owl.core',
              l.proxy(this.onDragStart, this)
            ),
            this.$stage.on(
              'touchcancel.owl.core',
              l.proxy(this.onDragEnd, this)
            ));
      }),
      (u.prototype.onDragStart = function (e) {
        var t = null;
        3 !== e.which &&
          ((t = l.support.transform
            ? {
                x: (t = this.$stage
                  .css('transform')
                  .replace(/.*\(|\)| /g, '')
                  .split(','))[16 === t.length ? 12 : 4],
                y: t[16 === t.length ? 13 : 5],
              }
            : ((t = this.$stage.position()),
              {
                x: this.settings.rtl
                  ? t.left +
                    this.$stage.width() -
                    this.width() +
                    this.settings.margin
                  : t.left,
                y: t.top,
              })),
          this.is('animating') &&
            (l.support.transform ? this.animate(t.x) : this.$stage.stop(),
            this.invalidate('position')),
          this.$element.toggleClass(
            this.options.grabClass,
            'mousedown' === e.type
          ),
          this.speed(0),
          (this._drag.time = new Date().getTime()),
          (this._drag.target = l(e.target)),
          (this._drag.stage.start = t),
          (this._drag.stage.current = t),
          (this._drag.pointer = this.pointer(e)),
          l(i).on(
            'mouseup.owl.core touchend.owl.core',
            l.proxy(this.onDragEnd, this)
          ),
          l(i).one(
            'mousemove.owl.core touchmove.owl.core',
            l.proxy(function (e) {
              var t = this.difference(this._drag.pointer, this.pointer(e));
              l(i).on(
                'mousemove.owl.core touchmove.owl.core',
                l.proxy(this.onDragMove, this)
              ),
                (Math.abs(t.x) < Math.abs(t.y) && this.is('valid')) ||
                  (e.preventDefault(),
                  this.enter('dragging'),
                  this.trigger('drag'));
            }, this)
          ));
      }),
      (u.prototype.onDragMove = function (e) {
        var t = null,
          n = null,
          i = this.difference(this._drag.pointer, this.pointer(e)),
          o = this.difference(this._drag.stage.start, i);
        this.is('dragging') &&
          (e.preventDefault(),
          this.settings.loop
            ? ((t = this.coordinates(this.minimum())),
              (n = this.coordinates(this.maximum() + 1) - t),
              (o.x = ((((o.x - t) % n) + n) % n) + t))
            : ((t = this.settings.rtl
                ? this.coordinates(this.maximum())
                : this.coordinates(this.minimum())),
              (n = this.settings.rtl
                ? this.coordinates(this.minimum())
                : this.coordinates(this.maximum())),
              (e = this.settings.pullDrag ? (-1 * i.x) / 5 : 0),
              (o.x = Math.max(Math.min(o.x, t + e), n + e))),
          (this._drag.stage.current = o),
          this.animate(o.x));
      }),
      (u.prototype.onDragEnd = function (e) {
        var e = this.difference(this._drag.pointer, this.pointer(e)),
          t = this._drag.stage.current,
          n = (0 < e.x) ^ this.settings.rtl ? 'left' : 'right';
        l(i).off('.owl.core'),
          this.$element.removeClass(this.options.grabClass),
          ((0 !== e.x && this.is('dragging')) || !this.is('valid')) &&
            (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
            this.current(
              this.closest(t.x, 0 !== e.x ? n : this._drag.direction)
            ),
            this.invalidate('position'),
            this.update(),
            (this._drag.direction = n),
            3 < Math.abs(e.x) ||
              300 < new Date().getTime() - this._drag.time) &&
            this._drag.target.one('click.owl.core', function () {
              return !1;
            }),
          this.is('dragging') &&
            (this.leave('dragging'), this.trigger('dragged'));
      }),
      (u.prototype.closest = function (n, i) {
        var o = -1,
          r = this.width(),
          s = this.coordinates();
        return (
          this.settings.freeDrag ||
            l.each(
              s,
              l.proxy(function (e, t) {
                return (
                  'left' === i && t - 30 < n && n < t + 30
                    ? (o = e)
                    : 'right' === i && t - r - 30 < n && n < t - r + 30
                    ? (o = e + 1)
                    : this.op(n, '<', t) &&
                      this.op(n, '>', s[e + 1] !== a ? s[e + 1] : t - r) &&
                      (o = 'left' === i ? e + 1 : e),
                  -1 === o
                );
              }, this)
            ),
          this.settings.loop ||
            (this.op(n, '>', s[this.minimum()])
              ? (o = n = this.minimum())
              : this.op(n, '<', s[this.maximum()]) && (o = n = this.maximum())),
          o
        );
      }),
      (u.prototype.animate = function (e) {
        var t = 0 < this.speed();
        this.is('animating') && this.onTransitionEnd(),
          t && (this.enter('animating'), this.trigger('translate')),
          l.support.transform3d && l.support.transition
            ? this.$stage.css({
                transform: 'translate3d(' + e + 'px,0px,0px)',
                transition:
                  this.speed() / 1e3 +
                  's' +
                  (this.settings.slideTransition
                    ? ' ' + this.settings.slideTransition
                    : ''),
              })
            : t
            ? this.$stage.animate(
                {
                  left: e + 'px',
                },
                this.speed(),
                this.settings.fallbackEasing,
                l.proxy(this.onTransitionEnd, this)
              )
            : this.$stage.css({
                left: e + 'px',
              });
      }),
      (u.prototype.is = function (e) {
        return this._states.current[e] && 0 < this._states.current[e];
      }),
      (u.prototype.current = function (e) {
        if (e !== a) {
          if (0 === this._items.length) return a;
          var t;
          (e = this.normalize(e)),
            this._current !== e &&
              ((t = this.trigger('change', {
                property: {
                  name: 'position',
                  value: e,
                },
              })).data !== a && (e = this.normalize(t.data)),
              (this._current = e),
              this.invalidate('position'),
              this.trigger('changed', {
                property: {
                  name: 'position',
                  value: this._current,
                },
              }));
        }
        return this._current;
      }),
      (u.prototype.invalidate = function (e) {
        return (
          'string' === l.type(e) &&
            ((this._invalidated[e] = !0), this.is('valid')) &&
            this.leave('valid'),
          l.map(this._invalidated, function (e, t) {
            return t;
          })
        );
      }),
      (u.prototype.reset = function (e) {
        (e = this.normalize(e)) !== a &&
          ((this._speed = 0),
          (this._current = e),
          this.suppress(['translate', 'translated']),
          this.animate(this.coordinates(e)),
          this.release(['translate', 'translated']));
      }),
      (u.prototype.normalize = function (e, t) {
        var n = this._items.length,
          t = t ? 0 : this._clones.length;
        return (
          !this.isNumeric(e) || n < 1
            ? (e = a)
            : (e < 0 || n + t <= e) &&
              (e = ((((e - t / 2) % n) + n) % n) + t / 2),
          e
        );
      }),
      (u.prototype.relative = function (e) {
        return (e -= this._clones.length / 2), this.normalize(e, !0);
      }),
      (u.prototype.maximum = function (e) {
        var t,
          n,
          i,
          o = this.settings,
          r = this._coordinates.length;
        if (o.loop) r = this._clones.length / 2 + this._items.length - 1;
        else if (o.autoWidth || o.merge) {
          if ((t = this._items.length))
            for (
              n = this._items[--t].width(), i = this.$element.width();
              t-- &&
              !((n += this._items[t].width() + this.settings.margin) > i);

            );
          r = t + 1;
        } else
          r = o.center ? this._items.length - 1 : this._items.length - o.items;
        return e && (r -= this._clones.length / 2), Math.max(r, 0);
      }),
      (u.prototype.minimum = function (e) {
        return e ? 0 : this._clones.length / 2;
      }),
      (u.prototype.items = function (e) {
        return e === a
          ? this._items.slice()
          : ((e = this.normalize(e, !0)), this._items[e]);
      }),
      (u.prototype.mergers = function (e) {
        return e === a
          ? this._mergers.slice()
          : ((e = this.normalize(e, !0)), this._mergers[e]);
      }),
      (u.prototype.clones = function (n) {
        function i(e) {
          return e % 2 == 0 ? o + e / 2 : t - (e + 1) / 2;
        }
        var t = this._clones.length / 2,
          o = t + this._items.length;
        return n === a
          ? l.map(this._clones, function (e, t) {
              return i(t);
            })
          : l.map(this._clones, function (e, t) {
              return e === n ? i(t) : null;
            });
      }),
      (u.prototype.speed = function (e) {
        return e !== a && (this._speed = e), this._speed;
      }),
      (u.prototype.coordinates = function (e) {
        var t,
          n = 1,
          i = e - 1;
        return e === a
          ? l.map(
              this._coordinates,
              l.proxy(function (e, t) {
                return this.coordinates(t);
              }, this)
            )
          : (this.settings.center
              ? (this.settings.rtl && ((n = -1), (i = e + 1)),
                (t = this._coordinates[e]),
                (t +=
                  ((this.width() - t + (this._coordinates[i] || 0)) / 2) * n))
              : (t = this._coordinates[i] || 0),
            Math.ceil(t));
      }),
      (u.prototype.duration = function (e, t, n) {
        return 0 === n
          ? 0
          : Math.min(Math.max(Math.abs(t - e), 1), 6) *
              Math.abs(n || this.settings.smartSpeed);
      }),
      (u.prototype.to = function (e, t) {
        var n = this.current(),
          i = e - this.relative(n),
          o = (0 < i) - (i < 0),
          r = this._items.length,
          s = this.minimum(),
          a = this.maximum();
        this.settings.loop
          ? (!this.settings.rewind && Math.abs(i) > r / 2 && (i += -1 * o * r),
            (o = (((((e = n + i) - s) % r) + r) % r) + s) !== e &&
              o - i <= a &&
              0 < o - i &&
              this.reset((n = (e = o) - i)))
          : (e = this.settings.rewind
              ? ((e % (a += 1)) + a) % a
              : Math.max(s, Math.min(a, e))),
          this.speed(this.duration(n, e, t)),
          this.current(e),
          this.isVisible() && this.update();
      }),
      (u.prototype.next = function (e) {
        (e = e || !1), this.to(this.relative(this.current()) + 1, e);
      }),
      (u.prototype.prev = function (e) {
        (e = e || !1), this.to(this.relative(this.current()) - 1, e);
      }),
      (u.prototype.onTransitionEnd = function (e) {
        if (
          e !== a &&
          (e.stopPropagation(),
          (e.target || e.srcElement || e.originalTarget) !== this.$stage.get(0))
        )
          return !1;
        this.leave('animating'), this.trigger('translated');
      }),
      (u.prototype.viewport = function () {
        var e;
        return (
          this.options.responsiveBaseElement !== n
            ? (e = l(this.options.responsiveBaseElement).width())
            : n.innerWidth
            ? (e = n.innerWidth)
            : i.documentElement && i.documentElement.clientWidth
            ? (e = i.documentElement.clientWidth)
            : console.warn('Can not detect viewport width.'),
          e
        );
      }),
      (u.prototype.replace = function (e) {
        this.$stage.empty(),
          (this._items = []),
          (e = e && (e instanceof jQuery ? e : l(e))),
          (e = this.settings.nestedItemSelector
            ? e.find('.' + this.settings.nestedItemSelector)
            : e)
            .filter(function () {
              return 1 === this.nodeType;
            })
            .each(
              l.proxy(function (e, t) {
                (t = this.prepare(t)),
                  this.$stage.append(t),
                  this._items.push(t),
                  this._mergers.push(
                    +t
                      .find('[data-merge]')
                      .addBack('[data-merge]')
                      .attr('data-merge') || 1
                  );
              }, this)
            ),
          this.reset(
            this.isNumeric(this.settings.startPosition)
              ? this.settings.startPosition
              : 0
          ),
          this.invalidate('items');
      }),
      (u.prototype.add = function (e, t) {
        var n = this.relative(this._current);
        (t = t === a ? this._items.length : this.normalize(t, !0)),
          (e = e instanceof jQuery ? e : l(e)),
          this.trigger('add', {
            content: e,
            position: t,
          }),
          (e = this.prepare(e)),
          0 === this._items.length || t === this._items.length
            ? (0 === this._items.length && this.$stage.append(e),
              0 !== this._items.length && this._items[t - 1].after(e),
              this._items.push(e),
              this._mergers.push(
                +e
                  .find('[data-merge]')
                  .addBack('[data-merge]')
                  .attr('data-merge') || 1
              ))
            : (this._items[t].before(e),
              this._items.splice(t, 0, e),
              this._mergers.splice(
                t,
                0,
                +e
                  .find('[data-merge]')
                  .addBack('[data-merge]')
                  .attr('data-merge') || 1
              )),
          this._items[n] && this.reset(this._items[n].index()),
          this.invalidate('items'),
          this.trigger('added', {
            content: e,
            position: t,
          });
      }),
      (u.prototype.remove = function (e) {
        (e = this.normalize(e, !0)) !== a &&
          (this.trigger('remove', {
            content: this._items[e],
            position: e,
          }),
          this._items[e].remove(),
          this._items.splice(e, 1),
          this._mergers.splice(e, 1),
          this.invalidate('items'),
          this.trigger('removed', {
            content: null,
            position: e,
          }));
      }),
      (u.prototype.preloadAutoWidthImages = function (e) {
        e.each(
          l.proxy(function (e, t) {
            this.enter('pre-loading'),
              (t = l(t)),
              l(new Image())
                .one(
                  'load',
                  l.proxy(function (e) {
                    t.attr('src', e.target.src),
                      t.css('opacity', 1),
                      this.leave('pre-loading'),
                      this.is('pre-loading') ||
                        this.is('initializing') ||
                        this.refresh();
                  }, this)
                )
                .attr(
                  'src',
                  t.attr('src') ||
                    t.attr('data-src') ||
                    t.attr('data-src-retina')
                );
          }, this)
        );
      }),
      (u.prototype.destroy = function () {
        for (var e in (this.$element.off('.owl.core'),
        this.$stage.off('.owl.core'),
        l(i).off('.owl.core'),
        !1 !== this.settings.responsive &&
          (n.clearTimeout(this.resizeTimer),
          this.off(n, 'resize', this._handlers.onThrottledResize)),
        this._plugins))
          this._plugins[e].destroy();
        this.$stage.children('.cloned').remove(),
          this.$stage.unwrap(),
          this.$stage.children().contents().unwrap(),
          this.$stage.children().unwrap(),
          this.$stage.remove(),
          this.$element
            .removeClass(this.options.refreshClass)
            .removeClass(this.options.loadingClass)
            .removeClass(this.options.loadedClass)
            .removeClass(this.options.rtlClass)
            .removeClass(this.options.dragClass)
            .removeClass(this.options.grabClass)
            .attr(
              'class',
              this.$element
                .attr('class')
                .replace(
                  new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'),
                  ''
                )
            )
            .removeData('owl.carousel');
      }),
      (u.prototype.op = function (e, t, n) {
        var i = this.settings.rtl;
        switch (t) {
          case '<':
            return i ? n < e : e < n;
          case '>':
            return i ? e < n : n < e;
          case '>=':
            return i ? e <= n : n <= e;
          case '<=':
            return i ? n <= e : e <= n;
        }
      }),
      (u.prototype.on = function (e, t, n, i) {
        e.addEventListener
          ? e.addEventListener(t, n, i)
          : e.attachEvent && e.attachEvent('on' + t, n);
      }),
      (u.prototype.off = function (e, t, n, i) {
        e.removeEventListener
          ? e.removeEventListener(t, n, i)
          : e.detachEvent && e.detachEvent('on' + t, n);
      }),
      (u.prototype.trigger = function (e, t, n, i, o) {
        var r = {
            item: {
              count: this._items.length,
              index: this.current(),
            },
          },
          s = l.camelCase(
            l
              .grep(['on', e, n], function (e) {
                return e;
              })
              .join('-')
              .toLowerCase()
          ),
          a = l.Event(
            [e, 'owl', n || 'carousel'].join('.').toLowerCase(),
            l.extend(
              {
                relatedTarget: this,
              },
              r,
              t
            )
          );
        return (
          this._supress[e] ||
            (l.each(this._plugins, function (e, t) {
              t.onTrigger && t.onTrigger(a);
            }),
            this.register({
              type: u.Type.Event,
              name: e,
            }),
            this.$element.trigger(a),
            this.settings &&
              'function' == typeof this.settings[s] &&
              this.settings[s].call(this, a)),
          a
        );
      }),
      (u.prototype.enter = function (e) {
        l.each(
          [e].concat(this._states.tags[e] || []),
          l.proxy(function (e, t) {
            this._states.current[t] === a && (this._states.current[t] = 0),
              this._states.current[t]++;
          }, this)
        );
      }),
      (u.prototype.leave = function (e) {
        l.each(
          [e].concat(this._states.tags[e] || []),
          l.proxy(function (e, t) {
            this._states.current[t]--;
          }, this)
        );
      }),
      (u.prototype.register = function (n) {
        var t;
        n.type === u.Type.Event
          ? (l.event.special[n.name] || (l.event.special[n.name] = {}),
            l.event.special[n.name].owl ||
              ((t = l.event.special[n.name]._default),
              (l.event.special[n.name]._default = function (e) {
                return !t ||
                  !t.apply ||
                  (e.namespace && -1 !== e.namespace.indexOf('owl'))
                  ? e.namespace && -1 < e.namespace.indexOf('owl')
                  : t.apply(this, arguments);
              }),
              (l.event.special[n.name].owl = !0)))
          : n.type === u.Type.State &&
            (this._states.tags[n.name]
              ? (this._states.tags[n.name] = this._states.tags[n.name].concat(
                  n.tags
                ))
              : (this._states.tags[n.name] = n.tags),
            (this._states.tags[n.name] = l.grep(
              this._states.tags[n.name],
              l.proxy(function (e, t) {
                return l.inArray(e, this._states.tags[n.name]) === t;
              }, this)
            )));
      }),
      (u.prototype.suppress = function (e) {
        l.each(
          e,
          l.proxy(function (e, t) {
            this._supress[t] = !0;
          }, this)
        );
      }),
      (u.prototype.release = function (e) {
        l.each(
          e,
          l.proxy(function (e, t) {
            delete this._supress[t];
          }, this)
        );
      }),
      (u.prototype.pointer = function (e) {
        var t = {
          x: null,
          y: null,
        };
        return (
          (e =
            (e = e.originalEvent || e || n.event).touches && e.touches.length
              ? e.touches[0]
              : e.changedTouches && e.changedTouches.length
              ? e.changedTouches[0]
              : e).pageX
            ? ((t.x = e.pageX), (t.y = e.pageY))
            : ((t.x = e.clientX), (t.y = e.clientY)),
          t
        );
      }),
      (u.prototype.isNumeric = function (e) {
        return !isNaN(parseFloat(e));
      }),
      (u.prototype.difference = function (e, t) {
        return {
          x: e.x - t.x,
          y: e.y - t.y,
        };
      }),
      (l.fn.owlCarousel = function (t) {
        var i = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
          var e = l(this),
            n = e.data('owl.carousel');
          n ||
            ((n = new u(this, 'object' == typeof t && t)),
            e.data('owl.carousel', n),
            l.each(
              [
                'next',
                'prev',
                'to',
                'destroy',
                'refresh',
                'replace',
                'add',
                'remove',
              ],
              function (e, t) {
                n.register({
                  type: u.Type.Event,
                  name: t,
                }),
                  n.$element.on(
                    t + '.owl.carousel.core',
                    l.proxy(function (e) {
                      e.namespace &&
                        e.relatedTarget !== this &&
                        (this.suppress([t]),
                        n[t].apply(this, [].slice.call(arguments, 1)),
                        this.release([t]));
                    }, n)
                  );
              }
            )),
            'string' == typeof t && '_' !== t.charAt(0) && n[t].apply(n, i);
        });
      }),
      (l.fn.owlCarousel.Constructor = u);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, n) {
    function i(e) {
      (this._core = e),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          'initialized.owl.carousel': t.proxy(function (e) {
            e.namespace && this._core.settings.autoRefresh && this.watch();
          }, this),
        }),
        (this._core.options = t.extend({}, i.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    }
    (i.Defaults = {
      autoRefresh: !0,
      autoRefreshInterval: 500,
    }),
      (i.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.isVisible()),
          (this._interval = n.setInterval(
            t.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )));
      }),
      (i.prototype.refresh = function () {
        this._core.isVisible() !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass('owl-hidden', !this._visible),
          this._visible) &&
          this._core.invalidate('width') &&
          this._core.refresh();
      }),
      (i.prototype.destroy = function () {
        var e, t;
        for (e in (n.clearInterval(this._interval), this._handlers))
          this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.AutoRefresh = i);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, o) {
    function t(e) {
      (this._core = e),
        (this._loaded = []),
        (this._handlers = {
          'initialized.owl.carousel change.owl.carousel resized.owl.carousel':
            a.proxy(function (e) {
              if (
                e.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((e.property && 'position' == e.property.name) ||
                  'initialized' == e.type)
              ) {
                var t = this._core.settings,
                  n = (t.center && Math.ceil(t.items / 2)) || t.items,
                  i = (t.center && -1 * n) || 0,
                  o =
                    (e.property && void 0 !== e.property.value
                      ? e.property.value
                      : this._core.current()) + i,
                  r = this._core.clones().length,
                  s = a.proxy(function (e, t) {
                    this.load(t);
                  }, this);
                for (
                  0 < t.lazyLoadEager &&
                  ((n += t.lazyLoadEager), t.loop) &&
                  ((o -= t.lazyLoadEager), n++);
                  i++ < n;

                )
                  this.load(r / 2 + this._core.relative(o)),
                    r && a.each(this._core.clones(this._core.relative(o)), s),
                    o++;
              }
            }, this),
        }),
        (this._core.options = a.extend({}, t.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    }
    (t.Defaults = {
      lazyLoad: !1,
      lazyLoadEager: 0,
    }),
      (t.prototype.load = function (e) {
        var e = this._core.$stage.children().eq(e),
          t = e && e.find('.owl-lazy');
        !t ||
          -1 < a.inArray(e.get(0), this._loaded) ||
          (t.each(
            a.proxy(function (e, t) {
              var n = a(t),
                i =
                  (1 < o.devicePixelRatio && n.attr('data-src-retina')) ||
                  n.attr('data-src') ||
                  n.attr('data-srcset');
              this._core.trigger(
                'load',
                {
                  element: n,
                  url: i,
                },
                'lazy'
              ),
                n.is('img')
                  ? n
                      .one(
                        'load.owl.lazy',
                        a.proxy(function () {
                          n.css('opacity', 1),
                            this._core.trigger(
                              'loaded',
                              {
                                element: n,
                                url: i,
                              },
                              'lazy'
                            );
                        }, this)
                      )
                      .attr('src', i)
                  : n.is('source')
                  ? n
                      .one(
                        'load.owl.lazy',
                        a.proxy(function () {
                          this._core.trigger(
                            'loaded',
                            {
                              element: n,
                              url: i,
                            },
                            'lazy'
                          );
                        }, this)
                      )
                      .attr('srcset', i)
                  : (((t = new Image()).onload = a.proxy(function () {
                      n.css({
                        'background-image': 'url("' + i + '")',
                        opacity: '1',
                      }),
                        this._core.trigger(
                          'loaded',
                          {
                            element: n,
                            url: i,
                          },
                          'lazy'
                        );
                    }, this)),
                    (t.src = i));
            }, this)
          ),
          this._loaded.push(e.get(0)));
      }),
      (t.prototype.destroy = function () {
        var e, t;
        for (e in this.handlers) this._core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Lazy = t);
  })(window.Zepto || window.jQuery, window, document),
  (function (o, n) {
    function i(e) {
      (this._core = e),
        (this._previousHeight = null),
        (this._handlers = {
          'initialized.owl.carousel refreshed.owl.carousel': o.proxy(function (
            e
          ) {
            e.namespace && this._core.settings.autoHeight && this.update();
          },
          this),
          'changed.owl.carousel': o.proxy(function (e) {
            e.namespace &&
              this._core.settings.autoHeight &&
              'position' === e.property.name &&
              this.update();
          }, this),
          'loaded.owl.lazy': o.proxy(function (e) {
            e.namespace &&
              this._core.settings.autoHeight &&
              e.element.closest('.' + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update();
          }, this),
        }),
        (this._core.options = o.extend({}, i.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        (this._intervalId = null);
      var t = this;
      o(n).on('load', function () {
        t._core.settings.autoHeight && t.update();
      }),
        o(n).resize(function () {
          t._core.settings.autoHeight &&
            (null != t._intervalId && clearTimeout(t._intervalId),
            (t._intervalId = setTimeout(function () {
              t.update();
            }, 250)));
        });
    }
    (i.Defaults = {
      autoHeight: !1,
      autoHeightClass: 'owl-height',
    }),
      (i.prototype.update = function () {
        var e = this._core._current,
          t = e + this._core.settings.items,
          n = this._core.settings.lazyLoad,
          e = this._core.$stage.children().toArray().slice(e, t),
          i = [],
          t = 0;
        o.each(e, function (e, t) {
          i.push(o(t).height());
        }),
          (t = Math.max.apply(null, i)) <= 1 &&
            n &&
            this._previousHeight &&
            (t = this._previousHeight),
          (this._previousHeight = t),
          this._core.$stage
            .parent()
            .height(t)
            .addClass(this._core.settings.autoHeightClass);
      }),
      (i.prototype.destroy = function () {
        var e, t;
        for (e in this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (o.fn.owlCarousel.Constructor.Plugins.AutoHeight = i);
  })(window.Zepto || window.jQuery, window, document),
  (function (c, t) {
    function n(e) {
      (this._core = e),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          'initialized.owl.carousel': c.proxy(function (e) {
            e.namespace &&
              this._core.register({
                type: 'state',
                name: 'playing',
                tags: ['interacting'],
              });
          }, this),
          'resize.owl.carousel': c.proxy(function (e) {
            e.namespace &&
              this._core.settings.video &&
              this.isInFullScreen() &&
              e.preventDefault();
          }, this),
          'refreshed.owl.carousel': c.proxy(function (e) {
            e.namespace &&
              this._core.is('resizing') &&
              this._core.$stage.find('.cloned .owl-video-frame').remove();
          }, this),
          'changed.owl.carousel': c.proxy(function (e) {
            e.namespace &&
              'position' === e.property.name &&
              this._playing &&
              this.stop();
          }, this),
          'prepared.owl.carousel': c.proxy(function (e) {
            var t;
            e.namespace &&
              (t = c(e.content).find('.owl-video')).length &&
              (t.css('display', 'none'), this.fetch(t, c(e.content)));
          }, this),
        }),
        (this._core.options = c.extend({}, n.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          'click.owl.video',
          '.owl-video-play-icon',
          c.proxy(function (e) {
            this.play(e);
          }, this)
        );
    }
    (n.Defaults = {
      video: !1,
      videoHeight: !1,
      videoWidth: !1,
    }),
      (n.prototype.fetch = function (e, t) {
        var n = e.attr('data-vimeo-id')
            ? 'vimeo'
            : e.attr('data-vzaar-id')
            ? 'vzaar'
            : 'youtube',
          i =
            e.attr('data-vimeo-id') ||
            e.attr('data-youtube-id') ||
            e.attr('data-vzaar-id'),
          o = e.attr('data-width') || this._core.settings.videoWidth,
          r = e.attr('data-height') || this._core.settings.videoHeight,
          s = e.attr('href');
        if (!s) throw new Error('Missing video URL.');
        if (
          -1 <
          (i = s.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          ))[3].indexOf('youtu')
        )
          n = 'youtube';
        else if (-1 < i[3].indexOf('vimeo')) n = 'vimeo';
        else {
          if (!(-1 < i[3].indexOf('vzaar')))
            throw new Error('Video URL not supported.');
          n = 'vzaar';
        }
        (i = i[6]),
          (this._videos[s] = {
            type: n,
            id: i,
            width: o,
            height: r,
          }),
          t.attr('data-video', s),
          this.thumbnail(e, this._videos[s]);
      }),
      (n.prototype.thumbnail = function (t, e) {
        function n(e) {
          (i = u.lazyLoad
            ? c('<div/>', {
                class: 'owl-video-tn ' + l,
                srcType: e,
              })
            : c('<div/>', {
                class: 'owl-video-tn',
                style: 'opacity:1;background-image:url(' + e + ')',
              })),
            t.after(i),
            t.after('<div class="owl-video-play-icon"></div>');
        }
        var i,
          o,
          r =
            e.width && e.height
              ? 'width:' + e.width + 'px;height:' + e.height + 'px;'
              : '',
          s = t.find('img'),
          a = 'src',
          l = '',
          u = this._core.settings;
        if (
          (t.wrap(
            c('<div/>', {
              class: 'owl-video-wrapper',
              style: r,
            })
          ),
          this._core.settings.lazyLoad && ((a = 'data-src'), (l = 'owl-lazy')),
          s.length)
        )
          return n(s.attr(a)), s.remove(), !1;
        'youtube' === e.type
          ? ((o = '//img.youtube.com/vi/' + e.id + '/hqdefault.jpg'), n(o))
          : 'vimeo' === e.type
          ? c.ajax({
              type: 'GET',
              url: '//vimeo.com/api/v2/video/' + e.id + '.json',
              jsonp: 'callback',
              dataType: 'jsonp',
              success: function (e) {
                (o = e[0].thumbnail_large), n(o);
              },
            })
          : 'vzaar' === e.type &&
            c.ajax({
              type: 'GET',
              url: '//vzaar.com/api/videos/' + e.id + '.json',
              jsonp: 'callback',
              dataType: 'jsonp',
              success: function (e) {
                (o = e.framegrab_url), n(o);
              },
            });
      }),
      (n.prototype.stop = function () {
        this._core.trigger('stop', null, 'video'),
          this._playing.find('.owl-video-frame').remove(),
          this._playing.removeClass('owl-video-playing'),
          (this._playing = null),
          this._core.leave('playing'),
          this._core.trigger('stopped', null, 'video');
      }),
      (n.prototype.play = function (e) {
        var t,
          e = c(e.target).closest('.' + this._core.settings.itemClass),
          n = this._videos[e.attr('data-video')],
          i = n.width || '100%',
          o = n.height || this._core.$stage.height();
        this._playing ||
          (this._core.enter('playing'),
          this._core.trigger('play', null, 'video'),
          (e = this._core.items(this._core.relative(e.index()))),
          this._core.reset(e.index()),
          (t = c(
            '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
          )).attr('height', o),
          t.attr('width', i),
          'youtube' === n.type
            ? t.attr(
                'src',
                '//www.youtube.com/embed/' +
                  n.id +
                  '?autoplay=1&rel=0&v=' +
                  n.id
              )
            : 'vimeo' === n.type
            ? t.attr('src', '//player.vimeo.com/video/' + n.id + '?autoplay=1')
            : 'vzaar' === n.type &&
              t.attr(
                'src',
                '//view.vzaar.com/' + n.id + '/player?autoplay=true'
              ),
          c(t)
            .wrap('<div class="owl-video-frame" />')
            .insertAfter(e.find('.owl-video')),
          (this._playing = e.addClass('owl-video-playing')));
      }),
      (n.prototype.isInFullScreen = function () {
        var e =
          t.fullscreenElement ||
          t.mozFullScreenElement ||
          t.webkitFullscreenElement;
        return e && c(e).parent().hasClass('owl-video-frame');
      }),
      (n.prototype.destroy = function () {
        var e, t;
        for (e in (this._core.$element.off('click.owl.video'), this._handlers))
          this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (c.fn.owlCarousel.Constructor.Plugins.Video = n);
  })(window.Zepto || window.jQuery, (window, document)),
  (function (s) {
    function t(e) {
      (this.core = e),
        (this.core.options = s.extend({}, t.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = void 0),
        (this.next = void 0),
        (this.handlers = {
          'change.owl.carousel': s.proxy(function (e) {
            e.namespace &&
              'position' == e.property.name &&
              ((this.previous = this.core.current()),
              (this.next = e.property.value));
          }, this),
          'drag.owl.carousel dragged.owl.carousel translated.owl.carousel':
            s.proxy(function (e) {
              e.namespace && (this.swapping = 'translated' == e.type);
            }, this),
          'translate.owl.carousel': s.proxy(function (e) {
            e.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap();
          }, this),
        }),
        this.core.$element.on(this.handlers);
    }
    (t.Defaults = {
      animateOut: !1,
      animateIn: !1,
    }),
      (t.prototype.swap = function () {
        var e, t, n, i, o, r;
        1 === this.core.settings.items &&
          s.support.animation &&
          s.support.transition &&
          (this.core.speed(0),
          (t = s.proxy(this.clear, this)),
          (n = this.core.$stage.children().eq(this.previous)),
          (i = this.core.$stage.children().eq(this.next)),
          (o = this.core.settings.animateIn),
          (r = this.core.settings.animateOut),
          this.core.current() !== this.previous) &&
          (r &&
            ((e =
              this.core.coordinates(this.previous) -
              this.core.coordinates(this.next)),
            n
              .one(s.support.animation.end, t)
              .css({
                left: e + 'px',
              })
              .addClass('animated owl-animated-out')
              .addClass(r)),
          o) &&
          i
            .one(s.support.animation.end, t)
            .addClass('animated owl-animated-in')
            .addClass(o);
      }),
      (t.prototype.clear = function (e) {
        s(e.target)
          .css({
            left: '',
          })
          .removeClass('animated owl-animated-out owl-animated-in')
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd();
      }),
      (t.prototype.destroy = function () {
        var e, t;
        for (e in this.handlers) this.core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (s.fn.owlCarousel.Constructor.Plugins.Animate = t);
  })(window.Zepto || window.jQuery, (window, document)),
  (function (i, o, t) {
    function n(e) {
      (this._core = e),
        (this._call = null),
        (this._time = 0),
        (this._timeout = 0),
        (this._paused = !0),
        (this._handlers = {
          'changed.owl.carousel': i.proxy(function (e) {
            e.namespace && 'settings' === e.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : e.namespace &&
                'position' === e.property.name &&
                this._paused &&
                (this._time = 0);
          }, this),
          'initialized.owl.carousel': i.proxy(function (e) {
            e.namespace && this._core.settings.autoplay && this.play();
          }, this),
          'play.owl.autoplay': i.proxy(function (e, t, n) {
            e.namespace && this.play(t, n);
          }, this),
          'stop.owl.autoplay': i.proxy(function (e) {
            e.namespace && this.stop();
          }, this),
          'mouseover.owl.autoplay': i.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is('rotating') &&
              this.pause();
          }, this),
          'mouseleave.owl.autoplay': i.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is('rotating') &&
              this.play();
          }, this),
          'touchstart.owl.core': i.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is('rotating') &&
              this.pause();
          }, this),
          'touchend.owl.core': i.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play();
          }, this),
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = i.extend({}, n.Defaults, this._core.options));
    }
    (n.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1,
    }),
      (n.prototype._next = function (e) {
        (this._call = o.setTimeout(
          i.proxy(this._next, this, e),
          this._timeout * (Math.round(this.read() / this._timeout) + 1) -
            this.read()
        )),
          this._core.is('interacting') ||
            t.hidden ||
            this._core.next(e || this._core.settings.autoplaySpeed);
      }),
      (n.prototype.read = function () {
        return new Date().getTime() - this._time;
      }),
      (n.prototype.play = function (e, t) {
        var n;
        this._core.is('rotating') || this._core.enter('rotating'),
          (e = e || this._core.settings.autoplayTimeout),
          (n = Math.min(this._time % (this._timeout || e), e)),
          this._paused
            ? ((this._time = this.read()), (this._paused = !1))
            : o.clearTimeout(this._call),
          (this._time += (this.read() % e) - n),
          (this._timeout = e),
          (this._call = o.setTimeout(i.proxy(this._next, this, t), e - n));
      }),
      (n.prototype.stop = function () {
        this._core.is('rotating') &&
          ((this._time = 0),
          (this._paused = !0),
          o.clearTimeout(this._call),
          this._core.leave('rotating'));
      }),
      (n.prototype.pause = function () {
        this._core.is('rotating') &&
          !this._paused &&
          ((this._time = this.read()),
          (this._paused = !0),
          o.clearTimeout(this._call));
      }),
      (n.prototype.destroy = function () {
        var e, t;
        for (e in (this.stop(), this._handlers))
          this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (i.fn.owlCarousel.Constructor.Plugins.autoplay = n);
  })(window.Zepto || window.jQuery, window, document),
  (function (o) {
    'use strict';

    function t(e) {
      (this._core = e),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = {
          next: this._core.next,
          prev: this._core.prev,
          to: this._core.to,
        }),
        (this._handlers = {
          'prepared.owl.carousel': o.proxy(function (e) {
            e.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  o(e.content)
                    .find('[data-dot]')
                    .addBack('[data-dot]')
                    .attr('data-dot') +
                  '</div>'
              );
          }, this),
          'added.owl.carousel': o.proxy(function (e) {
            e.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(e.position, 0, this._templates.pop());
          }, this),
          'remove.owl.carousel': o.proxy(function (e) {
            e.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(e.position, 1);
          }, this),
          'changed.owl.carousel': o.proxy(function (e) {
            e.namespace && 'position' == e.property.name && this.draw();
          }, this),
          'initialized.owl.carousel': o.proxy(function (e) {
            e.namespace &&
              !this._initialized &&
              (this._core.trigger('initialize', null, 'navigation'),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger('initialized', null, 'navigation'));
          }, this),
          'refreshed.owl.carousel': o.proxy(function (e) {
            e.namespace &&
              this._initialized &&
              (this._core.trigger('refresh', null, 'navigation'),
              this.update(),
              this.draw(),
              this._core.trigger('refreshed', null, 'navigation'));
          }, this),
        }),
        (this._core.options = o.extend({}, t.Defaults, this._core.options)),
        this.$element.on(this._handlers);
    }
    (t.Defaults = {
      nav: !1,
      navText: [
        '<span aria-label="Previous">&#x2039;</span>',
        '<span aria-label="Next">&#x203a;</span>',
      ],
      navSpeed: !1,
      navElement: 'button type="button" role="presentation"',
      navContainer: !1,
      navContainerClass: 'owl-nav',
      navClass: ['owl-prev', 'owl-next'],
      slideBy: 1,
      dotClass: 'owl-dot',
      dotsClass: 'owl-dots',
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1,
    }),
      (t.prototype.initialize = function () {
        var e,
          n = this._core.settings;
        for (e in ((this._controls.$relative = (
          n.navContainer
            ? o(n.navContainer)
            : o('<div>').addClass(n.navContainerClass).appendTo(this.$element)
        ).addClass('disabled')),
        (this._controls.$previous = o('<' + n.navElement + '>')
          .addClass(n.navClass[0])
          .html(n.navText[0])
          .prependTo(this._controls.$relative)
          .on(
            'click',
            o.proxy(function (e) {
              this.prev(n.navSpeed);
            }, this)
          )),
        (this._controls.$next = o('<' + n.navElement + '>')
          .addClass(n.navClass[1])
          .html(n.navText[1])
          .appendTo(this._controls.$relative)
          .on(
            'click',
            o.proxy(function (e) {
              this.next(n.navSpeed);
            }, this)
          )),
        n.dotsData ||
          (this._templates = [
            o('<button role="button">')
              .addClass(n.dotClass)
              .append(o('<span>'))
              .prop('outerHTML'),
          ]),
        (this._controls.$absolute = (
          n.dotsContainer
            ? o(n.dotsContainer)
            : o('<div>').addClass(n.dotsClass).appendTo(this.$element)
        ).addClass('disabled')),
        this._controls.$absolute.on(
          'click',
          'button',
          o.proxy(function (e) {
            var t = (
              o(e.target).parent().is(this._controls.$absolute)
                ? o(e.target)
                : o(e.target).parent()
            ).index();
            e.preventDefault(), this.to(t, n.dotsSpeed);
          }, this)
        ),
        this._overrides))
          this._core[e] = o.proxy(this[e], this);
      }),
      (t.prototype.destroy = function () {
        var e,
          t,
          n,
          i,
          o = this._core.settings;
        for (e in this._handlers) this.$element.off(e, this._handlers[e]);
        for (t in this._controls)
          '$relative' === t && o.navContainer
            ? this._controls[t].html('')
            : this._controls[t].remove();
        for (i in this.overides) this._core[i] = this._overrides[i];
        for (n in Object.getOwnPropertyNames(this))
          'function' != typeof this[n] && (this[n] = null);
      }),
      (t.prototype.update = function () {
        var e,
          t,
          n = this._core.clones().length / 2,
          i = n + this._core.items().length,
          o = this._core.maximum(!0),
          r = this._core.settings,
          s = r.center || r.autoWidth || r.dotsData ? 1 : r.dotsEach || r.items;
        if (
          ('page' !== r.slideBy && (r.slideBy = Math.min(r.slideBy, r.items)),
          r.dots || 'page' == r.slideBy)
        )
          for (this._pages = [], e = n, t = 0; e < i; e++) {
            if (s <= t || 0 === t) {
              if (
                (this._pages.push({
                  start: Math.min(o, e - n),
                  end: e - n + s - 1,
                }),
                Math.min(o, e - n) === o)
              )
                break;
              (t = 0), 0;
            }
            t += this._core.mergers(this._core.relative(e));
          }
      }),
      (t.prototype.draw = function () {
        var e = this._core.settings,
          t = this._core.items().length <= e.items,
          n = this._core.relative(this._core.current()),
          i = e.loop || e.rewind;
        this._controls.$relative.toggleClass('disabled', !e.nav || t),
          e.nav &&
            (this._controls.$previous.toggleClass(
              'disabled',
              !i && n <= this._core.minimum(!0)
            ),
            this._controls.$next.toggleClass(
              'disabled',
              !i && n >= this._core.maximum(!0)
            )),
          this._controls.$absolute.toggleClass('disabled', !e.dots || t),
          e.dots &&
            ((i =
              this._pages.length - this._controls.$absolute.children().length),
            e.dotsData && 0 != i
              ? this._controls.$absolute.html(this._templates.join(''))
              : 0 < i
              ? this._controls.$absolute.append(
                  new Array(1 + i).join(this._templates[0])
                )
              : i < 0 && this._controls.$absolute.children().slice(i).remove(),
            this._controls.$absolute.find('.active').removeClass('active'),
            this._controls.$absolute
              .children()
              .eq(o.inArray(this.current(), this._pages))
              .addClass('active'));
      }),
      (t.prototype.onTrigger = function (e) {
        var t = this._core.settings;
        e.page = {
          index: o.inArray(this.current(), this._pages),
          count: this._pages.length,
          size:
            t &&
            (t.center || t.autoWidth || t.dotsData ? 1 : t.dotsEach || t.items),
        };
      }),
      (t.prototype.current = function () {
        var n = this._core.relative(this._core.current());
        return o
          .grep(
            this._pages,
            o.proxy(function (e, t) {
              return e.start <= n && e.end >= n;
            }, this)
          )
          .pop();
      }),
      (t.prototype.getPosition = function (e) {
        var t,
          n,
          i = this._core.settings;
        return (
          'page' == i.slideBy
            ? ((t = o.inArray(this.current(), this._pages)),
              (n = this._pages.length),
              e ? ++t : --t,
              (t = this._pages[((t % n) + n) % n].start))
            : ((t = this._core.relative(this._core.current())),
              (n = this._core.items().length),
              e ? (t += i.slideBy) : (t -= i.slideBy)),
          t
        );
      }),
      (t.prototype.next = function (e) {
        o.proxy(this._overrides.to, this._core)(this.getPosition(!0), e);
      }),
      (t.prototype.prev = function (e) {
        o.proxy(this._overrides.to, this._core)(this.getPosition(!1), e);
      }),
      (t.prototype.to = function (e, t, n) {
        !n && this._pages.length
          ? ((n = this._pages.length),
            o.proxy(this._overrides.to, this._core)(
              this._pages[((e % n) + n) % n].start,
              t
            ))
          : o.proxy(this._overrides.to, this._core)(e, t);
      }),
      (o.fn.owlCarousel.Constructor.Plugins.Navigation = t);
  })(window.Zepto || window.jQuery, (window, document)),
  (function (i, o) {
    'use strict';

    function t(e) {
      (this._core = e),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          'initialized.owl.carousel': i.proxy(function (e) {
            e.namespace &&
              'URLHash' === this._core.settings.startPosition &&
              i(o).trigger('hashchange.owl.navigation');
          }, this),
          'prepared.owl.carousel': i.proxy(function (e) {
            var t;
            e.namespace &&
              (t = i(e.content)
                .find('[data-hash]')
                .addBack('[data-hash]')
                .attr('data-hash')) &&
              (this._hashes[t] = e.content);
          }, this),
          'changed.owl.carousel': i.proxy(function (e) {
            var n;
            e.namespace &&
              'position' === e.property.name &&
              ((n = this._core.items(
                this._core.relative(this._core.current())
              )),
              (e = i
                .map(this._hashes, function (e, t) {
                  return e === n ? t : null;
                })
                .join())) &&
              o.location.hash.slice(1) !== e &&
              (o.location.hash = e);
          }, this),
        }),
        (this._core.options = i.extend({}, t.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        i(o).on(
          'hashchange.owl.navigation',
          i.proxy(function (e) {
            var t = o.location.hash.substring(1),
              n = this._core.$stage.children(),
              n = this._hashes[t] && n.index(this._hashes[t]);
            void 0 !== n &&
              n !== this._core.current() &&
              this._core.to(this._core.relative(n), !1, !0);
          }, this)
        );
    }
    (t.Defaults = {
      URLhashListener: !1,
    }),
      (t.prototype.destroy = function () {
        var e, t;
        for (e in (i(o).off('hashchange.owl.navigation'), this._handlers))
          this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
          'function' != typeof this[t] && (this[t] = null);
      }),
      (i.fn.owlCarousel.Constructor.Plugins.Hash = t);
  })(window.Zepto || window.jQuery, window, document),
  (function (o) {
    function t(e, n) {
      var i = !1,
        t = e.charAt(0).toUpperCase() + e.slice(1);
      return (
        o.each((e + ' ' + s.join(t + ' ') + t).split(' '), function (e, t) {
          if (void 0 !== r[t]) return (i = !n || t), !1;
        }),
        i
      );
    }

    function e(e) {
      return t(e, !0);
    }
    var r = o('<support>').get(0).style,
      s = 'Webkit Moz O ms'.split(' '),
      n = {
        transition: {
          end: {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd',
            transition: 'transitionend',
          },
        },
        animation: {
          end: {
            WebkitAnimation: 'webkitAnimationEnd',
            MozAnimation: 'animationend',
            OAnimation: 'oAnimationEnd',
            animation: 'animationend',
          },
        },
      },
      i = function () {
        return !!t('transform');
      },
      a = function () {
        return !!t('perspective');
      },
      l = function () {
        return !!t('animation');
      };
    !(function () {
      return !!t('transition');
    })() ||
      ((o.support.transition = new String(e('transition'))),
      (o.support.transition.end = n.transition.end[o.support.transition])),
      l() &&
        ((o.support.animation = new String(e('animation'))),
        (o.support.animation.end = n.animation.end[o.support.animation])),
      i() &&
        ((o.support.transform = new String(e('transform'))),
        (o.support.transform3d = a()));
  })(window.Zepto || window.jQuery, (window, document));
var Common = Common || {},
  Common = (function () {
    var t = '[data-carousel="relatedNews"]';
    return {
      init: function () {},
      events: function () {},
      loader: function (e) {
        var t = $(
          '<div id="plateso-loader" class="ajax-loader"><div><i class="fas fa-spinner fa-pulse"></i></div></div>'
        );
        e ? $('body').append(t) : $('#plateso-loader').remove();
      },
      initRelatedNewsCarousel: function () {
        var e = $(t);
        e.length &&
          e.owlCarousel({
            margin: 30,
            loop: !0,
            stagePadding: 150,
            nav: !1,
            dots: !1,
            responsiveClass: !0,
            responsive: {
              0: {
                items: 1,
                stagePadding: 70,
              },
              700: {
                items: 2,
                stagePadding: 100,
              },
              1e3: {
                items: 3,
              },
            },
          });
      },
    };
  })(),
  Quiz =
    ($(window).on('load', Common.init),
    (window.QuizCommon = Common),
    Quiz || {}),
  Quiz = (function () {
    var i = {
        curIndex: 0,
        current: 1,
        total: 0,
      },
      e = '[data-action="nextStep"]',
      t = '[data-previous-step]',
      s = '.quiz-step',
      n = '[data-quiz-amount]',
      o = '[data-quiz-progress]',
      a = '#quiz-form',
      r = {},
      l = null,
      u = 0,
      c = !1;
    return {
      init: function () {
        var e;
        $('body').hasClass('page-quiz') &&
          ((i.total = $(s).length),
          Quiz.events(),
          Quiz.detectTimezone(),
          Quiz.changeStep(0),
          (e = localStorage.getItem('userData')) &&
            ((r = JSON.parse(e)).diabetesType &&
              $(`input[name="diabetes_type"][value="${r.diabetesType}"]`).prop(
                'checked',
                !0
              ),
            r.gender &&
              $(`input[name="gender"][value="${r.gender}"]`).prop(
                'checked',
                !0
              ),
            r.mealPreference &&
              $(
                `input[name="mealPreference"][value="${r.mealPreference}"]`
              ).prop('checked', !0),
            r.allergies
              ? (r.allergies.forEach((e) =>
                  $(`input[name="allergies"][value="${e}"]`).prop('checked', !0)
                ),
                $('input[name="allergies"][value="None"]').prop('checked', !1))
              : $('input[name="allergies"][value="None"]').prop('checked', !0),
            r.activityLevel &&
              $(`input[name="activityLevel"][value="${r.activityLevel}"]`).prop(
                'checked',
                !0
              ),
            r.age &&
              $(`input[name="age"][value="${r.age}"]`).prop('checked', !0),
            r.heightUnit &&
              ($(
                `input[name="height_ft_vs_cm"][value="${r.heightUnit}"]`
              ).click(),
              'ft' === r.heightUnit
                ? ($('input[name="height_ft"]').val(r.heightFt),
                  $('input[name="height_in"]').val(r.heightIn))
                : $('input[name="height_cm"]').val(r.heightCm)),
            r.weightUnit &&
              ($(
                `input[name="weight_lb_vs_kg"][value="${r.weightUnit}"]`
              ).click(),
              ('lb' === r.weightUnit
                ? $('input[name="weight_lb"]')
                : $('input[name="weight_kg"]')
              ).val(r.weight)),
            r.targetWeightUnit) &&
            ($(
              `input[name="target_weight_lb_vs_kg"][value="${r.targetWeightUnit}"]`
            ).click(),
            ('lb' === r.targetWeightUnit
              ? $('input[name="target_weight_lb"]')
              : $('input[name="target_weight_kg"]')
            ).val(r.targetWeight)),
          localStorage.getItem('userStaticData')) &&
          false &&
          ((e = $('[data-step="target_weight"] button')).addClass(
            'submit-result'
          ),
          e.attr('type', 'submit'),
          e.attr('data-action', 'submit'),
          e.html('See My Results'),
          $('[data-step="email"] input[type="email"]').val(r.email),
          $('[data-step="email"] input[type="checkbox"]').attr(
            'checked',
            'checked'
          ),
          $('[data-step="email"] button').removeClass('submit-result'),
          (c = !0));
      },
      events: function () {
        $(document)
          .on(
            'click',
            '.quiz-step .btn-quiz-label input[type="radio"]',
            Quiz.nextStep
          )
          .on('click', t, Quiz.prevStep)
          .on('click', e, Quiz.nextStep)
          .on('submit', a, Quiz.handleSubmit)
          .on('click', 'input[name="allergies"]', Quiz.allergiesChange)
          .on('quiz-change-step', Quiz.allergiesExclude)
          .on('click', '[name="diabetes_type"]', Quiz.diabetesTypeChange);
      },
      diabetesTypeChange: function () {
        var e = $('body'),
          t = $(this);
        // (r.Diet = t.val()),
        localStorage.setItem('userData', JSON.stringify(r)),
          e.addClass('page-quiz--o-hidden'),
          $('#quiz-welcome').removeClass('d-md-flex').hide(),
          $('#quiz-wrapper').removeClass('d-none').addClass('d-md-flex');
      },
      diabetesTypeChange2: function () {
        var e = $('body'),
          t = $(this);
        // (r.Diet = type),
        localStorage.setItem('userData', JSON.stringify(r)),
          e.addClass('page-quiz--o-hidden'),
          $('#quiz-welcome').removeClass('d-md-flex').hide(),
          $('#quiz-wrapper').removeClass('d-none').addClass('d-md-flex');
      },
      setDatatype: function (type) {
        r.Diet = type;
        dataDiet = type;
        localStorage.setItem('userData', JSON.stringify(r));
      },
      unsetDataType: function () {
        localStorage.removeItem('userData');
      },
      clearPreviousResults: function () {
        localStorage.removeItem('userData'),
          localStorage.removeItem('userStaticData'),
          localStorage.removeItem('endTime');
      },
      checkMinMax: function (e) {
        e = $(s).eq(e).data('step');
        if ('target_weight' == e) {
          $('#target-weight-hint').hide();
          var t = $('input[name="weight_lb_vs_kg"]:checked').val(),
            n = parseInt($('input[name="weight_' + t + '"]').val()),
            i = $('input[name="target_weight_lb_vs_kg"]:checked').val(),
            o = parseInt($(`input[name="target_weight_${i}"]`).val()),
            r = parseInt($(`input[name="target_weight_${i}"]`).attr('min'));
          if (
            ('lb' === i
              ? 'kg' === t && (n = convertKilogramsToPounds(n).toFixed())
              : 'lb' === t && (n = convertPoundsToKilograms(n).toFixed()),
            o < r)
          )
            Quiz.showInputMessage(
              '#target-weight-hint',
              'Your target weight is not within a healthy range.<br>Our lowest recommended target weight is <b>{weight}</b>'.replace(
                '{weight}',
                r + ' ' + i
              )
            );
          else {
            if (!(n < o)) return !0;
            Quiz.showInputMessage(
              '#target-weight-hint',
              'Target weight should be lower than your current weight.'
            );
          }
          $('input[name="target_weight_' + t + '"]').focus();
        } else if ('height' === e) {
          $('#height-hint').hide();
          r = $('input[name="height_ft_vs_cm"]:checked').val();
          if ('ft' === r) {
            (i = $('input[name="height_ft"]')),
              (n = $('input[name="height_in"]'));
            if (i.val().length > parseInt(i.attr('maxlength')))
              i.val(i.val().substring(0, i.val().length - 1)), i.focus();
            else if (n.val().length > parseInt(n.attr('maxlength')))
              n.val(n.val().substring(0, n.val().length - 1)), n.focus();
            else if (parseInt(i.val()) < parseInt(i.attr('min')))
              Quiz.showInputMessage(
                '#height-hint',
                'Height should be higher than ' +
                  i.attr('min') +
                  ' ft ' +
                  n.attr('min') +
                  ' inch'
              ),
                i.focus();
            else if (parseInt(i.val()) > parseInt(i.attr('max')))
              Quiz.showInputMessage(
                '#height-hint',
                'Height should be lower than ' + i.attr('max') + ' ft 3 inches'
              ),
                i.focus();
            else {
              if (parseInt(n.val()) < parseInt(n.attr('min')))
                Quiz.showInputMessage(
                  '#height-hint',
                  'Height should be higher than ' +
                    i.attr('min') +
                    ' ft ' +
                    n.attr('min') +
                    ' inch'
                );
              else {
                if (!(parseInt(n.val()) > parseInt(n.attr('max')))) return !0;
                Quiz.showInputMessage(
                  '#height-hint',
                  'Height should be lower than ' +
                    i.attr('max') +
                    ' ft 3 inches'
                );
              }
              n.focus();
            }
          } else if ('cm' === r) {
            o = $('input[name="height_cm"]');
            if (o.val().length > o.attr('maxlength'))
              o.val(o.val().substring(0, o.val().length - 1));
            else if (parseInt(o.val()) < parseInt(o.attr('min')))
              Quiz.showInputMessage(
                '#height-hint',
                'Height should be higher than ' + o.attr('min') + ' cm'
              );
            else {
              if (!(parseInt(o.val()) > parseInt(o.attr('max')))) return !0;
              Quiz.showInputMessage(
                '#height-hint',
                'Height should be lower than ' + o.attr('max') + ' cm'
              );
            }
            o.focus();
          }
        } else if ('weight' === e) {
          $('#weight-hint').hide();
          (t = $('input[name="weight_lb_vs_kg"]:checked').val()),
            (i = $('input[name="weight_' + t + '"]')),
            (n = i.closest('.quiz-size-fields')),
            (r = i.attr('min')),
            (o = i.attr('max')),
            (e = i.attr('maxlength'));
          if (i.val().length > e)
            i.val(i.val().substring(0, i.val().length - 1));
          else if (parseInt(i.val()) < parseInt(r))
            Quiz.showInputMessage(
              '#weight-hint',
              'Weight should be higher than ' + r + ' ' + n.data('active-unit')
            );
          else {
            if (!(parseInt(i.val()) > parseInt(o))) return !0;
            Quiz.showInputMessage(
              '#weight-hint',
              'Weight should be lower than ' + o + ' ' + n.data('active-unit')
            );
          }
          $('input[name="weight_' + t + '"]').focus();
        }
        return !1;
      },
      showInputMessage: function (e, t) {
        $(e).html(t).show();
      },
      progressRender: function () {
        var e = i.curIndex + 1;
        $(n).html('<b>' + e + '</b> / ' + (i.total - 1)),
          $(o).val((e / (i.total - 1)) * 100);
      },
      nextStep: function () {
        if (i.curIndex == 7 && (emExist || vtid || emLocal)) {
          // Quiz.handleSubmit2();
          Quiz.handleSubmit();
          $('.quiz-box__header').hide();
        } else {
          i.curIndex + 1 < i.total &&
            Quiz.validateStep(i.curIndex) &&
            (Quiz.storeStepResult(), Quiz.changeStep(i.curIndex + 1));
          gCurrentStep = i.curIndex;
          tmpBack = 0;
          flag = false;
          customNextStep();
          $('.bottom-links').hide();
        }
      },
      nextStep2: function () {
        i.curIndex + 1 < i.total &&
          Quiz.validateStep(i.curIndex) &&
          (Quiz.storeStepResult(), Quiz.changeStep(i.curIndex + 1));
        gCurrentStep = i.curIndex;
        customNextStep2();
        $('.bottom-links').hide();
      },
      prevStep: function () {
        0 < i.curIndex
          ? Quiz.changeStep(i.curIndex - 1)
          : ($('body').removeClass('page-quiz--o-hidden'),
            $('#quiz-welcome').addClass('d-md-flex').removeAttr('style'),
            $('.page-quiz .quiz-welcome').css('background-image', bgImage),
            $('.bottom-links').show(),
            $('.dropdown-modal div').scrollTop(0),
            $('#quiz-wrapper').addClass('d-none').removeClass('d-md-flex'));
        gCurrentStep = i.curIndex;
        if (text == '') {
          customPrevStep();
        } else if (totalStepping == 6) {
          customPrevStep();
        }
        customNextStep();
      },
      changeStep: function (e) {
        var t = $(s).eq(e),
          n = $(s).eq(e - 1);
        (i.curIndex = e),
          $(document).trigger('quiz-change-step', {
            index: e,
            step: t.data('step'),
          }),
          $('#quiz-wrapper').removeClass('step-' + n.data('step')),
          $('#quiz-wrapper').addClass('step-' + t.data('step')),
          $(s).hide(),
          t.show(),
          Quiz.progressRender();
      },
      validateStep: function (e) {
        var t = new FormData($(a)[0]);
        switch ($(s).eq(e).data('step')) {
          case 'height':
            var n = t.get('height_ft_vs_cm'),
              i = $.trim(t.get('height_ft')),
              o = $.trim(t.get('height_in')),
              r = $.trim(t.get('height_cm'));
            return 'ft' !== n || ('' !== i && '' !== o)
              ? ('cm' !== n || '' !== r) && Quiz.checkMinMax(e)
              : !1;
          case 'weight':
            (i = t.get('weight_lb_vs_kg')),
              (o = $.trim(t.get('weight_lb'))),
              (n = $.trim(t.get('weight_kg')));
            return 'lb' === i && '' === o
              ? !1
              : ('kg' !== i || '' !== n) && Quiz.checkMinMax(e);
          case 'target_weight':
            (r = t.get('target_weight_lb_vs_kg')),
              (o = $.trim(t.get('target_weight_lb'))),
              (i = $.trim(t.get('target_weight_kg')));
            return 'lb' === r && '' === o
              ? !1
              : ('kg' !== r || '' !== i) && Quiz.checkMinMax(e);
        }
        return !0;
      },
      storeStepResult: function () {
        var i,
          e = {},
          t = localStorage.getItem('userData'),
          t = (t && (e = JSON.parse(t)), new FormData($(a)[0])),
          n =
            ((r.gender = t.get('gender') || e.gender),
            (r.mealPreference = t.get('mealPreference') || e.mealPreference),
            (r.allergies = t.getAll('allergies') || e.allergies),
            0 < r.allergies.length &&
              r.mealPreference &&
              r.mealPreference !== e.mealPreference &&
              ((r.allergies = []),
              (i = $('input[name="allergies"]')),
              Array(i.length)
                .fill(0)
                .forEach((e, t) => {
                  var n = !1;
                  'None' === $(i[t]).val() && (n = !0),
                    $(i[t]).prop('checked', n);
                })),
            (r.activityLevel = t.get('activityLevel') || e.activityLevel),
            (r.age = t.get('age') || e.age),
            t.get('height_ft_vs_cm') || e.heightUnit),
          n =
            ('ft' === (r.heightUnit = n)
              ? ((r.heightFt = t.get('height_ft') || e.heightFt),
                (r.heightIn = t.get('height_in') || e.heightIn))
              : (r.heightCm = t.get('height_cm') || e.heightCm),
            t.get('weight_lb_vs_kg') || e.weightUnit),
          n =
            ((r.weightUnit = n),
            (r.weight =
              'lb' === n
                ? t.get('weight_lb') || e.weight
                : t.get('weight_kg') || e.weight),
            t.get('weight_lb_vs_kg') || e.targetWeightUnit);
        (n =
          ((r.targetWeightUnit = n),
          (r.targetWeight =
            'lb' === n
              ? t.get('target_weight_lb') || e.weight
              : t.get('target_weight_kg') || e.weight),
          (t.target_weight_kg = null),
          t.get('target_weight_lb_vs_kg') || e.targetWeightUnit)),
          console.log(r.targetWeight);

        localStorage.setItem('userData', JSON.stringify(r));
      },
      // handleSubmit: function (e) {

      //   e.preventDefault(), Quiz.clearPreviousResults();
      //   var e = new FormData($(a)[0]),
      //     t = {},
      //     n =
      //       (r.email || (r.email = e.get('email_address')),
      //       (t.ActivityLevel = e.get('activityLevel')),
      //       (t.Age = e.get('age')),
      //       (t.Diet = e.get('type')),
      //       (t.DislikeFoods = e.getAll('allergies').join(',')),
      //       (t.Email = e.get('email_address') || r.email),
      //       (t.Gender = e.get('gender')),
      //       (t.MealPreference = e.get('mealPreference')),
      //       e.get('height_ft_vs_cm')),
      //     n =
      //       ((t.HeightMeasure = 'ft' === n ? 'in' : n),
      //       (t.Height =
      //         'ft' === n
      //           ? 12 * parseInt('' + e.get('height_ft')) +
      //             parseInt('' + e.get('height_in'))
      //           : e.get('height_cm')),
      //       e.get('weight_lb_vs_kg')),
      //     n =
      //       ((t.CurrentWeightMeasure = n),
      //       (t.CurrentWeight =
      //         'lb' === n ? e.get('weight_lb') : e.get('weight_kg')),
      //       e.get('target_weight_lb_vs_kg'));
      //   (t.TargetWeightMeasure = n),
      //     (t.TargetWeight =
      //       'lb' === n ? e.get('target_weight_lb') : e.get('target_weight_kg'));
      //   $('#quiz-error').hide();
      //   n = $('.submit-result');

      //   n.html('Loading...'),
      //     n.prop('disabled', !0),
      //     c ||
      //       $.ajax({
      //         url: 'https://www.aweber.com/scripts/addlead.pl',
      //         method: 'POST',
      //         data: {
      //           meta_web_form_id: '1331142730',
      //           meta_split_id: '',
      //           listname: 'awlist6550153',
      //           meta_adtracking: 'Plateso_signup',
      //           meta_message: 1,
      //           meta_required: 'email',
      //           meta_tooltip: '',
      //           email: t.Email,
      //         },
      //         success: function () {},
      //         error: function () {},
      //       }),
      //     Quiz.postRequest('SendUserData', t, function (e) {
      //       'success' === e.status
      //         ? (localStorage.setItem('userData', JSON.stringify(r)),
      //           Quiz.changeStep(i.total - 1),
      //           Quiz.showCalculatingProgressBar())
      //         : alert('Something went wrong');
      //     });
      // },
      handleSubmit: async function (event) {
        if (event) event.preventDefault();
        Quiz.clearPreviousResults();
        $('#quiz-error').hide();
          
           // Function to get a cookie value by name
        function getCookie(name) {
        let cookieArr = document.cookie.split(';');
        for(let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split('=');
        if(name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
        return null;
  }

        Quiz.changeStep(i.total - 1);
        // Quiz.animateProgressBar();
        Quiz.showCalculatingProgressBar();
        const $loaderBtn = $('.submit-result');

        try {
          $loaderBtn.html('Loading...').prop('disabled', true);

          const e = new FormData($(a)[0]);
          const t = {};
          t.ActivityLevel = e.get('activityLevel');
          t.Age = e.get('age');
          t.Diet = e.get('type');
          t.DislikeFoods = e.getAll('allergies').join(',');
          t.Email = e.get('email_address') || r.email;
          t.Gender = e.get('gender');
          t.MealPreference = e.get('mealPreference');
          const heightMeasure = e.get('height_ft_vs_cm');
          t.HeightMeasure = heightMeasure === 'ft' ? 'in' : heightMeasure;
          t.Height =
            heightMeasure === 'ft'
              ? 12 * parseInt('' + e.get('height_ft')) +
                parseInt('' + e.get('height_in'))
              : e.get('height_cm');
          const weightMeasure = e.get('weight_lb_vs_kg');
          t.CurrentWeightMeasure = weightMeasure;
          t.CurrentWeight =
            weightMeasure === 'lb' ? e.get('weight_lb') : e.get('weight_kg');
          const targetWeightMeasure = e.get('target_weight_lb_vs_kg');
          t.TargetWeightMeasure = targetWeightMeasure;
          t.TargetWeight =
            targetWeightMeasure === 'lb'
              ? e.get('target_weight_lb')
              : e.get('target_weight_kg');

          const response = await Quiz.postRequestAsync('SendUserData', t);

          // if (event)
          //   $.ajax({
          //     url: 'https://www.aweber.com/scripts/addlead.pl',
          //     method: 'POST',
          //     data: {
          //       meta_web_form_id: '1331142730',
          //       meta_split_id: '',
          //       listname: 'awlist6550153',
          //       meta_adtracking: 'Plateso_signup',
          //       meta_message: 1,
          //       meta_required: 'email',
          //       meta_tooltip: '',
          //       email: t.Email,
          //       'custom vtid': response.id,
          //     },
          //     success: function () {},
          //     error: function () {},
          //   });
          if (event) {
               // Check local storage and cookies for 'v'
            let v = localStorage.getItem('v') || getCookie('v');
      
      // Choose the listname based on 'v' using if-else block
            let listname;
              if (v === '2') {
                listname = 'awlist6645539';
      //  }         else if (v === '3') {
      //          listname = 'awlistXXXXXXX';  // Replace with the actual listname for v=3
      }         else {
                listname = 'awlist6550153';  // Default case for v=1 or missing
      }
            localStorage.setItem('sendAweber', 'true');
            localStorage.setItem(
              'aweberData',
              JSON.stringify({
                meta_web_form_id: '1331142730',
                meta_split_id: '',
                listname: listname, 
                meta_adtracking: 'Plateso_signup',
                meta_message: 1,
                meta_required: 'email',
                meta_tooltip: '',
                email: t.Email,
                'custom vtid': response.id,
                'custom target_weight':
                  t.TargetWeight + ' ' + t.TargetWeightMeasure,
                'custom height': t.Height + ' ' + t.HeightMeasure,
              })
            );
          }
          if (!event) r.targetWeight = t.TargetWeight;

          localStorage.setItem('userData', JSON.stringify(r));
          // Quiz.redirectToResults();
        } catch (err) {
          console.error(err);
          alert('An error occured');
          $loaderBtn.html('I want my results').prop('disabled', false);
          Quiz.changeStep(event ? 8 : 7);
        }
      },
      handleSubmit2: function () {
        Quiz.clearPreviousResults();
        var e = new FormData($(a)[0]),
          t = {},
          n =
            (r.email || (r.email = e.get('email_address')),
            (t.ActivityLevel = e.get('activityLevel')),
            (t.Age = e.get('age')),
            (t.Diet = e.get('type')),
            (t.DislikeFoods = e.getAll('allergies').join(',')),
            (t.Email = e.get('email_address') || r.email),
            (t.Gender = e.get('gender')),
            (t.MealPreference = e.get('mealPreference')),
            e.get('height_ft_vs_cm')),
          n =
            ((t.HeightMeasure = 'ft' === n ? 'in' : n),
            (t.Height =
              'ft' === n
                ? 12 * parseInt('' + e.get('height_ft')) +
                  parseInt('' + e.get('height_in'))
                : e.get('height_cm')),
            e.get('weight_lb_vs_kg')),
          n =
            ((t.CurrentWeightMeasure = n),
            (t.CurrentWeight =
              'lb' === n ? e.get('weight_lb') : e.get('weight_kg')),
            e.get('target_weight_lb_vs_kg'));

        n =
          ((t.TargetWeightMeasure = n),
          (t.TargetWeight =
            'lb' === n ? e.get('target_weight_lb') : e.get('target_weight_kg')),
          e.get('height_ft_vs_cm'));

        // (t.TargetWeightMeasure = n),
        //   (t.TargetWeight =
        //     "lb" === n ? e.get("target_weight_lb") : e.get("target_weight_kg"));

        console.log(n);

        $('#quiz-error').hide();
        n = $('.submit-result');
        n.html('Loading...'),
          n.prop('disabled', !0),
          c || true,
          Quiz.postRequest('SendUserData', t, function (e) {
            r.targetWeight = t.TargetWeight;

            'success' === e.status
              ? (localStorage.setItem('userData', JSON.stringify(r)),
                Quiz.changeStep(i.total - 1),
                Quiz.showCalculatingProgressBar())
              : alert('Something went wrong');
          });
      },
      sendData: function (e, t, n, i) {
        t.Diet = dataDiet;
        if (vtid) {
          t.TID = vtid;
          delete t.Email;
        }
        console.log(t);
        $.ajax({
          url:
            'https://l7bfwie6f0.execute-api.us-east-1.amazonaws.com/prod/wf/' +
            e,
          method: i,
          data: t,
          success: function (response) {
            // Check if the response has a success status, contains an ID,
            // the ID does not include the word 'allready', and vtid doesn't already exist in local storage
            if (
              response.status === 'success' &&
              response.id &&
              !response.id.includes('allready') &&
              !localStorage.getItem('vtid')
            ) {
              // Store the ID in local storage and as a cookie
              localStorage.setItem('vtid', response.id);
              document.cookie = 'vtid=' + response.id + ';path=/;';
            }

            // Continue with the rest of the code
            n(response);
            QuizCommon.loader(false);
          },
        });
      },
      getRequest: function (e, t, n) {
        return this.sendData(e, t, n, 'GET');
      },
      postRequest: function (e, t, n) {
        return this.sendData(e, t, n, 'POST');
      },
      postRequestAsync: function (e, t) {
        return new Promise(function (resolve) {
          Quiz.postRequest(e, t, function (response) {
            resolve(response);
          });
        });
      },
      detectTimezone: function () {
        $.get(
          'https://api.ipgeolocation.io/ipgeo?apiKey=3b101ed1585b4c479ab7348461d98eb3',
          function (e) {
            ['.us'].includes(e.country_tld) ||
              $('input[value="kg"], input[value="cm"]').click();
          }
        );
      },
      allergiesChange: function (e) {
        'None' === e.target.value
          ? ($('input[name="allergies"]').prop('checked', !1),
            $('input[value="None"]').prop('checked', !0))
          : $('input[value="None"]').prop('checked', !1);
      },
      allergiesExclude: function (e, t) {
        var n,
          i,
          o = $(s).eq(t.index);
        'allergies' === t.step
          ? 'vegetarian' === (n = new FormData($(a)[0])).get('mealPreference')
            ? $('.vegetarian-exclude', o).hide()
            : 'vegan' === n.get('mealPreference')
            ? $('.vegetarian-exclude, .vegan-exclude', o).hide()
            : $('.vegetarian-exclude, .vegan-exclude', o).show()
          : 'email' === t.step
          ? $('.quiz-box__header').hide()
          : 'calculating' === t.step
          ? r.email && $('.quiz-box__header').hide()
          : $('.btn-group-toggle', o).length &&
            ((n = $('[type="radio"]:checked', o).val()),
            (i = $('[data-active-unit="' + n + '"]', o)),
            setTimeout(() => {
              if ($(window).width() > 600) {
                $('input[type="number"]', i).eq(0).focus();
              }
            }, 100));
      },
      showProgressBar: function () {
        Quiz.animateProgressBar();
        l = setInterval();
      },
      showCalculatingProgressBar: function () {
        Quiz.animateProgressBar(),
          (l = setInterval(Quiz.handleCalculatingProgressBarInterval, 50));
      },
      redirectToResults: function () {
        const e = location.pathname.split('/');
        location.href =
          location.origin +
          e.slice(0, e.length - 1).join('/') +
          '/quiz-result';
      },
      handleCalculatingProgressBarInterval: function () {
        var e;
        99 < u &&
          ((e = location.pathname.split('/')),
          (location.href =
            location.origin +
            e.slice(0, e.length - 1).join('/') +
            '/quiz-result'),
          l) &&
          clearInterval(l),
          Quiz.updateProgressLabel(u),
          u++;
      },
      animateProgressBar: function () {
        document.querySelectorAll('.quiz-calculating .meter').forEach((e) => {
          var t =
            e.getTotalLength() *
            ((100 - parseInt(e.parentNode.getAttribute('data-value'))) / 100);
          e.getBoundingClientRect(),
            (e.style.strokeDashoffset = Math.max(0, t));
        });
      },
      updateProgressLabel: function (t) {
        document.querySelectorAll('.quiz-calculating .meter').forEach((e) => {
          e.nextElementSibling.textContent = t + '%';
        });
      },
    };
  })(),
  QuizResult =
    ($(window).on('load', Quiz.init),
    (window.quiz = Quiz),
    (function () {
      var o = {},
        r = {},
        e = '[data-action="toggleFilter"]',
        t = '[data-action="toggleMainMenu"]',
        n = '[data-carousel="reviews"]';
      return {
        init: function () {
          var e, t, n, i;
          $('body').hasClass('page-results') &&
            ((e = localStorage.getItem('userData')),
            (t = localStorage.getItem('userStaticData')),
            (n = (i = (i = document.cookie) ? i.split(';') : null)
              ? i.find((e) => e.includes('userData='))
              : null),
            (i = i ? i.find((e) => e.includes('userStaticData=')) : null),
            !e && n && (e = n),
            (e = !t && i ? i : e) || (location.href = location.origin),
            (o = JSON.parse(e)),
            (n = generateRandom(4, 6)),
            (i = generateRandom(4, 6)),
            'lb' === o.weightUnit &&
              ((n = generateRandom(9, 13)), (i = generateRandom(9, 13))),
            QuizResult.getUserWeightDiff() < n + i &&
              (i = QuizResult.getUserWeightDiff() - n),
            QuizResult.isWeightOutRange() &&
              (n = QuizResult.getUserWeightDiff()),
            (r = {
              can_lose: n,
              can_lose_2months: i,
              success_percent: generateRandom(96, 99),
              weightLossData: QuizResult.getWeeksRandom(n),
            }),
            t
              ? (r = JSON.parse(t))
              : (localStorage.setItem('userStaticData', JSON.stringify(r)),
                (document.cookie =
                  'userData=' +
                  JSON.stringify(o) +
                  ';userStaticData=' +
                  JSON.stringify(r))),
            QuizResult.setResultsCta(),
            QuizResult.setPersonalSummary(),
            QuizResult.initReviewsCarousel());

          if (
            localStorage.getItem('sendAweber') === 'true' &&
            !!localStorage.getItem('aweberData')
          ) {
            try {
              const aweberData = JSON.parse(localStorage.getItem('aweberData'));
              const personalSummary = JSON.parse(
                localStorage.getItem('personalSummary')
              );
              const userData = JSON.parse(localStorage.getItem('userData'));
              const staticData = JSON.parse(
                localStorage.getItem('userStaticData')
              );
              const toSend = {
                ...aweberData,
                'custom diet': userData.Diet,
                'custom bmi': personalSummary.bmi,
                'custom metabolic_age': personalSummary.metabolicAge,
                'custom water_intake': personalSummary.waterIntake,
                'custom calorie_intake': personalSummary.calorieIntake,
                'custom calorie_intake_alt': personalSummary.calorieIntakeAlt,
                'custom age': userData.age,
                'custom gender': userData.gender === 'Man' ? 'male' : 'female',
                'custom weight': userData.weight + ' ' + userData.weightUnit,
                'custom activity_level': userData.activityLevel,
                'custom can_lose':
                  staticData.can_lose + ' ' + userData.weightUnit,
                'custom can_lose_2months':
                  parseInt(staticData.can_lose_2months) +
                  parseInt(staticData.can_lose) +
                  ' ' +
                  userData.weightUnit,
                'custom success_percent': staticData.success_percent,
                'custom targetDate': personalSummary.targetDate,
              };

              $.ajax({
                url: 'https://www.aweber.com/scripts/addlead.pl',
                method: 'POST',
                data: toSend,
                success: function () {},
                error: function () {},
              });

              localStorage.setItem('sendAweber', 'false');
            } catch (err) {
              console.log(err.message);
            }
          }
        },
        events: function () {
          $(document)
            .on('click', e, CrowdCommon.toggleBlogFilter)
            .on('click', t, CrowdCommon.toggleMainMenu);
        },
        isWeightOutRange: function () {
          return (
            QuizResult.getUserWeightDiff() < ('lb' === o.weightUnit ? 13 : 6)
          );
        },
        getUserWeightDiff: function () {
          return parseInt(o.weight) - parseInt(o.targetWeight);
        },
        calculateProjectedDate: function (
          initialWeight,
          canLose1stMonth,
          targetWeight,
          weightUnit
        ) {
          const weightDivider = weightUnit === 'lb' ? 8.8 : 4;

          const monthsToTarget =
            (Number(initialWeight) - Number(targetWeight) - canLose1stMonth) /
            weightDivider;

          return Math.floor(monthsToTarget) + 1;
        },
        calculateWeightProgression: function (
          currentWeight,
          targetWeight,
          months
        ) {
          if (months <= 0) {
            throw new Error('Months should be a positive integer.');
          }

          if (currentWeight <= targetWeight) {
            throw new Error(
              'Current weight should be greater than target weight.'
            );
          }

          const weightProgression = [];
          const weightLossPerMonth =
            (currentWeight - targetWeight) / (months - 1);

          for (let i = 0; i < months; i++) {
            const weight = currentWeight - i * weightLossPerMonth;
            weightProgression.push(Math.round(weight));
          }

          return weightProgression;
        },
        // setResultsCta: function () {
        //   if (o.gender == "Man") {
        //     o.gender = "Men";
        //   } else {
        //     o.gender = "Women";
        //   }
        //   var e = QuizResult.getUserWeightKg(),
        //     t =
        //       "{gender} aged {age} who weighed {weight} had a {success_percentage} success rate with our program",
        //     n = e,
        //     e =
        //       ("lb" === o.weightUnit &&
        //         (n = Math.ceil(convertKilogramsToPounds(e))),
        //       (t = (t = (t = (t = t.replace("{gender}", o.gender)).replace(
        //         "{age}",
        //         o.age
        //       )).replace("{weight}", o.weight + o.weightUnit)).replace(
        //         "{success_percentage}",
        //         r.success_percent + "%"
        //       )),
        //       $('[data-el="body_success_rate"]').html(t),
        //       new Date()),
        //     t = getMonthName(e.getMonth()) + " " + e.getFullYear(),
        //     i = [
        //       {
        //         x: e.getMonth(),
        //         y: n,
        //       },
        //     ];
        //   QuizResult.isWeightOutRange()
        //     ? (i.push({
        //         x: e.getMonth() + 1,
        //         y: n - QuizResult.getUserWeightDiff(),
        //       }),
        //       i.push({
        //         x: e.getMonth() + 2,
        //         y: parseInt(o.targetWeight),
        //       }))
        //     : (i.push({
        //         x: e.getMonth() + 1,
        //         y: n - r.can_lose,
        //       }),
        //       i.push({
        //         x: e.getMonth() + 2,
        //         y: n - r.can_lose - r.can_lose_2months,
        //       })),
        //     new Chart($("#chartCTAWeightLoss"), {
        //       type: "line",
        //       data: {
        //         labels: [
        //           getMonthName(e.getMonth()),
        //           getMonthName(e.getMonth() + 1),
        //           getMonthName(e.getMonth() + 2),
        //         ],
        //         datasets: [
        //           {
        //             label: t,
        //             data: i,
        //             borderWidth: 2,
        //             borderColor: "#1789D8",
        //             backgroundColor: "#C3E7FF",
        //             fill: !0,
        //           },
        //         ],
        //       },
        //       options: {
        //         layout: {
        //           padding: {
        //             top: 20,
        //             right: 20,
        //             bottom: 10,
        //             left: 25,
        //           },
        //         },
        //         elements: {
        //           point: {
        //             radius: 7,
        //             hoverRadius: 7,
        //             backgroundColor: "#FFF",
        //           },
        //         },
        //         maintainAspectRatio: !1,
        //         scales: {
        //           ticks: {
        //             display: !1,
        //           },
        //           x: {
        //             ticks: {
        //               font: {
        //                 size: 18,
        //               },
        //               color: "#1B3F57",
        //             },
        //           },
        //           y: {
        //             display: !1,
        //             ticks: {
        //               callback: function (e, t, n) {
        //                 return e + o.weightUnit;
        //               },
        //             },
        //           },
        //         },
        //         plugins: {
        //           legend: !1,
        //           title: {
        //             display: !0,
        //             text:
        //               Math.round(n - r.can_lose) +
        //               o.weightUnit +
        //               " by " +
        //               getMonthName(e.getMonth() + 1) +
        //               " " +
        //               e.getFullYear(),
        //             font: {
        //               size: 20,
        //             },
        //             color: "#1B3F57",
        //             padding: {
        //               top: 0,
        //               bottom: 30,
        //             },
        //           },
        //           tooltip: {
        //             enabled: !1,
        //             callbacks: {
        //               label: function (e) {
        //                 return e.formattedValue + o.weightUnit;
        //               },
        //             },
        //           },
        //           datalabels: {
        //             align: "end",
        //             anchor: "end",
        //             backgroundColor: "#1789D8",
        //             borderRadius: 4,
        //             color: "white",
        //             font: {
        //               weight: "bold",
        //             },
        //             formatter: function (e) {
        //               return e.y.toFixed() + " " + o.weightUnit;
        //             },
        //             padding: 6,
        //           },
        //         },
        //       },
        //       plugins: [ChartDataLabels],
        //     }),
        //     $("[data-can_lose]").html(
        //       "<b>" + r.can_lose + "</b> " + o.weightUnit
        //     );
        // },
        setResultsCta: function () {
          o.gender = o.gender === 'Man' ? 'Men' : 'Women';

          // console.log(o);
          const staticData = JSON.parse(localStorage.getItem('userStaticData'));
          // console.log(staticData);
          const monthsToTarget = QuizResult.calculateProjectedDate(
            o.weight,
            staticData.can_lose,
            o.targetWeight,
            o.weightUnit
          );

          const targetDate = new Date();
          targetDate.setMonth(targetDate.getMonth() + monthsToTarget);
          const targetYear = targetDate.getFullYear();

          var successRateTemplate =
            '{gender} aged {age} who weigh approx. {weight} have a {success_percentage} success rate with our program';

          var successRateMessage = successRateTemplate
            .replace('{gender}', o.gender)
            .replace('{age}', o.age)
            .replace('{weight}', o.weight + o.weightUnit)
            .replace('{success_percentage}', r.success_percent + '%');

          $('[data-el="body_success_rate"]').html(successRateMessage);

          var currentDate = new Date();

          var formattedDate =
            getMonthName(currentDate.getMonth()) +
            ' ' +
            currentDate.getFullYear();

          var chartData = [
            {
              x: currentDate.getMonth(),
              y: Number(o.weight),
            },
          ];

          const labels = [getMonthName(currentDate.getMonth())];

          // if (monthsToTarget > 1) {
          //   chartData.push({
          //     x: currentDate.getMonth(),
          //     y: Number(o.weight) - staticData.can_lose,
          //   });

          //   const nextMonth = currentDate.getMonth() + 1;
          //   nextMonth > 11
          //     ? labels.push(getMonthName(nextMonth - 12))
          //     : labels.push(getMonthName(nextMonth));
          // }

          chartData.push({
            x: currentDate.getMonth() + monthsToTarget,
            y: Number(o.targetWeight),
          });

          const targetMonth = currentDate.getMonth() + monthsToTarget;
          if (targetMonth > 11) {
            labels.push(
              getMonthName(targetMonth - 12 * Math.floor(targetMonth / 12))
            );
          } else {
            labels.push(getMonthName(targetMonth));
          }

          const randomDay = generateRandom(11, 19);

          new Chart($('#chartCTAWeightLoss'), {
            type: 'line',
            data: {
              labels,
              datasets: [
                {
                  label: formattedDate,
                  data: chartData,
                  borderWidth: 2,
                  borderColor: '#1789D8',
                  backgroundColor: '#C3E7FF',
                  fill: true,
                },
              ],
            },
            options: {
              layout: {
                padding: {
                  top: 20,
                  right: 20,
                  bottom: 10,
                  left: 25,
                },
              },
              elements: {
                point: {
                  radius: 7,
                  hoverRadius: 7,
                  backgroundColor: '#FFF',
                },
              },
              maintainAspectRatio: false,
              scales: {
                ticks: {
                  display: false,
                },
                x: {
                  ticks: {
                    font: {
                      size: 18,
                    },
                    color: '#1B3F57',
                  },
                },
                y: {
                  display: false,
                  ticks: {
                    callback: function (value, index, values) {
                      return value + o.weightUnit;
                    },
                  },
                },
              },
              plugins: {
                legend: false,
                title: {
                  display: true,
                  text: `${Number(o.targetWeight)} ${
                    o.weightUnit
                  } by ${randomDay} ${labels[labels.length - 1]} ${targetYear}`,

                  font: {
                    size: 20,
                  },
                  color: '#1B3F57',
                  padding: {
                    top: 0,
                    bottom: 30,
                  },
                },
                tooltip: {
                  enabled: false,
                  callbacks: {
                    label: function (tooltipItem) {
                      return tooltipItem.formattedValue + o.weightUnit;
                    },
                  },
                },
                datalabels: {
                  align: 'end',
                  anchor: 'end',
                  backgroundColor: '#1789D8',
                  borderRadius: 4,
                  color: 'white',
                  font: {
                    weight: 'bold',
                  },
                  formatter: function (value) {
                    return value.y.toFixed() + ' ' + o.weightUnit;
                  },
                  padding: 6,
                },
              },
            },
            plugins: [ChartDataLabels],
          });

          $('[data-can_lose]').html(
            `<strong>${r.can_lose} ${o.weightUnit}</strong>`
          );
          $('[data-can_reach').html(
            `${randomDay} ${labels[labels.length - 1]} ${targetYear}`
          );

          // localStorage.setItem(
          //   'targetDate',
          //   `${randomDay} ${labels[labels.length - 1]} ${targetYear}`
          // );
          try {
            const personalSummary = localStorage.getItem('personalSummary');
            if (!personalSummary) {
              localStorage.setItem(
                'personalSummary',
                JSON.stringify({
                  targetDate: `${randomDay} ${
                    labels[labels.length - 1]
                  } ${targetYear}`,
                })
              );
            } else {
              localStorage.setItem(
                'personalSummary',
                JSON.stringify({
                  ...JSON.parse(personalSummary),
                  targetDate: `${randomDay} ${
                    labels[labels.length - 1]
                  } ${targetYear}`,
                })
              );
            }
          } catch (err) {
            console.log(err);
          }
        },

        getUserWeightKg: function () {
          var e = parseFloat(o.weight);
          return (e =
            'lb' === o.weightUnit ? convertPoundsToKilograms(o.weight) : e);
        },
        setPersonalSummary: function () {
          const outputData = {};
          var e = QuizResult.getUserWeightKg(),
            t = o.heightCm;

          t = 'ft' === o.heightUnit ? convertFtToCm(o.heightFt, o.heightIn) : t;
          var heightM = convertCmToMeter(t);
          var calculatedBmi = e / Math.pow(heightM, 2);

          $('[data-body_mass_index]').html(calculatedBmi.toFixed(2));
          outputData.bmi = calculatedBmi.toFixed(2);

          if (calculatedBmi <= 18.49) {
            $('[data-body_mass_badge]').text('Underweight');
            $('[data-mass-index-block]').addClass('bmi-index-low');
          } else if (18.5 <= calculatedBmi && calculatedBmi <= 24.99) {
            $('[data-body_mass_badge]').text('Healthy weight');
            $('[data-mass-index-block]').addClass('bmi-index-normal');
          } else {
            if (25 <= calculatedBmi && calculatedBmi <= 29.99) {
              $('[data-body_mass_badge]').text('Pre-obesity');
            } else {
              $('[data-body_mass_badge]').text('Obese');
            }
            $('[data-mass-index-block]').addClass('bmi-index-high');
          }

          var n = 26.5;
          n = 'man' === o.gender.toLowerCase() ? 26.6 : n;
          var i = ((n - calculatedBmi) / n) * 100;
          var nText = n < calculatedBmi ? 'above' : 'below';

          $('[data-body_mass_averege_percent]').text(
            Math.round(Math.abs(i)) + '% ' + nText
          );
          $('[data-metabolic_age]').text(QuizResult.getHealthAge());
          outputData.metabolicAge = QuizResult.getHealthAge();

          var t = convertKilogramsToPounds(e) / 2;
          if ('lb' === o.weightUnit) {
            $('[data-water_intake_unit]').text('OZ');
          } else {
            $('[data-water_intake_unit]').text('Litres');
            t = convertOzToLiters(t);
          }

          $('[data-water_intake]').html(Math.round(t));
          outputData.waterIntake = Math.round(t);

          var caloriesAlt = 0;
          i =
            'very active' === o.activityLevel.toLowerCase()
              ? 10 * convertKilogramsToPounds(e)
              : 'moderately active' === o.activityLevel.toLowerCase()
              ? 9 * convertKilogramsToPounds(e)
              : 7 * convertKilogramsToPounds(e);
          caloriesAlt = i + generateRandom(60, 100);

          $('[data-calorie_intake_range]').html(
            i.toFixed() + ' - ' + caloriesAlt.toFixed()
          );
          $('[data-calorie_intake]').html(i.toFixed());
          $('[data-calorie_intake_alt]').html(caloriesAlt.toFixed());
          outputData.calorieIntake = i.toFixed();
          outputData.calorieIntakeAlt = caloriesAlt.toFixed();

          new Chart($('#chartWeightLoss'), {
            type: 'line',
            data: {
              backgroundColor: 'red',
              labels: ['W1', 'W2', 'W3', 'W4'],
              datasets: [
                {
                  data: r.weightLossData,
                  borderWidth: 2,
                  borderColor: '#B7DB58',
                },
              ],
            },
            options: {
              maintainAspectRatio: !1,
              layout: {
                backgroundColor: 'red',
                padding: {
                  top: 25,
                  right: 20,
                  bottom: 10,
                  left: 25,
                },
              },
              elements: {
                point: {
                  radius: 4,
                  hoverRadius: 4,
                  backgroundColor: '#B7DB58',
                },
              },
              scales: {
                ticks: {
                  display: !1,
                },
                x: {
                  ticks: {
                    color: '#8A96A0',
                  },
                },
                y: {
                  display: !1,
                  ticks: {
                    callback: function (e, t, n) {
                      return e + o.weightUnit;
                    },
                  },
                },
              },
              plugins: {
                legend: !1,
                tooltip: {
                  enabled: !1,
                  callbacks: {
                    label: function (e) {
                      return e.formattedValue + o.weightUnit;
                    },
                  },
                },
                datalabels: {
                  align: 'end',
                  anchor: 'end',
                  color: '#B7DB58',
                  font: {
                    weight: 'bold',
                  },
                  formatter: function (e) {
                    return e.y + ' ' + o.weightUnit;
                  },
                  padding: 6,
                },
              },
            },
            plugins: [ChartDataLabels],
          });

          try {
            const personalSummary = localStorage.getItem('personalSummary');
            if (!personalSummary) {
              localStorage.setItem(
                'personalSummary',
                JSON.stringify(outputData)
              );
            } else {
              localStorage.setItem(
                'personalSummary',
                JSON.stringify({
                  ...JSON.parse(personalSummary),
                  ...outputData,
                })
              );
            }
          } catch (err) {
            console.log(err);
          }
        },
        __getWeeksRandom: function (e) {
          e = parseInt(e);
          var t,
            n = 4,
            i = [];
          for (n--; 0 < n; )
            (t = generateRandom(1, e + 1 - n)),
              i.push({
                x: --n,
                y: (e -= t),
              });
          return (
            i.push({
              x: n,
              y: e,
            }),
            i.sort((e, t) => 0.5 - Math.random())
          );
        },
        getWeeksRandom: function (n) {
          var e, t;
          return n < 4
            ? Array(4)
                .fill(1)
                .map((e, t) => ({
                  x: t + 1,
                  y: 0 < n - t ? 1 : 0,
                }))
            : [
                {
                  x: 1,
                  y:
                    (e = Math.floor((n - 4) / 4) + 1) +
                    (0 < (t = n - 4 * e) ? t : 1 < e ? 1 : 0),
                },
                {
                  x: 2,
                  y: e + (0 < t && 1 < e ? 1 : 0),
                },
                {
                  x: 3,
                  y: e - (1 < e ? 1 : 0),
                },
                {
                  x: 4,
                  y: e,
                },
              ];
        },
        _getWeeksRandom: function (e) {
          var t = [],
            e = (((e = parseInt(e)) / 2).toFixed(), e / 4);
          return (
            t.push({
              x: 1,
              y: 1 + e,
            }),
            t.push({
              x: 2,
              y: e,
            }),
            t.push({
              x: 3,
              y: e - 1,
            }),
            t.push({
              x: 4,
              y: e,
            }),
            t
          );
        },

        getHealthAge: function () {
          var age;
          if (-1 !== o.age.indexOf('-')) {
            age =
              o.age.split('-').reduce(function (e, t) {
                return e + parseInt(t);
              }, 0) / 2;
          } else if ('string' == typeof o.age) {
            age = parseInt(o.age.replace(/[^0-9]/g, ''), 10); // Explicitly parse as integer
          }

          var bmi = parseFloat($('[data-body_mass_index]').text()); // Retrieve the pre-calculated BMI
          var health_age;

          age = Number(age); // Ensure age is treated as a number

          if (bmi < 18.5) {
            // underweight
            health_age = age + 5;
          } else if (bmi >= 18.5 && bmi < 25) {
            // normal weight
            health_age = age;
          } else if (bmi >= 25 && bmi < 30) {
            // overweight
            health_age = age + 7;
          } else if (bmi >= 30) {
            // obesity
            health_age = age + 7 + (bmi - 30);
          }

          health_age = Math.round(health_age);

          $('[data-metabolic_age]').text(health_age.toString());

          return health_age;
        },

        initReviewsCarousel: function () {
          var e = $(n);
          e.length &&
            e.owlCarousel({
              autoHeight: !0,
              margin: 20,
              responsive: {
                0: {
                  items: 1,
                  stagePadding: 40,
                  loop: !0,
                },
                600: {
                  items: 2,
                  stagePadding: 0,
                  loop: !1,
                },
                992: {
                  items: 3,
                  autoHeight: !1,
                },
                1441: {
                  items: 4,
                },
              },
            });
        },
      };
    })()),
  Payment = ($(window).on('load', QuizResult.init), Payment || {}),
  Payment = {
    init: function () {
      function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }

      function getCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length == 2) return parts.pop().split(';').shift();
      }

      function setEmailCookie(email) {
        document.cookie = 'email=' + email + ';path=/;';
      }

      function getEmailFromCookie() {
        return getCookie('email');
      }

      function appendVtidToUrl(baseUrl) {
        var vtid =
          getParameterByName('vtid') ||
          localStorage.getItem('vtid') ||
          getCookie('vtid');
        var email = getEmailFromCookie();
        if (email) {
          baseUrl += '&email=' + email;
        }
        return vtid ? baseUrl + '&vtid=' + vtid : baseUrl;
      }

      function deleteUserDataCookieAndLocalStorageIfVtidExists() {
        if (
          document.cookie
            .split(';')
            .some((item) => item.trim().startsWith('vtid='))
        ) {
          // If the vtid cookie exists, delete the userData and userStaticData cookie
          document.cookie =
            'userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/quiz;';
          document.cookie =
            'userStaticData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
          // Also, remove userData and userStaticData from local storage
          localStorage.removeItem('userData');
          localStorage.removeItem('userStaticData');
        }
      }

      if ($('body').hasClass('page-payment') || $('body').hasClass('page-choice')) {
    var vtidInUrl = getParameterByName('vtid');
    var vtidInLocalStorage = localStorage.getItem('vtid');
    var vtidInCookie = getCookie('vtid');
    var userData = localStorage.getItem('userData');
    var email = userData ? JSON.parse(userData).email : getEmailFromCookie();

    if (email) {
        setEmailCookie(email);
    }

    if (vtidInUrl || vtidInLocalStorage || vtidInCookie) {
        var baseUrls = {
            'page-payment': {
                planOne: 'https://plateso.pay.clickbank.net/?cbitems=1&cbskin=42840',
                planTwo: 'https://plateso.pay.clickbank.net/?cbitems=2&cbskin=42841',
                planThree: 'https://plateso.pay.clickbank.net/?cbitems=3&cbskin=42842'
            },
            'page-choice': {
                planOne: 'trial.html?',
                planTwo: 'https://plateso.pay.clickbank.net/?cbitems=2&cbskin=42841',
                planThree: 'https://plateso.pay.clickbank.net/?cbitems=3&cbskin=42842'
            }
        };

        var pageClass = $('body').attr('class').match(/page-(payment|choice)/)[0];
        var basePlanOneUrl = baseUrls[pageClass].planOne;
        var basePlanTwoUrl = baseUrls[pageClass].planTwo;
        var basePlanThreeUrl = baseUrls[pageClass].planThree;

        $('#plan-one').attr('href', appendVtidToUrl(basePlanOneUrl));
        $('#plan-two').attr('href', appendVtidToUrl(basePlanTwoUrl));
        $('#plan-three').attr('href', appendVtidToUrl(basePlanThreeUrl));
        
        // Your existing logic for deleting user data, cookies, etc.
        deleteUserDataCookieAndLocalStorageIfVtidExists();
    } else {
        location.href = './';
    }
}

    },
  },
  PaymentProcess =
    ($(window).on('load', Payment.init),
    (window.Common = Payment),
    PaymentProcess || {}),
  PaymentProcess = {
    init: function () {
      var e, t;
      $('body').hasClass('page-payment_process') &&
        ((e = (t = new URLSearchParams(location.search)).get('cbitems')),
        (t = t.get('email')),
        e) &&
        t &&
        PaymentProcess.sendData(
          'CreateUserProfile',
          {
            Email: t,
            MealPlan: [2, 4, 6][parseInt(e) - 1] + ' month',
            MealPlanStartDay: new Date().toISOString().split('T')[0],
          },
          (e) => {
            console.log('res: ', e);
          },
          'POST'
        );
    },
    sendData: function (e, t, n, i) {
      t.Diet = dataDiet;
      $.ajax({
        url:
          'https://l7bfwie6f0.execute-api.us-east-1.amazonaws.com/prod/wf/' + e,
        method: i,
        data: t,
        success: function (e) {
          n(e);
        },
      });
    },
  };
$(window).on('load', PaymentProcess.init),
  (window.PaymentProcess = PaymentProcess);
